/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const PostApiLeadScraperMicroserviceApiV1WorkspacesStatus = {
  WorkflowStatusUnspecified: "WORKFLOW_STATUS_UNSPECIFIED",
  WorkflowStatusDraft: "WORKFLOW_STATUS_DRAFT",
  WorkflowStatusActive: "WORKFLOW_STATUS_ACTIVE",
  WorkflowStatusPaused: "WORKFLOW_STATUS_PAUSED",
  WorkflowStatusFailed: "WORKFLOW_STATUS_FAILED",
  WorkflowStatusCompleted: "WORKFLOW_STATUS_COMPLETED",
  WorkflowStatusArchived: "WORKFLOW_STATUS_ARCHIVED",
  WorkflowStatusPendingApproval: "WORKFLOW_STATUS_PENDING_APPROVAL",
  WorkflowStatusValidating: "WORKFLOW_STATUS_VALIDATING",
  WorkflowStatusQuotaExceeded: "WORKFLOW_STATUS_QUOTA_EXCEEDED",
  WorkflowStatusWarning: "WORKFLOW_STATUS_WARNING",
} as const;
export type PostApiLeadScraperMicroserviceApiV1WorkspacesStatus = ClosedEnum<
  typeof PostApiLeadScraperMicroserviceApiV1WorkspacesStatus
>;

export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesStatus = {
  BackgroundJobStatusUnspecified: "BACKGROUND_JOB_STATUS_UNSPECIFIED",
  BackgroundJobStatusQueued: "BACKGROUND_JOB_STATUS_QUEUED",
  BackgroundJobStatusInProgress: "BACKGROUND_JOB_STATUS_IN_PROGRESS",
  BackgroundJobStatusCompleted: "BACKGROUND_JOB_STATUS_COMPLETED",
  BackgroundJobStatusFailed: "BACKGROUND_JOB_STATUS_FAILED",
  BackgroundJobStatusCancelled: "BACKGROUND_JOB_STATUS_CANCELLED",
  BackgroundJobStatusTimedOut: "BACKGROUND_JOB_STATUS_TIMED_OUT",
} as const;
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesStatus =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesStatus
  >;

export const PostApiLeadScraperMicroserviceApiV1WorkspacesLang = {
  LanguageUnspecified: "LANGUAGE_UNSPECIFIED",
  LanguageEnglish: "LANGUAGE_ENGLISH",
  LanguageSpanish: "LANGUAGE_SPANISH",
  LanguageFrench: "LANGUAGE_FRENCH",
  LanguageGerman: "LANGUAGE_GERMAN",
  LanguageItalian: "LANGUAGE_ITALIAN",
  LanguagePortuguese: "LANGUAGE_PORTUGUESE",
  LanguageDutch: "LANGUAGE_DUTCH",
  LanguageRussian: "LANGUAGE_RUSSIAN",
  LanguageChinese: "LANGUAGE_CHINESE",
  LanguageJapanese: "LANGUAGE_JAPANESE",
  LanguageKorean: "LANGUAGE_KOREAN",
  LanguageArabic: "LANGUAGE_ARABIC",
  LanguageHindi: "LANGUAGE_HINDI",
  LanguageGreek: "LANGUAGE_GREEK",
  LanguageTurkish: "LANGUAGE_TURKISH",
} as const;
export type PostApiLeadScraperMicroserviceApiV1WorkspacesLang = ClosedEnum<
  typeof PostApiLeadScraperMicroserviceApiV1WorkspacesLang
>;

export const PostApiLeadScraperMicroserviceApiV1WorkspacesDay = {
  DayOfWeekUnspecified: "DAY_OF_WEEK_UNSPECIFIED",
  DayOfWeekMonday: "DAY_OF_WEEK_MONDAY",
  DayOfWeekTuesday: "DAY_OF_WEEK_TUESDAY",
  DayOfWeekWednesday: "DAY_OF_WEEK_WEDNESDAY",
  DayOfWeekThursday: "DAY_OF_WEEK_THURSDAY",
  DayOfWeekFriday: "DAY_OF_WEEK_FRIDAY",
  DayOfWeekSaturday: "DAY_OF_WEEK_SATURDAY",
  DayOfWeekSunday: "DAY_OF_WEEK_SUNDAY",
} as const;
export type PostApiLeadScraperMicroserviceApiV1WorkspacesDay = ClosedEnum<
  typeof PostApiLeadScraperMicroserviceApiV1WorkspacesDay
>;

export type PostApiLeadScraperMicroserviceApiV1WorkspacesRegularHours = {
  id?: string | undefined;
  day?: PostApiLeadScraperMicroserviceApiV1WorkspacesDay | undefined;
  openTime?: string | undefined;
  closeTime?: string | undefined;
  closed?: boolean | undefined;
  createdAt?: Date | undefined;
  updatedAt?: Date | undefined;
  deletedAt?: Date | undefined;
};

export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesDay = {
  DayOfWeekUnspecified: "DAY_OF_WEEK_UNSPECIFIED",
  DayOfWeekMonday: "DAY_OF_WEEK_MONDAY",
  DayOfWeekTuesday: "DAY_OF_WEEK_TUESDAY",
  DayOfWeekWednesday: "DAY_OF_WEEK_WEDNESDAY",
  DayOfWeekThursday: "DAY_OF_WEEK_THURSDAY",
  DayOfWeekFriday: "DAY_OF_WEEK_FRIDAY",
  DayOfWeekSaturday: "DAY_OF_WEEK_SATURDAY",
  DayOfWeekSunday: "DAY_OF_WEEK_SUNDAY",
} as const;
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesDay =
  ClosedEnum<typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesDay>;

export type PostApiLeadScraperMicroserviceApiV1WorkspacesSpecialHours = {
  id?: string | undefined;
  day?: PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesDay | undefined;
  openTime?: string | undefined;
  closeTime?: string | undefined;
  closed?: boolean | undefined;
  createdAt?: Date | undefined;
  updatedAt?: Date | undefined;
  deletedAt?: Date | undefined;
};

export type PostApiLeadScraperMicroserviceApiV1WorkspacesReviews = {
  id?: string | undefined;
  author?: string | undefined;
  rating?: number | undefined;
  text?: string | undefined;
  time?: Date | undefined;
  language?: string | undefined;
  profilePhotoUrl?: string | undefined;
  reviewCount?: number | undefined;
  createdAt?: Date | undefined;
  updatedAt?: Date | undefined;
  deletedAt?: Date | undefined;
};

export const PostApiLeadScraperMicroserviceApiV1WorkspacesRevenueRange = {
  RevenueRangeUnspecified: "REVENUE_RANGE_UNSPECIFIED",
  RevenueRangeUnder100K: "REVENUE_RANGE_UNDER_100K",
  RevenueRange100KTo1M: "REVENUE_RANGE_100K_TO_1M",
  RevenueRange1MTo10M: "REVENUE_RANGE_1M_TO_10M",
  RevenueRange10MTo50M: "REVENUE_RANGE_10M_TO_50M",
  RevenueRangeOver50M: "REVENUE_RANGE_OVER_50M",
} as const;
export type PostApiLeadScraperMicroserviceApiV1WorkspacesRevenueRange =
  ClosedEnum<typeof PostApiLeadScraperMicroserviceApiV1WorkspacesRevenueRange>;

export const PostApiLeadScraperMicroserviceApiV1WorkspacesEmployeeBenefits = {
  EmployeeBenefitUnspecified: "EMPLOYEE_BENEFIT_UNSPECIFIED",
  EmployeeBenefitHealthInsurance: "EMPLOYEE_BENEFIT_HEALTH_INSURANCE",
  EmployeeBenefitRetirementPlan: "EMPLOYEE_BENEFIT_RETIREMENT_PLAN",
  EmployeeBenefitPaidTimeOff: "EMPLOYEE_BENEFIT_PAID_TIME_OFF",
  EmployeeBenefitRemoteWork: "EMPLOYEE_BENEFIT_REMOTE_WORK",
} as const;
export type PostApiLeadScraperMicroserviceApiV1WorkspacesEmployeeBenefits =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesEmployeeBenefits
  >;

export type PostApiLeadScraperMicroserviceApiV1WorkspacesLeads = {
  id?: string | undefined;
  name?: string | undefined;
  website?: string | undefined;
  phone?: string | undefined;
  address?: string | undefined;
  city?: string | undefined;
  state?: string | undefined;
  country?: string | undefined;
  latitude?: number | undefined;
  longitude?: number | undefined;
  googleRating?: number | undefined;
  reviewCount?: number | undefined;
  industry?: string | undefined;
  employeeCount?: number | undefined;
  estimatedRevenue?: string | undefined;
  createdAt?: Date | undefined;
  updatedAt?: Date | undefined;
  deletedAt?: Date | undefined;
  placeId?: string | undefined;
  googleMapsUrl?: string | undefined;
  businessStatus?: string | undefined;
  regularHours?:
    | Array<PostApiLeadScraperMicroserviceApiV1WorkspacesRegularHours>
    | undefined;
  specialHours?:
    | Array<PostApiLeadScraperMicroserviceApiV1WorkspacesSpecialHours>
    | undefined;
  photoReferences?: Array<string> | undefined;
  mainPhotoUrl?: string | undefined;
  reviews?:
    | Array<PostApiLeadScraperMicroserviceApiV1WorkspacesReviews>
    | undefined;
  types?: Array<string> | undefined;
  amenities?: Array<string> | undefined;
  servesVegetarianFood?: boolean | undefined;
  outdoorSeating?: boolean | undefined;
  paymentMethods?: Array<string> | undefined;
  wheelchairAccessible?: boolean | undefined;
  parkingAvailable?: boolean | undefined;
  socialMedia?: { [k: string]: string } | undefined;
  ratingCategory?: string | undefined;
  rating?: number | undefined;
  count?: number | undefined;
  lastUpdated?: Date | undefined;
  dataSourceVersion?: string | undefined;
  scrapingSessionId?: string | undefined;
  alternatePhones?: Array<string> | undefined;
  contactPersonName?: string | undefined;
  contactPersonTitle?: string | undefined;
  contactEmail?: string | undefined;
  foundedYear?: number | undefined;
  businessType?: string | undefined;
  certifications?: Array<string> | undefined;
  licenseNumber?: string | undefined;
  revenueRange?:
    | PostApiLeadScraperMicroserviceApiV1WorkspacesRevenueRange
    | undefined;
  fundingStage?: string | undefined;
  isPublicCompany?: boolean | undefined;
  websiteLoadSpeed?: number | undefined;
  hasSslCertificate?: boolean | undefined;
  cmsUsed?: string | undefined;
  ecommercePlatforms?: Array<string> | undefined;
  timezone?: string | undefined;
  neighborhood?: string | undefined;
  nearbyLandmarks?: Array<string> | undefined;
  transportationAccess?: string | undefined;
  employeeBenefits?:
    | Array<PostApiLeadScraperMicroserviceApiV1WorkspacesEmployeeBenefits>
    | undefined;
  parentCompany?: string | undefined;
  subsidiaries?: Array<string> | undefined;
  isFranchise?: boolean | undefined;
  seoKeywords?: Array<string> | undefined;
  usesGoogleAds?: boolean | undefined;
  googleMyBusinessCategory?: string | undefined;
  naicsCode?: string | undefined;
  sicCode?: string | undefined;
  unspscCode?: string | undefined;
  isGreenCertified?: boolean | undefined;
  energySources?: Array<string> | undefined;
  sustainabilityRating?: string | undefined;
  recentAnnouncements?: Array<string> | undefined;
  lastProductLaunch?: Date | undefined;
  hasLitigationHistory?: boolean | undefined;
  exportControlStatus?: string | undefined;
};

export type PostApiLeadScraperMicroserviceApiV1WorkspacesJobs = {
  id?: string | undefined;
  priority?: number | undefined;
  payloadType?: string | undefined;
  payload?: string | undefined;
  createdAt?: Date | undefined;
  status?:
    | PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesStatus
    | undefined;
  name?: string | undefined;
  keywords?: Array<string> | undefined;
  lang?: PostApiLeadScraperMicroserviceApiV1WorkspacesLang | undefined;
  zoom?: number | undefined;
  lat?: string | undefined;
  lon?: string | undefined;
  fastMode?: boolean | undefined;
  radius?: number | undefined;
  depth?: number | undefined;
  email?: boolean | undefined;
  maxTime?: number | undefined;
  proxies?: Array<string> | undefined;
  updatedAt?: Date | undefined;
  deletedAt?: Date | undefined;
  leads?: Array<PostApiLeadScraperMicroserviceApiV1WorkspacesLeads> | undefined;
  url?: string | undefined;
};

export const PostApiLeadScraperMicroserviceApiV1WorkspacesOutputFormat = {
  OutputFormatUnspecified: "OUTPUT_FORMAT_UNSPECIFIED",
  OutputFormatJson: "OUTPUT_FORMAT_JSON",
  OutputFormatCsv: "OUTPUT_FORMAT_CSV",
  OutputFormatBigquery: "OUTPUT_FORMAT_BIGQUERY",
  OutputFormatPostgres: "OUTPUT_FORMAT_POSTGRES",
} as const;
export type PostApiLeadScraperMicroserviceApiV1WorkspacesOutputFormat =
  ClosedEnum<typeof PostApiLeadScraperMicroserviceApiV1WorkspacesOutputFormat>;

export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkflows = {
  id?: string | undefined;
  name?: string | undefined;
  cronExpression?: string | undefined;
  nextRunTime?: Date | undefined;
  lastRunTime?: Date | undefined;
  status?: PostApiLeadScraperMicroserviceApiV1WorkspacesStatus | undefined;
  retryCount?: number | undefined;
  maxRetries?: number | undefined;
  alertEmails?: string | undefined;
  createdAt?: Date | undefined;
  updatedAt?: Date | undefined;
  deletedAt?: Date | undefined;
  jobs?: Array<PostApiLeadScraperMicroserviceApiV1WorkspacesJobs> | undefined;
  geoFencingRadius?: number | undefined;
  geoFencingLat?: number | undefined;
  geoFencingLon?: number | undefined;
  geoFencingZoomMin?: number | undefined;
  geoFencingZoomMax?: number | undefined;
  includeReviews?: boolean | undefined;
  includePhotos?: boolean | undefined;
  includeBusinessHours?: boolean | undefined;
  maxReviewsPerBusiness?: number | undefined;
  outputFormat?:
    | PostApiLeadScraperMicroserviceApiV1WorkspacesOutputFormat
    | undefined;
  outputDestination?: string | undefined;
  dataRetention?: string | undefined;
  anonymizePii?: boolean | undefined;
  notificationSlackChannel?: string | undefined;
  notificationEmailGroup?: string | undefined;
  notificationNotifyOnStart?: boolean | undefined;
  notificationNotifyOnComplete?: boolean | undefined;
  notificationNotifyOnFailure?: boolean | undefined;
  contentFilterAllowedCountries?: Array<string> | undefined;
  contentFilterExcludedTypes?: Array<string> | undefined;
  contentFilterMinimumRating?: number | undefined;
  contentFilterMinimumReviews?: number | undefined;
  qosMaxConcurrentRequests?: number | undefined;
  qosMaxRetries?: number | undefined;
  qosRequestTimeout?: string | undefined;
  qosEnableJavascript?: boolean | undefined;
  respectRobotsTxt?: boolean | undefined;
  acceptTermsOfService?: boolean | undefined;
  userAgent?: string | undefined;
  searchTerms?: Array<string> | undefined;
  scheduledEntryId?: string | undefined;
};

export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRequestStatus =
  {
    BackgroundJobStatusUnspecified: "BACKGROUND_JOB_STATUS_UNSPECIFIED",
    BackgroundJobStatusQueued: "BACKGROUND_JOB_STATUS_QUEUED",
    BackgroundJobStatusInProgress: "BACKGROUND_JOB_STATUS_IN_PROGRESS",
    BackgroundJobStatusCompleted: "BACKGROUND_JOB_STATUS_COMPLETED",
    BackgroundJobStatusFailed: "BACKGROUND_JOB_STATUS_FAILED",
    BackgroundJobStatusCancelled: "BACKGROUND_JOB_STATUS_CANCELLED",
    BackgroundJobStatusTimedOut: "BACKGROUND_JOB_STATUS_TIMED_OUT",
  } as const;
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRequestStatus =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRequestStatus
  >;

export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesLang = {
  LanguageUnspecified: "LANGUAGE_UNSPECIFIED",
  LanguageEnglish: "LANGUAGE_ENGLISH",
  LanguageSpanish: "LANGUAGE_SPANISH",
  LanguageFrench: "LANGUAGE_FRENCH",
  LanguageGerman: "LANGUAGE_GERMAN",
  LanguageItalian: "LANGUAGE_ITALIAN",
  LanguagePortuguese: "LANGUAGE_PORTUGUESE",
  LanguageDutch: "LANGUAGE_DUTCH",
  LanguageRussian: "LANGUAGE_RUSSIAN",
  LanguageChinese: "LANGUAGE_CHINESE",
  LanguageJapanese: "LANGUAGE_JAPANESE",
  LanguageKorean: "LANGUAGE_KOREAN",
  LanguageArabic: "LANGUAGE_ARABIC",
  LanguageHindi: "LANGUAGE_HINDI",
  LanguageGreek: "LANGUAGE_GREEK",
  LanguageTurkish: "LANGUAGE_TURKISH",
} as const;
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesLang =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesLang
  >;

export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRequestDay =
  {
    DayOfWeekUnspecified: "DAY_OF_WEEK_UNSPECIFIED",
    DayOfWeekMonday: "DAY_OF_WEEK_MONDAY",
    DayOfWeekTuesday: "DAY_OF_WEEK_TUESDAY",
    DayOfWeekWednesday: "DAY_OF_WEEK_WEDNESDAY",
    DayOfWeekThursday: "DAY_OF_WEEK_THURSDAY",
    DayOfWeekFriday: "DAY_OF_WEEK_FRIDAY",
    DayOfWeekSaturday: "DAY_OF_WEEK_SATURDAY",
    DayOfWeekSunday: "DAY_OF_WEEK_SUNDAY",
  } as const;
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRequestDay =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRequestDay
  >;

export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRegularHours =
  {
    id?: string | undefined;
    day?:
      | PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRequestDay
      | undefined;
    openTime?: string | undefined;
    closeTime?: string | undefined;
    closed?: boolean | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
  };

export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRequestRequestBodyDay =
  {
    DayOfWeekUnspecified: "DAY_OF_WEEK_UNSPECIFIED",
    DayOfWeekMonday: "DAY_OF_WEEK_MONDAY",
    DayOfWeekTuesday: "DAY_OF_WEEK_TUESDAY",
    DayOfWeekWednesday: "DAY_OF_WEEK_WEDNESDAY",
    DayOfWeekThursday: "DAY_OF_WEEK_THURSDAY",
    DayOfWeekFriday: "DAY_OF_WEEK_FRIDAY",
    DayOfWeekSaturday: "DAY_OF_WEEK_SATURDAY",
    DayOfWeekSunday: "DAY_OF_WEEK_SUNDAY",
  } as const;
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRequestRequestBodyDay =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRequestRequestBodyDay
  >;

export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesSpecialHours =
  {
    id?: string | undefined;
    day?:
      | PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRequestRequestBodyDay
      | undefined;
    openTime?: string | undefined;
    closeTime?: string | undefined;
    closed?: boolean | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
  };

export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesReviews = {
  id?: string | undefined;
  author?: string | undefined;
  rating?: number | undefined;
  text?: string | undefined;
  time?: Date | undefined;
  language?: string | undefined;
  profilePhotoUrl?: string | undefined;
  reviewCount?: number | undefined;
  createdAt?: Date | undefined;
  updatedAt?: Date | undefined;
  deletedAt?: Date | undefined;
};

export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRevenueRange =
  {
    RevenueRangeUnspecified: "REVENUE_RANGE_UNSPECIFIED",
    RevenueRangeUnder100K: "REVENUE_RANGE_UNDER_100K",
    RevenueRange100KTo1M: "REVENUE_RANGE_100K_TO_1M",
    RevenueRange1MTo10M: "REVENUE_RANGE_1M_TO_10M",
    RevenueRange10MTo50M: "REVENUE_RANGE_10M_TO_50M",
    RevenueRangeOver50M: "REVENUE_RANGE_OVER_50M",
  } as const;
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRevenueRange =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRevenueRange
  >;

export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesEmployeeBenefits =
  {
    EmployeeBenefitUnspecified: "EMPLOYEE_BENEFIT_UNSPECIFIED",
    EmployeeBenefitHealthInsurance: "EMPLOYEE_BENEFIT_HEALTH_INSURANCE",
    EmployeeBenefitRetirementPlan: "EMPLOYEE_BENEFIT_RETIREMENT_PLAN",
    EmployeeBenefitPaidTimeOff: "EMPLOYEE_BENEFIT_PAID_TIME_OFF",
    EmployeeBenefitRemoteWork: "EMPLOYEE_BENEFIT_REMOTE_WORK",
  } as const;
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesEmployeeBenefits =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesEmployeeBenefits
  >;

export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesLeads = {
  id?: string | undefined;
  name?: string | undefined;
  website?: string | undefined;
  phone?: string | undefined;
  address?: string | undefined;
  city?: string | undefined;
  state?: string | undefined;
  country?: string | undefined;
  latitude?: number | undefined;
  longitude?: number | undefined;
  googleRating?: number | undefined;
  reviewCount?: number | undefined;
  industry?: string | undefined;
  employeeCount?: number | undefined;
  estimatedRevenue?: string | undefined;
  createdAt?: Date | undefined;
  updatedAt?: Date | undefined;
  deletedAt?: Date | undefined;
  placeId?: string | undefined;
  googleMapsUrl?: string | undefined;
  businessStatus?: string | undefined;
  regularHours?:
    | Array<PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRegularHours>
    | undefined;
  specialHours?:
    | Array<PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesSpecialHours>
    | undefined;
  photoReferences?: Array<string> | undefined;
  mainPhotoUrl?: string | undefined;
  reviews?:
    | Array<PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesReviews>
    | undefined;
  types?: Array<string> | undefined;
  amenities?: Array<string> | undefined;
  servesVegetarianFood?: boolean | undefined;
  outdoorSeating?: boolean | undefined;
  paymentMethods?: Array<string> | undefined;
  wheelchairAccessible?: boolean | undefined;
  parkingAvailable?: boolean | undefined;
  socialMedia?: { [k: string]: string } | undefined;
  ratingCategory?: string | undefined;
  rating?: number | undefined;
  count?: number | undefined;
  lastUpdated?: Date | undefined;
  dataSourceVersion?: string | undefined;
  scrapingSessionId?: string | undefined;
  alternatePhones?: Array<string> | undefined;
  contactPersonName?: string | undefined;
  contactPersonTitle?: string | undefined;
  contactEmail?: string | undefined;
  foundedYear?: number | undefined;
  businessType?: string | undefined;
  certifications?: Array<string> | undefined;
  licenseNumber?: string | undefined;
  revenueRange?:
    | PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRevenueRange
    | undefined;
  fundingStage?: string | undefined;
  isPublicCompany?: boolean | undefined;
  websiteLoadSpeed?: number | undefined;
  hasSslCertificate?: boolean | undefined;
  cmsUsed?: string | undefined;
  ecommercePlatforms?: Array<string> | undefined;
  timezone?: string | undefined;
  neighborhood?: string | undefined;
  nearbyLandmarks?: Array<string> | undefined;
  transportationAccess?: string | undefined;
  employeeBenefits?:
    | Array<
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesEmployeeBenefits
    >
    | undefined;
  parentCompany?: string | undefined;
  subsidiaries?: Array<string> | undefined;
  isFranchise?: boolean | undefined;
  seoKeywords?: Array<string> | undefined;
  usesGoogleAds?: boolean | undefined;
  googleMyBusinessCategory?: string | undefined;
  naicsCode?: string | undefined;
  sicCode?: string | undefined;
  unspscCode?: string | undefined;
  isGreenCertified?: boolean | undefined;
  energySources?: Array<string> | undefined;
  sustainabilityRating?: string | undefined;
  recentAnnouncements?: Array<string> | undefined;
  lastProductLaunch?: Date | undefined;
  hasLitigationHistory?: boolean | undefined;
  exportControlStatus?: string | undefined;
};

export type PostApiLeadScraperMicroserviceApiV1WorkspacesScrapingJobs = {
  id?: string | undefined;
  priority?: number | undefined;
  payloadType?: string | undefined;
  payload?: string | undefined;
  createdAt?: Date | undefined;
  status?:
    | PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRequestStatus
    | undefined;
  name?: string | undefined;
  keywords?: Array<string> | undefined;
  lang?:
    | PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesLang
    | undefined;
  zoom?: number | undefined;
  lat?: string | undefined;
  lon?: string | undefined;
  fastMode?: boolean | undefined;
  radius?: number | undefined;
  depth?: number | undefined;
  email?: boolean | undefined;
  maxTime?: number | undefined;
  proxies?: Array<string> | undefined;
  updatedAt?: Date | undefined;
  deletedAt?: Date | undefined;
  leads?:
    | Array<PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesLeads>
    | undefined;
  url?: string | undefined;
};

export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRequestRequestBodyStatus =
  {
    StatusUnspecified: "STATUS_UNSPECIFIED",
    StatusActive: "STATUS_ACTIVE",
    StatusSuspended: "STATUS_SUSPENDED",
    StatusPendingVerification: "STATUS_PENDING_VERIFICATION",
    StatusRevoked: "STATUS_REVOKED",
    StatusExpired: "STATUS_EXPIRED",
    StatusRateLimited: "STATUS_RATE_LIMITED",
    StatusPendingReview: "STATUS_PENDING_REVIEW",
    StatusDeprecated: "STATUS_DEPRECATED",
    StatusMaintenance: "STATUS_MAINTENANCE",
  } as const;
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRequestRequestBodyStatus =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRequestRequestBodyStatus
  >;

export type PostApiLeadScraperMicroserviceApiV1WorkspacesApiKeys = {
  id?: string | undefined;
  name?: string | undefined;
  keyHash?: string | undefined;
  keyPrefix?: string | undefined;
  scopes?: Array<string> | undefined;
  allowedIps?: Array<string> | undefined;
  allowedDomains?: Array<string> | undefined;
  allowedEnvironments?: Array<string> | undefined;
  isTestKey?: boolean | undefined;
  requestsPerSecond?: number | undefined;
  requestsPerDay?: number | undefined;
  concurrentRequests?: number | undefined;
  monthlyRequestQuota?: string | undefined;
  costPerRequest?: number | undefined;
  billingTier?: string | undefined;
  totalRequests?: string | undefined;
  totalErrors?: string | undefined;
  lastUsedAt?: Date | undefined;
  averageResponseTime?: number | undefined;
  endpointUsageJson?: string | undefined;
  errorRatesJson?: string | undefined;
  recentErrors?: string | undefined;
  successfulRequestsCount?: number | undefined;
  successRate?: number | undefined;
  status?:
    | PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRequestRequestBodyStatus
    | undefined;
  createdAt?: Date | undefined;
  updatedAt?: Date | undefined;
  expiresAt?: Date | undefined;
  deletedAt?: Date | undefined;
  lastRotatedAt?: Date | undefined;
  lastSecurityReviewAt?: Date | undefined;
  requiresClientSecret?: boolean | undefined;
  clientSecretHash?: string | undefined;
  enforceHttps?: boolean | undefined;
  enforceSigning?: boolean | undefined;
  allowedSignatureAlgorithms?: Array<string> | undefined;
  enforceMutualTls?: boolean | undefined;
  clientCertificateHash?: string | undefined;
  requireRequestSigning?: boolean | undefined;
  description?: string | undefined;
  metadataJson?: string | undefined;
  tags?: Array<string> | undefined;
  apiVersion?: string | undefined;
  supportedFeatures?: Array<string> | undefined;
  documentationUrl?: string | undefined;
  supportContact?: string | undefined;
  logAllRequests?: boolean | undefined;
  lastRotationReason?: string | undefined;
  lastRotationDate?: Date | undefined;
  rotationFrequencyDays?: number | undefined;
  complianceStandards?: Array<string> | undefined;
  requiresAuditLogging?: boolean | undefined;
  dataResidency?: string | undefined;
  approvedIntegrations?: Array<string> | undefined;
  alertEmails?: Array<string> | undefined;
  webhookUrl?: string | undefined;
  alertOnQuotaThreshold?: boolean | undefined;
  quotaAlertThreshold?: number | undefined;
  alertOnErrorSpike?: boolean | undefined;
  errorAlertThreshold?: number | undefined;
  monitoringIntegrations?: Array<string> | undefined;
  encrypted?: boolean | undefined;
  dataClassification?: string | undefined;
  maxUses?: number | undefined;
  rateLimit?: number | undefined;
};

export const PostApiLeadScraperMicroserviceApiV1WorkspacesTriggerEvents = {
  TriggerEventUnspecified: "TRIGGER_EVENT_UNSPECIFIED",
  TriggerEventJobStarted: "TRIGGER_EVENT_JOB_STARTED",
  TriggerEventJobCompleted: "TRIGGER_EVENT_JOB_COMPLETED",
  TriggerEventJobFailed: "TRIGGER_EVENT_JOB_FAILED",
  TriggerEventLeadFound: "TRIGGER_EVENT_LEAD_FOUND",
  TriggerEventQuotaExceeded: "TRIGGER_EVENT_QUOTA_EXCEEDED",
  TriggerEventErrorThresholdReached: "TRIGGER_EVENT_ERROR_THRESHOLD_REACHED",
  TriggerEventRateLimitReached: "TRIGGER_EVENT_RATE_LIMIT_REACHED",
  TriggerEventDataValidationFailed: "TRIGGER_EVENT_DATA_VALIDATION_FAILED",
  TriggerEventNewProxyNeeded: "TRIGGER_EVENT_NEW_PROXY_NEEDED",
  TriggerEventScheduledMaintenance: "TRIGGER_EVENT_SCHEDULED_MAINTENANCE",
} as const;
export type PostApiLeadScraperMicroserviceApiV1WorkspacesTriggerEvents =
  ClosedEnum<typeof PostApiLeadScraperMicroserviceApiV1WorkspacesTriggerEvents>;

export const PostApiLeadScraperMicroserviceApiV1WorkspacesIncludedFields = {
  IncludedFieldUnspecified: "INCLUDED_FIELD_UNSPECIFIED",
  IncludedFieldName: "INCLUDED_FIELD_NAME",
  IncludedFieldWebsite: "INCLUDED_FIELD_WEBSITE",
  IncludedFieldPhone: "INCLUDED_FIELD_PHONE",
  IncludedFieldAddress: "INCLUDED_FIELD_ADDRESS",
  IncludedFieldLocation: "INCLUDED_FIELD_LOCATION",
  IncludedFieldCoordinates: "INCLUDED_FIELD_COORDINATES",
  IncludedFieldGoogleRating: "INCLUDED_FIELD_GOOGLE_RATING",
  IncludedFieldReviewCount: "INCLUDED_FIELD_REVIEW_COUNT",
  IncludedFieldReviews: "INCLUDED_FIELD_REVIEWS",
  IncludedFieldBusinessHours: "INCLUDED_FIELD_BUSINESS_HOURS",
  IncludedFieldBusinessStatus: "INCLUDED_FIELD_BUSINESS_STATUS",
  IncludedFieldPlaceId: "INCLUDED_FIELD_PLACE_ID",
  IncludedFieldGoogleMapsUrl: "INCLUDED_FIELD_GOOGLE_MAPS_URL",
  IncludedFieldPhotos: "INCLUDED_FIELD_PHOTOS",
  IncludedFieldMainPhoto: "INCLUDED_FIELD_MAIN_PHOTO",
  IncludedFieldBusinessTypes: "INCLUDED_FIELD_BUSINESS_TYPES",
  IncludedFieldAmenities: "INCLUDED_FIELD_AMENITIES",
  IncludedFieldPaymentMethods: "INCLUDED_FIELD_PAYMENT_METHODS",
  IncludedFieldSocialProfiles: "INCLUDED_FIELD_SOCIAL_PROFILES",
  IncludedFieldEmployeeCount: "INCLUDED_FIELD_EMPLOYEE_COUNT",
  IncludedFieldRevenueInfo: "INCLUDED_FIELD_REVENUE_INFO",
  IncludedFieldFoundedYear: "INCLUDED_FIELD_FOUNDED_YEAR",
  IncludedFieldCertifications: "INCLUDED_FIELD_CERTIFICATIONS",
  IncludedFieldNaicsCode: "INCLUDED_FIELD_NAICS_CODE",
  IncludedFieldSicCode: "INCLUDED_FIELD_SIC_CODE",
  IncludedFieldScrapingMetadata: "INCLUDED_FIELD_SCRAPING_METADATA",
  IncludedFieldComplianceInfo: "INCLUDED_FIELD_COMPLIANCE_INFO",
  IncludedFieldAlternatePhones: "INCLUDED_FIELD_ALTERNATE_PHONES",
  IncludedFieldContactPerson: "INCLUDED_FIELD_CONTACT_PERSON",
  IncludedFieldContactEmail: "INCLUDED_FIELD_CONTACT_EMAIL",
} as const;
export type PostApiLeadScraperMicroserviceApiV1WorkspacesIncludedFields =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesIncludedFields
  >;

export const PostApiLeadScraperMicroserviceApiV1WorkspacesPayloadFormat = {
  PayloadFormatUnspecified: "PAYLOAD_FORMAT_UNSPECIFIED",
  PayloadFormatJson: "PAYLOAD_FORMAT_JSON",
  PayloadFormatXml: "PAYLOAD_FORMAT_XML",
  PayloadFormatFormData: "PAYLOAD_FORMAT_FORM_DATA",
  PayloadFormatProtobuf: "PAYLOAD_FORMAT_PROTOBUF",
  PayloadFormatYaml: "PAYLOAD_FORMAT_YAML",
} as const;
export type PostApiLeadScraperMicroserviceApiV1WorkspacesPayloadFormat =
  ClosedEnum<typeof PostApiLeadScraperMicroserviceApiV1WorkspacesPayloadFormat>;

export type PostApiLeadScraperMicroserviceApiV1WorkspacesMetadata = {};

export type PostApiLeadScraperMicroserviceApiV1WorkspacesWebhooks = {
  id?: string | undefined;
  url?: string | undefined;
  authType?: string | undefined;
  authToken?: string | undefined;
  customHeaders?: { [k: string]: string } | undefined;
  maxRetries?: number | undefined;
  retryInterval?: string | undefined;
  triggerEvents?:
    | Array<PostApiLeadScraperMicroserviceApiV1WorkspacesTriggerEvents>
    | undefined;
  includedFields?:
    | Array<PostApiLeadScraperMicroserviceApiV1WorkspacesIncludedFields>
    | undefined;
  includeFullResults?: boolean | undefined;
  payloadFormat?:
    | PostApiLeadScraperMicroserviceApiV1WorkspacesPayloadFormat
    | undefined;
  verifySsl?: boolean | undefined;
  signingSecret?: string | undefined;
  rateLimit?: number | undefined;
  rateLimitInterval?: string | undefined;
  createdAt?: Date | undefined;
  updatedAt?: Date | undefined;
  lastTriggeredAt?: Date | undefined;
  successfulCalls?: number | undefined;
  failedCalls?: number | undefined;
  metadata?: PostApiLeadScraperMicroserviceApiV1WorkspacesMetadata | undefined;
  webhookName?: string | undefined;
};

export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceType = {
  WorkspaceTypeUnspecified: "WORKSPACE_TYPE_UNSPECIFIED",
  WorkspaceTypePersonal: "WORKSPACE_TYPE_PERSONAL",
  WorkspaceTypeTeam: "WORKSPACE_TYPE_TEAM",
  WorkspaceTypeEnterprise: "WORKSPACE_TYPE_ENTERPRISE",
} as const;
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceType =
  ClosedEnum<typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceType>;

export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspace = {
  id?: string | undefined;
  name?: string | undefined;
  industry?: string | undefined;
  domain?: string | undefined;
  gdprCompliant?: boolean | undefined;
  hipaaCompliant?: boolean | undefined;
  soc2Compliant?: boolean | undefined;
  storageQuota?: string | undefined;
  usedStorage?: string | undefined;
  createdAt?: Date | undefined;
  updatedAt?: Date | undefined;
  deletedAt?: Date | undefined;
  workflows?:
    | Array<PostApiLeadScraperMicroserviceApiV1WorkspacesWorkflows>
    | undefined;
  jobsRunThisMonth?: number | undefined;
  workspaceJobLimit?: number | undefined;
  dailyJobQuota?: number | undefined;
  activeScrapers?: number | undefined;
  totalLeadsCollected?: number | undefined;
  lastJobRun?: Date | undefined;
  scrapingJobs?:
    | Array<PostApiLeadScraperMicroserviceApiV1WorkspacesScrapingJobs>
    | undefined;
  apiKeys?:
    | Array<PostApiLeadScraperMicroserviceApiV1WorkspacesApiKeys>
    | undefined;
  webhooks?:
    | Array<PostApiLeadScraperMicroserviceApiV1WorkspacesWebhooks>
    | undefined;
  workspaceType?:
    | PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceType
    | undefined;
  description?: string | undefined;
  metadata?: { [k: string]: string } | undefined;
  tags?: Array<string> | undefined;
  maxTeamMembers?: number | undefined;
  currentTeamMembers?: number | undefined;
  allowGuestAccess?: boolean | undefined;
  allowedEmailDomains?: Array<string> | undefined;
  exportFormats?: Array<string> | undefined;
  exportSchedule?: string | undefined;
  exportDestinations?: Array<string> | undefined;
  exportDestinationConfig?: { [k: string]: string } | undefined;
  compressExports?: boolean | undefined;
  compressionFormat?: string | undefined;
  salesforceEnabled?: boolean | undefined;
  salesforceConfig?: string | undefined;
  hubspotEnabled?: boolean | undefined;
  hubspotConfig?: string | undefined;
  zapierEnabled?: boolean | undefined;
  zapierWebhook?: string | undefined;
  activeIntegrations?: Array<string> | undefined;
  integrationSettings?: { [k: string]: string } | undefined;
};

export type PostApiLeadScraperMicroserviceApiV1WorkspacesRequestBody = {
  workspace?:
    | PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspace
    | undefined;
  accountId?: string | undefined;
  organizationId?: string | undefined;
  tenantId?: string | undefined;
};

export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseStatus =
  {
    WorkflowStatusUnspecified: "WORKFLOW_STATUS_UNSPECIFIED",
    WorkflowStatusDraft: "WORKFLOW_STATUS_DRAFT",
    WorkflowStatusActive: "WORKFLOW_STATUS_ACTIVE",
    WorkflowStatusPaused: "WORKFLOW_STATUS_PAUSED",
    WorkflowStatusFailed: "WORKFLOW_STATUS_FAILED",
    WorkflowStatusCompleted: "WORKFLOW_STATUS_COMPLETED",
    WorkflowStatusArchived: "WORKFLOW_STATUS_ARCHIVED",
    WorkflowStatusPendingApproval: "WORKFLOW_STATUS_PENDING_APPROVAL",
    WorkflowStatusValidating: "WORKFLOW_STATUS_VALIDATING",
    WorkflowStatusQuotaExceeded: "WORKFLOW_STATUS_QUOTA_EXCEEDED",
    WorkflowStatusWarning: "WORKFLOW_STATUS_WARNING",
  } as const;
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseStatus =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseStatus
  >;

export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200ApplicationJSONResponseBodyStatus =
  {
    BackgroundJobStatusUnspecified: "BACKGROUND_JOB_STATUS_UNSPECIFIED",
    BackgroundJobStatusQueued: "BACKGROUND_JOB_STATUS_QUEUED",
    BackgroundJobStatusInProgress: "BACKGROUND_JOB_STATUS_IN_PROGRESS",
    BackgroundJobStatusCompleted: "BACKGROUND_JOB_STATUS_COMPLETED",
    BackgroundJobStatusFailed: "BACKGROUND_JOB_STATUS_FAILED",
    BackgroundJobStatusCancelled: "BACKGROUND_JOB_STATUS_CANCELLED",
    BackgroundJobStatusTimedOut: "BACKGROUND_JOB_STATUS_TIMED_OUT",
  } as const;
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200ApplicationJSONResponseBodyStatus =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200ApplicationJSONResponseBodyStatus
  >;

export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Lang =
  {
    LanguageUnspecified: "LANGUAGE_UNSPECIFIED",
    LanguageEnglish: "LANGUAGE_ENGLISH",
    LanguageSpanish: "LANGUAGE_SPANISH",
    LanguageFrench: "LANGUAGE_FRENCH",
    LanguageGerman: "LANGUAGE_GERMAN",
    LanguageItalian: "LANGUAGE_ITALIAN",
    LanguagePortuguese: "LANGUAGE_PORTUGUESE",
    LanguageDutch: "LANGUAGE_DUTCH",
    LanguageRussian: "LANGUAGE_RUSSIAN",
    LanguageChinese: "LANGUAGE_CHINESE",
    LanguageJapanese: "LANGUAGE_JAPANESE",
    LanguageKorean: "LANGUAGE_KOREAN",
    LanguageArabic: "LANGUAGE_ARABIC",
    LanguageHindi: "LANGUAGE_HINDI",
    LanguageGreek: "LANGUAGE_GREEK",
    LanguageTurkish: "LANGUAGE_TURKISH",
  } as const;
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Lang =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Lang
  >;

export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200ApplicationJSONDay =
  {
    DayOfWeekUnspecified: "DAY_OF_WEEK_UNSPECIFIED",
    DayOfWeekMonday: "DAY_OF_WEEK_MONDAY",
    DayOfWeekTuesday: "DAY_OF_WEEK_TUESDAY",
    DayOfWeekWednesday: "DAY_OF_WEEK_WEDNESDAY",
    DayOfWeekThursday: "DAY_OF_WEEK_THURSDAY",
    DayOfWeekFriday: "DAY_OF_WEEK_FRIDAY",
    DayOfWeekSaturday: "DAY_OF_WEEK_SATURDAY",
    DayOfWeekSunday: "DAY_OF_WEEK_SUNDAY",
  } as const;
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200ApplicationJSONDay =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200ApplicationJSONDay
  >;

export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200RegularHours =
  {
    id?: string | undefined;
    day?:
      | PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200ApplicationJSONDay
      | undefined;
    openTime?: string | undefined;
    closeTime?: string | undefined;
    closed?: boolean | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
  };

export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200ApplicationJSONResponseBodyDay =
  {
    DayOfWeekUnspecified: "DAY_OF_WEEK_UNSPECIFIED",
    DayOfWeekMonday: "DAY_OF_WEEK_MONDAY",
    DayOfWeekTuesday: "DAY_OF_WEEK_TUESDAY",
    DayOfWeekWednesday: "DAY_OF_WEEK_WEDNESDAY",
    DayOfWeekThursday: "DAY_OF_WEEK_THURSDAY",
    DayOfWeekFriday: "DAY_OF_WEEK_FRIDAY",
    DayOfWeekSaturday: "DAY_OF_WEEK_SATURDAY",
    DayOfWeekSunday: "DAY_OF_WEEK_SUNDAY",
  } as const;
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200ApplicationJSONResponseBodyDay =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200ApplicationJSONResponseBodyDay
  >;

export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200SpecialHours =
  {
    id?: string | undefined;
    day?:
      | PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200ApplicationJSONResponseBodyDay
      | undefined;
    openTime?: string | undefined;
    closeTime?: string | undefined;
    closed?: boolean | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
  };

export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Reviews =
  {
    id?: string | undefined;
    author?: string | undefined;
    rating?: number | undefined;
    text?: string | undefined;
    time?: Date | undefined;
    language?: string | undefined;
    profilePhotoUrl?: string | undefined;
    reviewCount?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
  };

export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200RevenueRange =
  {
    RevenueRangeUnspecified: "REVENUE_RANGE_UNSPECIFIED",
    RevenueRangeUnder100K: "REVENUE_RANGE_UNDER_100K",
    RevenueRange100KTo1M: "REVENUE_RANGE_100K_TO_1M",
    RevenueRange1MTo10M: "REVENUE_RANGE_1M_TO_10M",
    RevenueRange10MTo50M: "REVENUE_RANGE_10M_TO_50M",
    RevenueRangeOver50M: "REVENUE_RANGE_OVER_50M",
  } as const;
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200RevenueRange =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200RevenueRange
  >;

export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200EmployeeBenefits =
  {
    EmployeeBenefitUnspecified: "EMPLOYEE_BENEFIT_UNSPECIFIED",
    EmployeeBenefitHealthInsurance: "EMPLOYEE_BENEFIT_HEALTH_INSURANCE",
    EmployeeBenefitRetirementPlan: "EMPLOYEE_BENEFIT_RETIREMENT_PLAN",
    EmployeeBenefitPaidTimeOff: "EMPLOYEE_BENEFIT_PAID_TIME_OFF",
    EmployeeBenefitRemoteWork: "EMPLOYEE_BENEFIT_REMOTE_WORK",
  } as const;
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200EmployeeBenefits =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200EmployeeBenefits
  >;

export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Leads =
  {
    id?: string | undefined;
    name?: string | undefined;
    website?: string | undefined;
    phone?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    googleRating?: number | undefined;
    reviewCount?: number | undefined;
    industry?: string | undefined;
    employeeCount?: number | undefined;
    estimatedRevenue?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
    placeId?: string | undefined;
    googleMapsUrl?: string | undefined;
    businessStatus?: string | undefined;
    regularHours?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200RegularHours
      >
      | undefined;
    specialHours?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200SpecialHours
      >
      | undefined;
    photoReferences?: Array<string> | undefined;
    mainPhotoUrl?: string | undefined;
    reviews?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Reviews
      >
      | undefined;
    types?: Array<string> | undefined;
    amenities?: Array<string> | undefined;
    servesVegetarianFood?: boolean | undefined;
    outdoorSeating?: boolean | undefined;
    paymentMethods?: Array<string> | undefined;
    wheelchairAccessible?: boolean | undefined;
    parkingAvailable?: boolean | undefined;
    socialMedia?: { [k: string]: string } | undefined;
    ratingCategory?: string | undefined;
    rating?: number | undefined;
    count?: number | undefined;
    lastUpdated?: Date | undefined;
    dataSourceVersion?: string | undefined;
    scrapingSessionId?: string | undefined;
    alternatePhones?: Array<string> | undefined;
    contactPersonName?: string | undefined;
    contactPersonTitle?: string | undefined;
    contactEmail?: string | undefined;
    foundedYear?: number | undefined;
    businessType?: string | undefined;
    certifications?: Array<string> | undefined;
    licenseNumber?: string | undefined;
    revenueRange?:
      | PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200RevenueRange
      | undefined;
    fundingStage?: string | undefined;
    isPublicCompany?: boolean | undefined;
    websiteLoadSpeed?: number | undefined;
    hasSslCertificate?: boolean | undefined;
    cmsUsed?: string | undefined;
    ecommercePlatforms?: Array<string> | undefined;
    timezone?: string | undefined;
    neighborhood?: string | undefined;
    nearbyLandmarks?: Array<string> | undefined;
    transportationAccess?: string | undefined;
    employeeBenefits?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200EmployeeBenefits
      >
      | undefined;
    parentCompany?: string | undefined;
    subsidiaries?: Array<string> | undefined;
    isFranchise?: boolean | undefined;
    seoKeywords?: Array<string> | undefined;
    usesGoogleAds?: boolean | undefined;
    googleMyBusinessCategory?: string | undefined;
    naicsCode?: string | undefined;
    sicCode?: string | undefined;
    unspscCode?: string | undefined;
    isGreenCertified?: boolean | undefined;
    energySources?: Array<string> | undefined;
    sustainabilityRating?: string | undefined;
    recentAnnouncements?: Array<string> | undefined;
    lastProductLaunch?: Date | undefined;
    hasLitigationHistory?: boolean | undefined;
    exportControlStatus?: string | undefined;
  };

export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesJobs = {
  id?: string | undefined;
  priority?: number | undefined;
  payloadType?: string | undefined;
  payload?: string | undefined;
  createdAt?: Date | undefined;
  status?:
    | PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200ApplicationJSONResponseBodyStatus
    | undefined;
  name?: string | undefined;
  keywords?: Array<string> | undefined;
  lang?:
    | PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Lang
    | undefined;
  zoom?: number | undefined;
  lat?: string | undefined;
  lon?: string | undefined;
  fastMode?: boolean | undefined;
  radius?: number | undefined;
  depth?: number | undefined;
  email?: boolean | undefined;
  maxTime?: number | undefined;
  proxies?: Array<string> | undefined;
  updatedAt?: Date | undefined;
  deletedAt?: Date | undefined;
  leads?:
    | Array<
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Leads
    >
    | undefined;
  url?: string | undefined;
};

export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesOutputFormat =
  {
    OutputFormatUnspecified: "OUTPUT_FORMAT_UNSPECIFIED",
    OutputFormatJson: "OUTPUT_FORMAT_JSON",
    OutputFormatCsv: "OUTPUT_FORMAT_CSV",
    OutputFormatBigquery: "OUTPUT_FORMAT_BIGQUERY",
    OutputFormatPostgres: "OUTPUT_FORMAT_POSTGRES",
  } as const;
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesOutputFormat =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesOutputFormat
  >;

export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWorkflows = {
  id?: string | undefined;
  name?: string | undefined;
  cronExpression?: string | undefined;
  nextRunTime?: Date | undefined;
  lastRunTime?: Date | undefined;
  status?:
    | PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseStatus
    | undefined;
  retryCount?: number | undefined;
  maxRetries?: number | undefined;
  alertEmails?: string | undefined;
  createdAt?: Date | undefined;
  updatedAt?: Date | undefined;
  deletedAt?: Date | undefined;
  jobs?:
    | Array<PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesJobs>
    | undefined;
  geoFencingRadius?: number | undefined;
  geoFencingLat?: number | undefined;
  geoFencingLon?: number | undefined;
  geoFencingZoomMin?: number | undefined;
  geoFencingZoomMax?: number | undefined;
  includeReviews?: boolean | undefined;
  includePhotos?: boolean | undefined;
  includeBusinessHours?: boolean | undefined;
  maxReviewsPerBusiness?: number | undefined;
  outputFormat?:
    | PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesOutputFormat
    | undefined;
  outputDestination?: string | undefined;
  dataRetention?: string | undefined;
  anonymizePii?: boolean | undefined;
  notificationSlackChannel?: string | undefined;
  notificationEmailGroup?: string | undefined;
  notificationNotifyOnStart?: boolean | undefined;
  notificationNotifyOnComplete?: boolean | undefined;
  notificationNotifyOnFailure?: boolean | undefined;
  contentFilterAllowedCountries?: Array<string> | undefined;
  contentFilterExcludedTypes?: Array<string> | undefined;
  contentFilterMinimumRating?: number | undefined;
  contentFilterMinimumReviews?: number | undefined;
  qosMaxConcurrentRequests?: number | undefined;
  qosMaxRetries?: number | undefined;
  qosRequestTimeout?: string | undefined;
  qosEnableJavascript?: boolean | undefined;
  respectRobotsTxt?: boolean | undefined;
  acceptTermsOfService?: boolean | undefined;
  userAgent?: string | undefined;
  searchTerms?: Array<string> | undefined;
  scheduledEntryId?: string | undefined;
};

export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Status =
  {
    BackgroundJobStatusUnspecified: "BACKGROUND_JOB_STATUS_UNSPECIFIED",
    BackgroundJobStatusQueued: "BACKGROUND_JOB_STATUS_QUEUED",
    BackgroundJobStatusInProgress: "BACKGROUND_JOB_STATUS_IN_PROGRESS",
    BackgroundJobStatusCompleted: "BACKGROUND_JOB_STATUS_COMPLETED",
    BackgroundJobStatusFailed: "BACKGROUND_JOB_STATUS_FAILED",
    BackgroundJobStatusCancelled: "BACKGROUND_JOB_STATUS_CANCELLED",
    BackgroundJobStatusTimedOut: "BACKGROUND_JOB_STATUS_TIMED_OUT",
  } as const;
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Status =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Status
  >;

export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseLang =
  {
    LanguageUnspecified: "LANGUAGE_UNSPECIFIED",
    LanguageEnglish: "LANGUAGE_ENGLISH",
    LanguageSpanish: "LANGUAGE_SPANISH",
    LanguageFrench: "LANGUAGE_FRENCH",
    LanguageGerman: "LANGUAGE_GERMAN",
    LanguageItalian: "LANGUAGE_ITALIAN",
    LanguagePortuguese: "LANGUAGE_PORTUGUESE",
    LanguageDutch: "LANGUAGE_DUTCH",
    LanguageRussian: "LANGUAGE_RUSSIAN",
    LanguageChinese: "LANGUAGE_CHINESE",
    LanguageJapanese: "LANGUAGE_JAPANESE",
    LanguageKorean: "LANGUAGE_KOREAN",
    LanguageArabic: "LANGUAGE_ARABIC",
    LanguageHindi: "LANGUAGE_HINDI",
    LanguageGreek: "LANGUAGE_GREEK",
    LanguageTurkish: "LANGUAGE_TURKISH",
  } as const;
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseLang =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseLang
  >;

export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseDay =
  {
    DayOfWeekUnspecified: "DAY_OF_WEEK_UNSPECIFIED",
    DayOfWeekMonday: "DAY_OF_WEEK_MONDAY",
    DayOfWeekTuesday: "DAY_OF_WEEK_TUESDAY",
    DayOfWeekWednesday: "DAY_OF_WEEK_WEDNESDAY",
    DayOfWeekThursday: "DAY_OF_WEEK_THURSDAY",
    DayOfWeekFriday: "DAY_OF_WEEK_FRIDAY",
    DayOfWeekSaturday: "DAY_OF_WEEK_SATURDAY",
    DayOfWeekSunday: "DAY_OF_WEEK_SUNDAY",
  } as const;
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseDay =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseDay
  >;

export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseRegularHours =
  {
    id?: string | undefined;
    day?:
      | PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseDay
      | undefined;
    openTime?: string | undefined;
    closeTime?: string | undefined;
    closed?: boolean | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
  };

export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Day =
  {
    DayOfWeekUnspecified: "DAY_OF_WEEK_UNSPECIFIED",
    DayOfWeekMonday: "DAY_OF_WEEK_MONDAY",
    DayOfWeekTuesday: "DAY_OF_WEEK_TUESDAY",
    DayOfWeekWednesday: "DAY_OF_WEEK_WEDNESDAY",
    DayOfWeekThursday: "DAY_OF_WEEK_THURSDAY",
    DayOfWeekFriday: "DAY_OF_WEEK_FRIDAY",
    DayOfWeekSaturday: "DAY_OF_WEEK_SATURDAY",
    DayOfWeekSunday: "DAY_OF_WEEK_SUNDAY",
  } as const;
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Day =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Day
  >;

export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseSpecialHours =
  {
    id?: string | undefined;
    day?:
      | PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Day
      | undefined;
    openTime?: string | undefined;
    closeTime?: string | undefined;
    closed?: boolean | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
  };

export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseReviews =
  {
    id?: string | undefined;
    author?: string | undefined;
    rating?: number | undefined;
    text?: string | undefined;
    time?: Date | undefined;
    language?: string | undefined;
    profilePhotoUrl?: string | undefined;
    reviewCount?: number | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
  };

export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseRevenueRange =
  {
    RevenueRangeUnspecified: "REVENUE_RANGE_UNSPECIFIED",
    RevenueRangeUnder100K: "REVENUE_RANGE_UNDER_100K",
    RevenueRange100KTo1M: "REVENUE_RANGE_100K_TO_1M",
    RevenueRange1MTo10M: "REVENUE_RANGE_1M_TO_10M",
    RevenueRange10MTo50M: "REVENUE_RANGE_10M_TO_50M",
    RevenueRangeOver50M: "REVENUE_RANGE_OVER_50M",
  } as const;
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseRevenueRange =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseRevenueRange
  >;

export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseEmployeeBenefits =
  {
    EmployeeBenefitUnspecified: "EMPLOYEE_BENEFIT_UNSPECIFIED",
    EmployeeBenefitHealthInsurance: "EMPLOYEE_BENEFIT_HEALTH_INSURANCE",
    EmployeeBenefitRetirementPlan: "EMPLOYEE_BENEFIT_RETIREMENT_PLAN",
    EmployeeBenefitPaidTimeOff: "EMPLOYEE_BENEFIT_PAID_TIME_OFF",
    EmployeeBenefitRemoteWork: "EMPLOYEE_BENEFIT_REMOTE_WORK",
  } as const;
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseEmployeeBenefits =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseEmployeeBenefits
  >;

export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseLeads =
  {
    id?: string | undefined;
    name?: string | undefined;
    website?: string | undefined;
    phone?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    googleRating?: number | undefined;
    reviewCount?: number | undefined;
    industry?: string | undefined;
    employeeCount?: number | undefined;
    estimatedRevenue?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
    placeId?: string | undefined;
    googleMapsUrl?: string | undefined;
    businessStatus?: string | undefined;
    regularHours?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseRegularHours
      >
      | undefined;
    specialHours?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseSpecialHours
      >
      | undefined;
    photoReferences?: Array<string> | undefined;
    mainPhotoUrl?: string | undefined;
    reviews?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseReviews
      >
      | undefined;
    types?: Array<string> | undefined;
    amenities?: Array<string> | undefined;
    servesVegetarianFood?: boolean | undefined;
    outdoorSeating?: boolean | undefined;
    paymentMethods?: Array<string> | undefined;
    wheelchairAccessible?: boolean | undefined;
    parkingAvailable?: boolean | undefined;
    socialMedia?: { [k: string]: string } | undefined;
    ratingCategory?: string | undefined;
    rating?: number | undefined;
    count?: number | undefined;
    lastUpdated?: Date | undefined;
    dataSourceVersion?: string | undefined;
    scrapingSessionId?: string | undefined;
    alternatePhones?: Array<string> | undefined;
    contactPersonName?: string | undefined;
    contactPersonTitle?: string | undefined;
    contactEmail?: string | undefined;
    foundedYear?: number | undefined;
    businessType?: string | undefined;
    certifications?: Array<string> | undefined;
    licenseNumber?: string | undefined;
    revenueRange?:
      | PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseRevenueRange
      | undefined;
    fundingStage?: string | undefined;
    isPublicCompany?: boolean | undefined;
    websiteLoadSpeed?: number | undefined;
    hasSslCertificate?: boolean | undefined;
    cmsUsed?: string | undefined;
    ecommercePlatforms?: Array<string> | undefined;
    timezone?: string | undefined;
    neighborhood?: string | undefined;
    nearbyLandmarks?: Array<string> | undefined;
    transportationAccess?: string | undefined;
    employeeBenefits?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseEmployeeBenefits
      >
      | undefined;
    parentCompany?: string | undefined;
    subsidiaries?: Array<string> | undefined;
    isFranchise?: boolean | undefined;
    seoKeywords?: Array<string> | undefined;
    usesGoogleAds?: boolean | undefined;
    googleMyBusinessCategory?: string | undefined;
    naicsCode?: string | undefined;
    sicCode?: string | undefined;
    unspscCode?: string | undefined;
    isGreenCertified?: boolean | undefined;
    energySources?: Array<string> | undefined;
    sustainabilityRating?: string | undefined;
    recentAnnouncements?: Array<string> | undefined;
    lastProductLaunch?: Date | undefined;
    hasLitigationHistory?: boolean | undefined;
    exportControlStatus?: string | undefined;
  };

export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesScrapingJobs =
  {
    id?: string | undefined;
    priority?: number | undefined;
    payloadType?: string | undefined;
    payload?: string | undefined;
    createdAt?: Date | undefined;
    status?:
      | PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Status
      | undefined;
    name?: string | undefined;
    keywords?: Array<string> | undefined;
    lang?:
      | PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseLang
      | undefined;
    zoom?: number | undefined;
    lat?: string | undefined;
    lon?: string | undefined;
    fastMode?: boolean | undefined;
    radius?: number | undefined;
    depth?: number | undefined;
    email?: boolean | undefined;
    maxTime?: number | undefined;
    proxies?: Array<string> | undefined;
    updatedAt?: Date | undefined;
    deletedAt?: Date | undefined;
    leads?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseLeads
      >
      | undefined;
    url?: string | undefined;
  };

export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200ApplicationJSONStatus =
  {
    StatusUnspecified: "STATUS_UNSPECIFIED",
    StatusActive: "STATUS_ACTIVE",
    StatusSuspended: "STATUS_SUSPENDED",
    StatusPendingVerification: "STATUS_PENDING_VERIFICATION",
    StatusRevoked: "STATUS_REVOKED",
    StatusExpired: "STATUS_EXPIRED",
    StatusRateLimited: "STATUS_RATE_LIMITED",
    StatusPendingReview: "STATUS_PENDING_REVIEW",
    StatusDeprecated: "STATUS_DEPRECATED",
    StatusMaintenance: "STATUS_MAINTENANCE",
  } as const;
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200ApplicationJSONStatus =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200ApplicationJSONStatus
  >;

export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesApiKeys = {
  id?: string | undefined;
  name?: string | undefined;
  keyHash?: string | undefined;
  keyPrefix?: string | undefined;
  scopes?: Array<string> | undefined;
  allowedIps?: Array<string> | undefined;
  allowedDomains?: Array<string> | undefined;
  allowedEnvironments?: Array<string> | undefined;
  isTestKey?: boolean | undefined;
  requestsPerSecond?: number | undefined;
  requestsPerDay?: number | undefined;
  concurrentRequests?: number | undefined;
  monthlyRequestQuota?: string | undefined;
  costPerRequest?: number | undefined;
  billingTier?: string | undefined;
  totalRequests?: string | undefined;
  totalErrors?: string | undefined;
  lastUsedAt?: Date | undefined;
  averageResponseTime?: number | undefined;
  endpointUsageJson?: string | undefined;
  errorRatesJson?: string | undefined;
  recentErrors?: string | undefined;
  successfulRequestsCount?: number | undefined;
  successRate?: number | undefined;
  status?:
    | PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200ApplicationJSONStatus
    | undefined;
  createdAt?: Date | undefined;
  updatedAt?: Date | undefined;
  expiresAt?: Date | undefined;
  deletedAt?: Date | undefined;
  lastRotatedAt?: Date | undefined;
  lastSecurityReviewAt?: Date | undefined;
  requiresClientSecret?: boolean | undefined;
  clientSecretHash?: string | undefined;
  enforceHttps?: boolean | undefined;
  enforceSigning?: boolean | undefined;
  allowedSignatureAlgorithms?: Array<string> | undefined;
  enforceMutualTls?: boolean | undefined;
  clientCertificateHash?: string | undefined;
  requireRequestSigning?: boolean | undefined;
  description?: string | undefined;
  metadataJson?: string | undefined;
  tags?: Array<string> | undefined;
  apiVersion?: string | undefined;
  supportedFeatures?: Array<string> | undefined;
  documentationUrl?: string | undefined;
  supportContact?: string | undefined;
  logAllRequests?: boolean | undefined;
  lastRotationReason?: string | undefined;
  lastRotationDate?: Date | undefined;
  rotationFrequencyDays?: number | undefined;
  complianceStandards?: Array<string> | undefined;
  requiresAuditLogging?: boolean | undefined;
  dataResidency?: string | undefined;
  approvedIntegrations?: Array<string> | undefined;
  alertEmails?: Array<string> | undefined;
  webhookUrl?: string | undefined;
  alertOnQuotaThreshold?: boolean | undefined;
  quotaAlertThreshold?: number | undefined;
  alertOnErrorSpike?: boolean | undefined;
  errorAlertThreshold?: number | undefined;
  monitoringIntegrations?: Array<string> | undefined;
  encrypted?: boolean | undefined;
  dataClassification?: string | undefined;
  maxUses?: number | undefined;
  rateLimit?: number | undefined;
};

export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesTriggerEvents =
  {
    TriggerEventUnspecified: "TRIGGER_EVENT_UNSPECIFIED",
    TriggerEventJobStarted: "TRIGGER_EVENT_JOB_STARTED",
    TriggerEventJobCompleted: "TRIGGER_EVENT_JOB_COMPLETED",
    TriggerEventJobFailed: "TRIGGER_EVENT_JOB_FAILED",
    TriggerEventLeadFound: "TRIGGER_EVENT_LEAD_FOUND",
    TriggerEventQuotaExceeded: "TRIGGER_EVENT_QUOTA_EXCEEDED",
    TriggerEventErrorThresholdReached: "TRIGGER_EVENT_ERROR_THRESHOLD_REACHED",
    TriggerEventRateLimitReached: "TRIGGER_EVENT_RATE_LIMIT_REACHED",
    TriggerEventDataValidationFailed: "TRIGGER_EVENT_DATA_VALIDATION_FAILED",
    TriggerEventNewProxyNeeded: "TRIGGER_EVENT_NEW_PROXY_NEEDED",
    TriggerEventScheduledMaintenance: "TRIGGER_EVENT_SCHEDULED_MAINTENANCE",
  } as const;
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesTriggerEvents =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesTriggerEvents
  >;

export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesIncludedFields =
  {
    IncludedFieldUnspecified: "INCLUDED_FIELD_UNSPECIFIED",
    IncludedFieldName: "INCLUDED_FIELD_NAME",
    IncludedFieldWebsite: "INCLUDED_FIELD_WEBSITE",
    IncludedFieldPhone: "INCLUDED_FIELD_PHONE",
    IncludedFieldAddress: "INCLUDED_FIELD_ADDRESS",
    IncludedFieldLocation: "INCLUDED_FIELD_LOCATION",
    IncludedFieldCoordinates: "INCLUDED_FIELD_COORDINATES",
    IncludedFieldGoogleRating: "INCLUDED_FIELD_GOOGLE_RATING",
    IncludedFieldReviewCount: "INCLUDED_FIELD_REVIEW_COUNT",
    IncludedFieldReviews: "INCLUDED_FIELD_REVIEWS",
    IncludedFieldBusinessHours: "INCLUDED_FIELD_BUSINESS_HOURS",
    IncludedFieldBusinessStatus: "INCLUDED_FIELD_BUSINESS_STATUS",
    IncludedFieldPlaceId: "INCLUDED_FIELD_PLACE_ID",
    IncludedFieldGoogleMapsUrl: "INCLUDED_FIELD_GOOGLE_MAPS_URL",
    IncludedFieldPhotos: "INCLUDED_FIELD_PHOTOS",
    IncludedFieldMainPhoto: "INCLUDED_FIELD_MAIN_PHOTO",
    IncludedFieldBusinessTypes: "INCLUDED_FIELD_BUSINESS_TYPES",
    IncludedFieldAmenities: "INCLUDED_FIELD_AMENITIES",
    IncludedFieldPaymentMethods: "INCLUDED_FIELD_PAYMENT_METHODS",
    IncludedFieldSocialProfiles: "INCLUDED_FIELD_SOCIAL_PROFILES",
    IncludedFieldEmployeeCount: "INCLUDED_FIELD_EMPLOYEE_COUNT",
    IncludedFieldRevenueInfo: "INCLUDED_FIELD_REVENUE_INFO",
    IncludedFieldFoundedYear: "INCLUDED_FIELD_FOUNDED_YEAR",
    IncludedFieldCertifications: "INCLUDED_FIELD_CERTIFICATIONS",
    IncludedFieldNaicsCode: "INCLUDED_FIELD_NAICS_CODE",
    IncludedFieldSicCode: "INCLUDED_FIELD_SIC_CODE",
    IncludedFieldScrapingMetadata: "INCLUDED_FIELD_SCRAPING_METADATA",
    IncludedFieldComplianceInfo: "INCLUDED_FIELD_COMPLIANCE_INFO",
    IncludedFieldAlternatePhones: "INCLUDED_FIELD_ALTERNATE_PHONES",
    IncludedFieldContactPerson: "INCLUDED_FIELD_CONTACT_PERSON",
    IncludedFieldContactEmail: "INCLUDED_FIELD_CONTACT_EMAIL",
  } as const;
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesIncludedFields =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesIncludedFields
  >;

export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesPayloadFormat =
  {
    PayloadFormatUnspecified: "PAYLOAD_FORMAT_UNSPECIFIED",
    PayloadFormatJson: "PAYLOAD_FORMAT_JSON",
    PayloadFormatXml: "PAYLOAD_FORMAT_XML",
    PayloadFormatFormData: "PAYLOAD_FORMAT_FORM_DATA",
    PayloadFormatProtobuf: "PAYLOAD_FORMAT_PROTOBUF",
    PayloadFormatYaml: "PAYLOAD_FORMAT_YAML",
  } as const;
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesPayloadFormat =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesPayloadFormat
  >;

export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesMetadata =
  {};

export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWebhooks = {
  id?: string | undefined;
  url?: string | undefined;
  authType?: string | undefined;
  authToken?: string | undefined;
  customHeaders?: { [k: string]: string } | undefined;
  maxRetries?: number | undefined;
  retryInterval?: string | undefined;
  triggerEvents?:
    | Array<
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesTriggerEvents
    >
    | undefined;
  includedFields?:
    | Array<
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesIncludedFields
    >
    | undefined;
  includeFullResults?: boolean | undefined;
  payloadFormat?:
    | PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesPayloadFormat
    | undefined;
  verifySsl?: boolean | undefined;
  signingSecret?: string | undefined;
  rateLimit?: number | undefined;
  rateLimitInterval?: string | undefined;
  createdAt?: Date | undefined;
  updatedAt?: Date | undefined;
  lastTriggeredAt?: Date | undefined;
  successfulCalls?: number | undefined;
  failedCalls?: number | undefined;
  metadata?:
    | PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesMetadata
    | undefined;
  webhookName?: string | undefined;
};

export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWorkspaceType =
  {
    WorkspaceTypeUnspecified: "WORKSPACE_TYPE_UNSPECIFIED",
    WorkspaceTypePersonal: "WORKSPACE_TYPE_PERSONAL",
    WorkspaceTypeTeam: "WORKSPACE_TYPE_TEAM",
    WorkspaceTypeEnterprise: "WORKSPACE_TYPE_ENTERPRISE",
  } as const;
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWorkspaceType =
  ClosedEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWorkspaceType
  >;

export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWorkspace = {
  id?: string | undefined;
  name?: string | undefined;
  industry?: string | undefined;
  domain?: string | undefined;
  gdprCompliant?: boolean | undefined;
  hipaaCompliant?: boolean | undefined;
  soc2Compliant?: boolean | undefined;
  storageQuota?: string | undefined;
  usedStorage?: string | undefined;
  createdAt?: Date | undefined;
  updatedAt?: Date | undefined;
  deletedAt?: Date | undefined;
  workflows?:
    | Array<PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWorkflows>
    | undefined;
  jobsRunThisMonth?: number | undefined;
  workspaceJobLimit?: number | undefined;
  dailyJobQuota?: number | undefined;
  activeScrapers?: number | undefined;
  totalLeadsCollected?: number | undefined;
  lastJobRun?: Date | undefined;
  scrapingJobs?:
    | Array<PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesScrapingJobs>
    | undefined;
  apiKeys?:
    | Array<PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesApiKeys>
    | undefined;
  webhooks?:
    | Array<PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWebhooks>
    | undefined;
  workspaceType?:
    | PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWorkspaceType
    | undefined;
  description?: string | undefined;
  metadata?: { [k: string]: string } | undefined;
  tags?: Array<string> | undefined;
  maxTeamMembers?: number | undefined;
  currentTeamMembers?: number | undefined;
  allowGuestAccess?: boolean | undefined;
  allowedEmailDomains?: Array<string> | undefined;
  exportFormats?: Array<string> | undefined;
  exportSchedule?: string | undefined;
  exportDestinations?: Array<string> | undefined;
  exportDestinationConfig?: { [k: string]: string } | undefined;
  compressExports?: boolean | undefined;
  compressionFormat?: string | undefined;
  salesforceEnabled?: boolean | undefined;
  salesforceConfig?: string | undefined;
  hubspotEnabled?: boolean | undefined;
  hubspotConfig?: string | undefined;
  zapierEnabled?: boolean | undefined;
  zapierWebhook?: string | undefined;
  activeIntegrations?: Array<string> | undefined;
  integrationSettings?: { [k: string]: string } | undefined;
};

/**
 * Creates a new workspace for a given account
 */
export type PostApiLeadScraperMicroserviceApiV1WorkspacesResponseBody = {
  workspace?:
    | PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWorkspace
    | undefined;
};

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesStatus$inboundSchema:
  z.ZodNativeEnum<typeof PostApiLeadScraperMicroserviceApiV1WorkspacesStatus> =
    z.nativeEnum(PostApiLeadScraperMicroserviceApiV1WorkspacesStatus);

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesStatus$outboundSchema:
  z.ZodNativeEnum<typeof PostApiLeadScraperMicroserviceApiV1WorkspacesStatus> =
    PostApiLeadScraperMicroserviceApiV1WorkspacesStatus$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesStatus$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesStatus$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesStatus$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesStatus$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesStatus$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesStatus$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesStatus
  > = z.nativeEnum(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesStatus,
  );

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesStatus$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesStatus
  > =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesStatus$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesStatus$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesStatus$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesStatus$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesStatus$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesStatus$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesLang$inboundSchema:
  z.ZodNativeEnum<typeof PostApiLeadScraperMicroserviceApiV1WorkspacesLang> = z
    .nativeEnum(PostApiLeadScraperMicroserviceApiV1WorkspacesLang);

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesLang$outboundSchema:
  z.ZodNativeEnum<typeof PostApiLeadScraperMicroserviceApiV1WorkspacesLang> =
    PostApiLeadScraperMicroserviceApiV1WorkspacesLang$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesLang$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesLang$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesLang$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesLang$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesLang$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesDay$inboundSchema:
  z.ZodNativeEnum<typeof PostApiLeadScraperMicroserviceApiV1WorkspacesDay> = z
    .nativeEnum(PostApiLeadScraperMicroserviceApiV1WorkspacesDay);

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesDay$outboundSchema:
  z.ZodNativeEnum<typeof PostApiLeadScraperMicroserviceApiV1WorkspacesDay> =
    PostApiLeadScraperMicroserviceApiV1WorkspacesDay$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesDay$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesDay$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesDay$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesDay$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesDay$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesRegularHours$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesRegularHours,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    day: PostApiLeadScraperMicroserviceApiV1WorkspacesDay$inboundSchema.default(
      "DAY_OF_WEEK_UNSPECIFIED",
    ),
    openTime: z.string().optional(),
    closeTime: z.string().optional(),
    closed: z.boolean().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1WorkspacesRegularHours$Outbound =
  {
    id?: string | undefined;
    day: string;
    openTime?: string | undefined;
    closeTime?: string | undefined;
    closed?: boolean | undefined;
    createdAt?: string | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesRegularHours$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesRegularHours$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1WorkspacesRegularHours
  > = z.object({
    id: z.string().optional(),
    day: PostApiLeadScraperMicroserviceApiV1WorkspacesDay$outboundSchema
      .default("DAY_OF_WEEK_UNSPECIFIED"),
    openTime: z.string().optional(),
    closeTime: z.string().optional(),
    closed: z.boolean().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesRegularHours$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesRegularHours$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesRegularHours$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesRegularHours$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesRegularHours$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesRegularHours$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1WorkspacesRegularHours$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesRegularHoursToJSON(
  postApiLeadScraperMicroserviceApiV1WorkspacesRegularHours:
    PostApiLeadScraperMicroserviceApiV1WorkspacesRegularHours,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1WorkspacesRegularHours$outboundSchema
      .parse(postApiLeadScraperMicroserviceApiV1WorkspacesRegularHours),
  );
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesRegularHoursFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1WorkspacesRegularHours,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1WorkspacesRegularHours$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1WorkspacesRegularHours' from JSON`,
  );
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesDay$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesDay
  > = z.nativeEnum(PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesDay);

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesDay$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesDay
  > = PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesDay$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesDay$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesDay$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesDay$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesDay$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesDay$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesSpecialHours$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesSpecialHours,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    day:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesDay$inboundSchema
        .default("DAY_OF_WEEK_UNSPECIFIED"),
    openTime: z.string().optional(),
    closeTime: z.string().optional(),
    closed: z.boolean().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1WorkspacesSpecialHours$Outbound =
  {
    id?: string | undefined;
    day: string;
    openTime?: string | undefined;
    closeTime?: string | undefined;
    closed?: boolean | undefined;
    createdAt?: string | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesSpecialHours$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesSpecialHours$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1WorkspacesSpecialHours
  > = z.object({
    id: z.string().optional(),
    day:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesDay$outboundSchema
        .default("DAY_OF_WEEK_UNSPECIFIED"),
    openTime: z.string().optional(),
    closeTime: z.string().optional(),
    closed: z.boolean().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesSpecialHours$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesSpecialHours$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesSpecialHours$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesSpecialHours$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesSpecialHours$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesSpecialHours$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1WorkspacesSpecialHours$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesSpecialHoursToJSON(
  postApiLeadScraperMicroserviceApiV1WorkspacesSpecialHours:
    PostApiLeadScraperMicroserviceApiV1WorkspacesSpecialHours,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1WorkspacesSpecialHours$outboundSchema
      .parse(postApiLeadScraperMicroserviceApiV1WorkspacesSpecialHours),
  );
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesSpecialHoursFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1WorkspacesSpecialHours,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1WorkspacesSpecialHours$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1WorkspacesSpecialHours' from JSON`,
  );
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesReviews$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesReviews,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    author: z.string().optional(),
    rating: z.number().optional(),
    text: z.string().optional(),
    time: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    language: z.string().optional(),
    profilePhotoUrl: z.string().optional(),
    reviewCount: z.number().int().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1WorkspacesReviews$Outbound = {
  id?: string | undefined;
  author?: string | undefined;
  rating?: number | undefined;
  text?: string | undefined;
  time?: string | undefined;
  language?: string | undefined;
  profilePhotoUrl?: string | undefined;
  reviewCount?: number | undefined;
  createdAt?: string | undefined;
  updatedAt?: string | undefined;
  deletedAt?: string | undefined;
};

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesReviews$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesReviews$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1WorkspacesReviews
  > = z.object({
    id: z.string().optional(),
    author: z.string().optional(),
    rating: z.number().optional(),
    text: z.string().optional(),
    time: z.date().transform(v => v.toISOString()).optional(),
    language: z.string().optional(),
    profilePhotoUrl: z.string().optional(),
    reviewCount: z.number().int().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesReviews$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesReviews$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesReviews$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesReviews$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesReviews$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesReviews$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1WorkspacesReviews$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesReviewsToJSON(
  postApiLeadScraperMicroserviceApiV1WorkspacesReviews:
    PostApiLeadScraperMicroserviceApiV1WorkspacesReviews,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1WorkspacesReviews$outboundSchema.parse(
      postApiLeadScraperMicroserviceApiV1WorkspacesReviews,
    ),
  );
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesReviewsFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1WorkspacesReviews,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1WorkspacesReviews$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1WorkspacesReviews' from JSON`,
  );
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesRevenueRange$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesRevenueRange
  > = z.nativeEnum(PostApiLeadScraperMicroserviceApiV1WorkspacesRevenueRange);

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesRevenueRange$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesRevenueRange
  > = PostApiLeadScraperMicroserviceApiV1WorkspacesRevenueRange$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesRevenueRange$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesRevenueRange$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesRevenueRange$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesRevenueRange$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesRevenueRange$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesEmployeeBenefits$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesEmployeeBenefits
  > = z.nativeEnum(
    PostApiLeadScraperMicroserviceApiV1WorkspacesEmployeeBenefits,
  );

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesEmployeeBenefits$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesEmployeeBenefits
  > =
    PostApiLeadScraperMicroserviceApiV1WorkspacesEmployeeBenefits$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesEmployeeBenefits$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesEmployeeBenefits$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesEmployeeBenefits$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesEmployeeBenefits$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesEmployeeBenefits$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesLeads$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesLeads,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    name: z.string().optional(),
    website: z.string().optional(),
    phone: z.string().optional(),
    address: z.string().optional(),
    city: z.string().optional(),
    state: z.string().optional(),
    country: z.string().optional(),
    latitude: z.number().optional(),
    longitude: z.number().optional(),
    googleRating: z.number().optional(),
    reviewCount: z.number().int().optional(),
    industry: z.string().optional(),
    employeeCount: z.number().int().optional(),
    estimatedRevenue: z.string().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    placeId: z.string().optional(),
    googleMapsUrl: z.string().optional(),
    businessStatus: z.string().optional(),
    regularHours: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1WorkspacesRegularHours$inboundSchema
      ),
    ).optional(),
    specialHours: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1WorkspacesSpecialHours$inboundSchema
      ),
    ).optional(),
    photoReferences: z.array(z.string()).optional(),
    mainPhotoUrl: z.string().optional(),
    reviews: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1WorkspacesReviews$inboundSchema
      ),
    ).optional(),
    types: z.array(z.string()).optional(),
    amenities: z.array(z.string()).optional(),
    servesVegetarianFood: z.boolean().optional(),
    outdoorSeating: z.boolean().optional(),
    paymentMethods: z.array(z.string()).optional(),
    wheelchairAccessible: z.boolean().optional(),
    parkingAvailable: z.boolean().optional(),
    socialMedia: z.record(z.string()).optional(),
    ratingCategory: z.string().optional(),
    rating: z.number().optional(),
    count: z.number().int().optional(),
    lastUpdated: z.string().datetime({ offset: true }).transform(v =>
      new Date(v)
    ).optional(),
    dataSourceVersion: z.string().optional(),
    scrapingSessionId: z.string().optional(),
    alternatePhones: z.array(z.string()).optional(),
    contactPersonName: z.string().optional(),
    contactPersonTitle: z.string().optional(),
    contactEmail: z.string().optional(),
    foundedYear: z.number().int().optional(),
    businessType: z.string().optional(),
    certifications: z.array(z.string()).optional(),
    licenseNumber: z.string().optional(),
    revenueRange:
      PostApiLeadScraperMicroserviceApiV1WorkspacesRevenueRange$inboundSchema
        .default("REVENUE_RANGE_UNSPECIFIED"),
    fundingStage: z.string().optional(),
    isPublicCompany: z.boolean().optional(),
    websiteLoadSpeed: z.number().optional(),
    hasSslCertificate: z.boolean().optional(),
    cmsUsed: z.string().optional(),
    ecommercePlatforms: z.array(z.string()).optional(),
    timezone: z.string().optional(),
    neighborhood: z.string().optional(),
    nearbyLandmarks: z.array(z.string()).optional(),
    transportationAccess: z.string().optional(),
    employeeBenefits: z.array(
      PostApiLeadScraperMicroserviceApiV1WorkspacesEmployeeBenefits$inboundSchema,
    ).optional(),
    parentCompany: z.string().optional(),
    subsidiaries: z.array(z.string()).optional(),
    isFranchise: z.boolean().optional(),
    seoKeywords: z.array(z.string()).optional(),
    usesGoogleAds: z.boolean().optional(),
    googleMyBusinessCategory: z.string().optional(),
    naicsCode: z.string().optional(),
    sicCode: z.string().optional(),
    unspscCode: z.string().optional(),
    isGreenCertified: z.boolean().optional(),
    energySources: z.array(z.string()).optional(),
    sustainabilityRating: z.string().optional(),
    recentAnnouncements: z.array(z.string()).optional(),
    lastProductLaunch: z.string().datetime({ offset: true }).transform(v =>
      new Date(v)
    ).optional(),
    hasLitigationHistory: z.boolean().optional(),
    exportControlStatus: z.string().optional(),
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1WorkspacesLeads$Outbound = {
  id?: string | undefined;
  name?: string | undefined;
  website?: string | undefined;
  phone?: string | undefined;
  address?: string | undefined;
  city?: string | undefined;
  state?: string | undefined;
  country?: string | undefined;
  latitude?: number | undefined;
  longitude?: number | undefined;
  googleRating?: number | undefined;
  reviewCount?: number | undefined;
  industry?: string | undefined;
  employeeCount?: number | undefined;
  estimatedRevenue?: string | undefined;
  createdAt?: string | undefined;
  updatedAt?: string | undefined;
  deletedAt?: string | undefined;
  placeId?: string | undefined;
  googleMapsUrl?: string | undefined;
  businessStatus?: string | undefined;
  regularHours?:
    | Array<PostApiLeadScraperMicroserviceApiV1WorkspacesRegularHours$Outbound>
    | undefined;
  specialHours?:
    | Array<PostApiLeadScraperMicroserviceApiV1WorkspacesSpecialHours$Outbound>
    | undefined;
  photoReferences?: Array<string> | undefined;
  mainPhotoUrl?: string | undefined;
  reviews?:
    | Array<PostApiLeadScraperMicroserviceApiV1WorkspacesReviews$Outbound>
    | undefined;
  types?: Array<string> | undefined;
  amenities?: Array<string> | undefined;
  servesVegetarianFood?: boolean | undefined;
  outdoorSeating?: boolean | undefined;
  paymentMethods?: Array<string> | undefined;
  wheelchairAccessible?: boolean | undefined;
  parkingAvailable?: boolean | undefined;
  socialMedia?: { [k: string]: string } | undefined;
  ratingCategory?: string | undefined;
  rating?: number | undefined;
  count?: number | undefined;
  lastUpdated?: string | undefined;
  dataSourceVersion?: string | undefined;
  scrapingSessionId?: string | undefined;
  alternatePhones?: Array<string> | undefined;
  contactPersonName?: string | undefined;
  contactPersonTitle?: string | undefined;
  contactEmail?: string | undefined;
  foundedYear?: number | undefined;
  businessType?: string | undefined;
  certifications?: Array<string> | undefined;
  licenseNumber?: string | undefined;
  revenueRange: string;
  fundingStage?: string | undefined;
  isPublicCompany?: boolean | undefined;
  websiteLoadSpeed?: number | undefined;
  hasSslCertificate?: boolean | undefined;
  cmsUsed?: string | undefined;
  ecommercePlatforms?: Array<string> | undefined;
  timezone?: string | undefined;
  neighborhood?: string | undefined;
  nearbyLandmarks?: Array<string> | undefined;
  transportationAccess?: string | undefined;
  employeeBenefits?: Array<string> | undefined;
  parentCompany?: string | undefined;
  subsidiaries?: Array<string> | undefined;
  isFranchise?: boolean | undefined;
  seoKeywords?: Array<string> | undefined;
  usesGoogleAds?: boolean | undefined;
  googleMyBusinessCategory?: string | undefined;
  naicsCode?: string | undefined;
  sicCode?: string | undefined;
  unspscCode?: string | undefined;
  isGreenCertified?: boolean | undefined;
  energySources?: Array<string> | undefined;
  sustainabilityRating?: string | undefined;
  recentAnnouncements?: Array<string> | undefined;
  lastProductLaunch?: string | undefined;
  hasLitigationHistory?: boolean | undefined;
  exportControlStatus?: string | undefined;
};

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesLeads$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesLeads$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1WorkspacesLeads
  > = z.object({
    id: z.string().optional(),
    name: z.string().optional(),
    website: z.string().optional(),
    phone: z.string().optional(),
    address: z.string().optional(),
    city: z.string().optional(),
    state: z.string().optional(),
    country: z.string().optional(),
    latitude: z.number().optional(),
    longitude: z.number().optional(),
    googleRating: z.number().optional(),
    reviewCount: z.number().int().optional(),
    industry: z.string().optional(),
    employeeCount: z.number().int().optional(),
    estimatedRevenue: z.string().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
    placeId: z.string().optional(),
    googleMapsUrl: z.string().optional(),
    businessStatus: z.string().optional(),
    regularHours: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1WorkspacesRegularHours$outboundSchema
      ),
    ).optional(),
    specialHours: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1WorkspacesSpecialHours$outboundSchema
      ),
    ).optional(),
    photoReferences: z.array(z.string()).optional(),
    mainPhotoUrl: z.string().optional(),
    reviews: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1WorkspacesReviews$outboundSchema
      ),
    ).optional(),
    types: z.array(z.string()).optional(),
    amenities: z.array(z.string()).optional(),
    servesVegetarianFood: z.boolean().optional(),
    outdoorSeating: z.boolean().optional(),
    paymentMethods: z.array(z.string()).optional(),
    wheelchairAccessible: z.boolean().optional(),
    parkingAvailable: z.boolean().optional(),
    socialMedia: z.record(z.string()).optional(),
    ratingCategory: z.string().optional(),
    rating: z.number().optional(),
    count: z.number().int().optional(),
    lastUpdated: z.date().transform(v => v.toISOString()).optional(),
    dataSourceVersion: z.string().optional(),
    scrapingSessionId: z.string().optional(),
    alternatePhones: z.array(z.string()).optional(),
    contactPersonName: z.string().optional(),
    contactPersonTitle: z.string().optional(),
    contactEmail: z.string().optional(),
    foundedYear: z.number().int().optional(),
    businessType: z.string().optional(),
    certifications: z.array(z.string()).optional(),
    licenseNumber: z.string().optional(),
    revenueRange:
      PostApiLeadScraperMicroserviceApiV1WorkspacesRevenueRange$outboundSchema
        .default("REVENUE_RANGE_UNSPECIFIED"),
    fundingStage: z.string().optional(),
    isPublicCompany: z.boolean().optional(),
    websiteLoadSpeed: z.number().optional(),
    hasSslCertificate: z.boolean().optional(),
    cmsUsed: z.string().optional(),
    ecommercePlatforms: z.array(z.string()).optional(),
    timezone: z.string().optional(),
    neighborhood: z.string().optional(),
    nearbyLandmarks: z.array(z.string()).optional(),
    transportationAccess: z.string().optional(),
    employeeBenefits: z.array(
      PostApiLeadScraperMicroserviceApiV1WorkspacesEmployeeBenefits$outboundSchema,
    ).optional(),
    parentCompany: z.string().optional(),
    subsidiaries: z.array(z.string()).optional(),
    isFranchise: z.boolean().optional(),
    seoKeywords: z.array(z.string()).optional(),
    usesGoogleAds: z.boolean().optional(),
    googleMyBusinessCategory: z.string().optional(),
    naicsCode: z.string().optional(),
    sicCode: z.string().optional(),
    unspscCode: z.string().optional(),
    isGreenCertified: z.boolean().optional(),
    energySources: z.array(z.string()).optional(),
    sustainabilityRating: z.string().optional(),
    recentAnnouncements: z.array(z.string()).optional(),
    lastProductLaunch: z.date().transform(v => v.toISOString()).optional(),
    hasLitigationHistory: z.boolean().optional(),
    exportControlStatus: z.string().optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesLeads$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesLeads$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesLeads$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesLeads$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesLeads$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesLeads$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1WorkspacesLeads$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesLeadsToJSON(
  postApiLeadScraperMicroserviceApiV1WorkspacesLeads:
    PostApiLeadScraperMicroserviceApiV1WorkspacesLeads,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1WorkspacesLeads$outboundSchema.parse(
      postApiLeadScraperMicroserviceApiV1WorkspacesLeads,
    ),
  );
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesLeadsFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1WorkspacesLeads,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1WorkspacesLeads$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1WorkspacesLeads' from JSON`,
  );
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesJobs$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesJobs,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    priority: z.number().int().optional(),
    payloadType: z.string().optional(),
    payload: z.string().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    status:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesStatus$inboundSchema
        .default("BACKGROUND_JOB_STATUS_UNSPECIFIED"),
    name: z.string().optional(),
    keywords: z.array(z.string()).optional(),
    lang: PostApiLeadScraperMicroserviceApiV1WorkspacesLang$inboundSchema
      .default("LANGUAGE_UNSPECIFIED"),
    zoom: z.number().int().optional(),
    lat: z.string().optional(),
    lon: z.string().optional(),
    fastMode: z.boolean().optional(),
    radius: z.number().int().optional(),
    depth: z.number().int().optional(),
    email: z.boolean().optional(),
    maxTime: z.number().int().optional(),
    proxies: z.array(z.string()).optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    leads: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1WorkspacesLeads$inboundSchema
      ),
    ).optional(),
    url: z.string().optional(),
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1WorkspacesJobs$Outbound = {
  id?: string | undefined;
  priority?: number | undefined;
  payloadType?: string | undefined;
  payload?: string | undefined;
  createdAt?: string | undefined;
  status: string;
  name?: string | undefined;
  keywords?: Array<string> | undefined;
  lang: string;
  zoom?: number | undefined;
  lat?: string | undefined;
  lon?: string | undefined;
  fastMode?: boolean | undefined;
  radius?: number | undefined;
  depth?: number | undefined;
  email?: boolean | undefined;
  maxTime?: number | undefined;
  proxies?: Array<string> | undefined;
  updatedAt?: string | undefined;
  deletedAt?: string | undefined;
  leads?:
    | Array<PostApiLeadScraperMicroserviceApiV1WorkspacesLeads$Outbound>
    | undefined;
  url?: string | undefined;
};

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesJobs$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesJobs$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1WorkspacesJobs
  > = z.object({
    id: z.string().optional(),
    priority: z.number().int().optional(),
    payloadType: z.string().optional(),
    payload: z.string().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    status:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesStatus$outboundSchema
        .default("BACKGROUND_JOB_STATUS_UNSPECIFIED"),
    name: z.string().optional(),
    keywords: z.array(z.string()).optional(),
    lang: PostApiLeadScraperMicroserviceApiV1WorkspacesLang$outboundSchema
      .default("LANGUAGE_UNSPECIFIED"),
    zoom: z.number().int().optional(),
    lat: z.string().optional(),
    lon: z.string().optional(),
    fastMode: z.boolean().optional(),
    radius: z.number().int().optional(),
    depth: z.number().int().optional(),
    email: z.boolean().optional(),
    maxTime: z.number().int().optional(),
    proxies: z.array(z.string()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
    leads: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1WorkspacesLeads$outboundSchema
      ),
    ).optional(),
    url: z.string().optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesJobs$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesJobs$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesJobs$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesJobs$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesJobs$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesJobs$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1WorkspacesJobs$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesJobsToJSON(
  postApiLeadScraperMicroserviceApiV1WorkspacesJobs:
    PostApiLeadScraperMicroserviceApiV1WorkspacesJobs,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1WorkspacesJobs$outboundSchema.parse(
      postApiLeadScraperMicroserviceApiV1WorkspacesJobs,
    ),
  );
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesJobsFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1WorkspacesJobs,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1WorkspacesJobs$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1WorkspacesJobs' from JSON`,
  );
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesOutputFormat$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesOutputFormat
  > = z.nativeEnum(PostApiLeadScraperMicroserviceApiV1WorkspacesOutputFormat);

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesOutputFormat$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesOutputFormat
  > = PostApiLeadScraperMicroserviceApiV1WorkspacesOutputFormat$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesOutputFormat$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesOutputFormat$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesOutputFormat$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesOutputFormat$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesOutputFormat$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkflows$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkflows,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    name: z.string().optional(),
    cronExpression: z.string().optional(),
    nextRunTime: z.string().datetime({ offset: true }).transform(v =>
      new Date(v)
    ).optional(),
    lastRunTime: z.string().datetime({ offset: true }).transform(v =>
      new Date(v)
    ).optional(),
    status: PostApiLeadScraperMicroserviceApiV1WorkspacesStatus$inboundSchema
      .default("WORKFLOW_STATUS_UNSPECIFIED"),
    retryCount: z.number().int().optional(),
    maxRetries: z.number().int().optional(),
    alertEmails: z.string().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    jobs: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1WorkspacesJobs$inboundSchema
      ),
    ).optional(),
    geoFencingRadius: z.number().optional(),
    geoFencingLat: z.number().optional(),
    geoFencingLon: z.number().optional(),
    geoFencingZoomMin: z.number().int().optional(),
    geoFencingZoomMax: z.number().int().optional(),
    includeReviews: z.boolean().optional(),
    includePhotos: z.boolean().optional(),
    includeBusinessHours: z.boolean().optional(),
    maxReviewsPerBusiness: z.number().int().optional(),
    outputFormat:
      PostApiLeadScraperMicroserviceApiV1WorkspacesOutputFormat$inboundSchema
        .default("OUTPUT_FORMAT_UNSPECIFIED"),
    outputDestination: z.string().optional(),
    dataRetention: z.string().optional(),
    anonymizePii: z.boolean().optional(),
    notificationSlackChannel: z.string().optional(),
    notificationEmailGroup: z.string().optional(),
    notificationNotifyOnStart: z.boolean().optional(),
    notificationNotifyOnComplete: z.boolean().optional(),
    notificationNotifyOnFailure: z.boolean().optional(),
    contentFilterAllowedCountries: z.array(z.string()).optional(),
    contentFilterExcludedTypes: z.array(z.string()).optional(),
    contentFilterMinimumRating: z.number().optional(),
    contentFilterMinimumReviews: z.number().int().optional(),
    qosMaxConcurrentRequests: z.number().int().optional(),
    qosMaxRetries: z.number().int().optional(),
    qosRequestTimeout: z.string().optional(),
    qosEnableJavascript: z.boolean().optional(),
    respectRobotsTxt: z.boolean().optional(),
    acceptTermsOfService: z.boolean().optional(),
    userAgent: z.string().optional(),
    searchTerms: z.array(z.string()).optional(),
    scheduledEntryId: z.string().optional(),
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkflows$Outbound = {
  id?: string | undefined;
  name?: string | undefined;
  cronExpression?: string | undefined;
  nextRunTime?: string | undefined;
  lastRunTime?: string | undefined;
  status: string;
  retryCount?: number | undefined;
  maxRetries?: number | undefined;
  alertEmails?: string | undefined;
  createdAt?: string | undefined;
  updatedAt?: string | undefined;
  deletedAt?: string | undefined;
  jobs?:
    | Array<PostApiLeadScraperMicroserviceApiV1WorkspacesJobs$Outbound>
    | undefined;
  geoFencingRadius?: number | undefined;
  geoFencingLat?: number | undefined;
  geoFencingLon?: number | undefined;
  geoFencingZoomMin?: number | undefined;
  geoFencingZoomMax?: number | undefined;
  includeReviews?: boolean | undefined;
  includePhotos?: boolean | undefined;
  includeBusinessHours?: boolean | undefined;
  maxReviewsPerBusiness?: number | undefined;
  outputFormat: string;
  outputDestination?: string | undefined;
  dataRetention?: string | undefined;
  anonymizePii?: boolean | undefined;
  notificationSlackChannel?: string | undefined;
  notificationEmailGroup?: string | undefined;
  notificationNotifyOnStart?: boolean | undefined;
  notificationNotifyOnComplete?: boolean | undefined;
  notificationNotifyOnFailure?: boolean | undefined;
  contentFilterAllowedCountries?: Array<string> | undefined;
  contentFilterExcludedTypes?: Array<string> | undefined;
  contentFilterMinimumRating?: number | undefined;
  contentFilterMinimumReviews?: number | undefined;
  qosMaxConcurrentRequests?: number | undefined;
  qosMaxRetries?: number | undefined;
  qosRequestTimeout?: string | undefined;
  qosEnableJavascript?: boolean | undefined;
  respectRobotsTxt?: boolean | undefined;
  acceptTermsOfService?: boolean | undefined;
  userAgent?: string | undefined;
  searchTerms?: Array<string> | undefined;
  scheduledEntryId?: string | undefined;
};

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkflows$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkflows$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkflows
  > = z.object({
    id: z.string().optional(),
    name: z.string().optional(),
    cronExpression: z.string().optional(),
    nextRunTime: z.date().transform(v => v.toISOString()).optional(),
    lastRunTime: z.date().transform(v => v.toISOString()).optional(),
    status: PostApiLeadScraperMicroserviceApiV1WorkspacesStatus$outboundSchema
      .default("WORKFLOW_STATUS_UNSPECIFIED"),
    retryCount: z.number().int().optional(),
    maxRetries: z.number().int().optional(),
    alertEmails: z.string().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
    jobs: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1WorkspacesJobs$outboundSchema
      ),
    ).optional(),
    geoFencingRadius: z.number().optional(),
    geoFencingLat: z.number().optional(),
    geoFencingLon: z.number().optional(),
    geoFencingZoomMin: z.number().int().optional(),
    geoFencingZoomMax: z.number().int().optional(),
    includeReviews: z.boolean().optional(),
    includePhotos: z.boolean().optional(),
    includeBusinessHours: z.boolean().optional(),
    maxReviewsPerBusiness: z.number().int().optional(),
    outputFormat:
      PostApiLeadScraperMicroserviceApiV1WorkspacesOutputFormat$outboundSchema
        .default("OUTPUT_FORMAT_UNSPECIFIED"),
    outputDestination: z.string().optional(),
    dataRetention: z.string().optional(),
    anonymizePii: z.boolean().optional(),
    notificationSlackChannel: z.string().optional(),
    notificationEmailGroup: z.string().optional(),
    notificationNotifyOnStart: z.boolean().optional(),
    notificationNotifyOnComplete: z.boolean().optional(),
    notificationNotifyOnFailure: z.boolean().optional(),
    contentFilterAllowedCountries: z.array(z.string()).optional(),
    contentFilterExcludedTypes: z.array(z.string()).optional(),
    contentFilterMinimumRating: z.number().optional(),
    contentFilterMinimumReviews: z.number().int().optional(),
    qosMaxConcurrentRequests: z.number().int().optional(),
    qosMaxRetries: z.number().int().optional(),
    qosRequestTimeout: z.string().optional(),
    qosEnableJavascript: z.boolean().optional(),
    respectRobotsTxt: z.boolean().optional(),
    acceptTermsOfService: z.boolean().optional(),
    userAgent: z.string().optional(),
    searchTerms: z.array(z.string()).optional(),
    scheduledEntryId: z.string().optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkflows$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkflows$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkflows$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkflows$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkflows$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkflows$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkflows$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWorkflowsToJSON(
  postApiLeadScraperMicroserviceApiV1WorkspacesWorkflows:
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkflows,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkflows$outboundSchema.parse(
      postApiLeadScraperMicroserviceApiV1WorkspacesWorkflows,
    ),
  );
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWorkflowsFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1WorkspacesWorkflows,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkflows$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1WorkspacesWorkflows' from JSON`,
  );
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRequestStatus$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRequestStatus
  > = z.nativeEnum(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRequestStatus,
  );

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRequestStatus$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRequestStatus
  > =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRequestStatus$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRequestStatus$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRequestStatus$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRequestStatus$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRequestStatus$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRequestStatus$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesLang$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesLang
  > = z.nativeEnum(PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesLang);

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesLang$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesLang
  > = PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesLang$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesLang$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesLang$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesLang$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesLang$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesLang$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRequestDay$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRequestDay
  > = z.nativeEnum(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRequestDay,
  );

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRequestDay$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRequestDay
  > =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRequestDay$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRequestDay$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRequestDay$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRequestDay$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRequestDay$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRequestDay$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRegularHours$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRegularHours,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    day:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRequestDay$inboundSchema
        .default("DAY_OF_WEEK_UNSPECIFIED"),
    openTime: z.string().optional(),
    closeTime: z.string().optional(),
    closed: z.boolean().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRegularHours$Outbound =
  {
    id?: string | undefined;
    day: string;
    openTime?: string | undefined;
    closeTime?: string | undefined;
    closed?: boolean | undefined;
    createdAt?: string | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRegularHours$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRegularHours$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRegularHours
  > = z.object({
    id: z.string().optional(),
    day:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRequestDay$outboundSchema
        .default("DAY_OF_WEEK_UNSPECIFIED"),
    openTime: z.string().optional(),
    closeTime: z.string().optional(),
    closed: z.boolean().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRegularHours$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRegularHours$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRegularHours$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRegularHours$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRegularHours$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRegularHours$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRegularHours$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRegularHoursToJSON(
  postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRegularHours:
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRegularHours,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRegularHours$outboundSchema
      .parse(
        postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRegularHours,
      ),
  );
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRegularHoursFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRegularHours,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRegularHours$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRegularHours' from JSON`,
  );
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRequestRequestBodyDay$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRequestRequestBodyDay
  > = z.nativeEnum(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRequestRequestBodyDay,
  );

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRequestRequestBodyDay$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRequestRequestBodyDay
  > =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRequestRequestBodyDay$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRequestRequestBodyDay$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRequestRequestBodyDay$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRequestRequestBodyDay$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRequestRequestBodyDay$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRequestRequestBodyDay$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesSpecialHours$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesSpecialHours,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    day:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRequestRequestBodyDay$inboundSchema
        .default("DAY_OF_WEEK_UNSPECIFIED"),
    openTime: z.string().optional(),
    closeTime: z.string().optional(),
    closed: z.boolean().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesSpecialHours$Outbound =
  {
    id?: string | undefined;
    day: string;
    openTime?: string | undefined;
    closeTime?: string | undefined;
    closed?: boolean | undefined;
    createdAt?: string | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesSpecialHours$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesSpecialHours$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesSpecialHours
  > = z.object({
    id: z.string().optional(),
    day:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRequestRequestBodyDay$outboundSchema
        .default("DAY_OF_WEEK_UNSPECIFIED"),
    openTime: z.string().optional(),
    closeTime: z.string().optional(),
    closed: z.boolean().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesSpecialHours$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesSpecialHours$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesSpecialHours$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesSpecialHours$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesSpecialHours$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesSpecialHours$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesSpecialHours$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesSpecialHoursToJSON(
  postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesSpecialHours:
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesSpecialHours,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesSpecialHours$outboundSchema
      .parse(
        postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesSpecialHours,
      ),
  );
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesSpecialHoursFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesSpecialHours,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesSpecialHours$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesSpecialHours' from JSON`,
  );
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesReviews$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesReviews,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    author: z.string().optional(),
    rating: z.number().optional(),
    text: z.string().optional(),
    time: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    language: z.string().optional(),
    profilePhotoUrl: z.string().optional(),
    reviewCount: z.number().int().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesReviews$Outbound =
  {
    id?: string | undefined;
    author?: string | undefined;
    rating?: number | undefined;
    text?: string | undefined;
    time?: string | undefined;
    language?: string | undefined;
    profilePhotoUrl?: string | undefined;
    reviewCount?: number | undefined;
    createdAt?: string | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesReviews$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesReviews$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesReviews
  > = z.object({
    id: z.string().optional(),
    author: z.string().optional(),
    rating: z.number().optional(),
    text: z.string().optional(),
    time: z.date().transform(v => v.toISOString()).optional(),
    language: z.string().optional(),
    profilePhotoUrl: z.string().optional(),
    reviewCount: z.number().int().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesReviews$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesReviews$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesReviews$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesReviews$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesReviews$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesReviews$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesReviews$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesReviewsToJSON(
  postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesReviews:
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesReviews,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesReviews$outboundSchema
      .parse(postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesReviews),
  );
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesReviewsFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesReviews,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesReviews$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesReviews' from JSON`,
  );
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRevenueRange$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRevenueRange
  > = z.nativeEnum(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRevenueRange,
  );

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRevenueRange$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRevenueRange
  > =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRevenueRange$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRevenueRange$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRevenueRange$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRevenueRange$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRevenueRange$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRevenueRange$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesEmployeeBenefits$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesEmployeeBenefits
  > = z.nativeEnum(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesEmployeeBenefits,
  );

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesEmployeeBenefits$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesEmployeeBenefits
  > =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesEmployeeBenefits$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesEmployeeBenefits$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesEmployeeBenefits$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesEmployeeBenefits$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesEmployeeBenefits$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesEmployeeBenefits$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesLeads$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesLeads,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    name: z.string().optional(),
    website: z.string().optional(),
    phone: z.string().optional(),
    address: z.string().optional(),
    city: z.string().optional(),
    state: z.string().optional(),
    country: z.string().optional(),
    latitude: z.number().optional(),
    longitude: z.number().optional(),
    googleRating: z.number().optional(),
    reviewCount: z.number().int().optional(),
    industry: z.string().optional(),
    employeeCount: z.number().int().optional(),
    estimatedRevenue: z.string().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    placeId: z.string().optional(),
    googleMapsUrl: z.string().optional(),
    businessStatus: z.string().optional(),
    regularHours: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRegularHours$inboundSchema
      ),
    ).optional(),
    specialHours: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesSpecialHours$inboundSchema
      ),
    ).optional(),
    photoReferences: z.array(z.string()).optional(),
    mainPhotoUrl: z.string().optional(),
    reviews: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesReviews$inboundSchema
      ),
    ).optional(),
    types: z.array(z.string()).optional(),
    amenities: z.array(z.string()).optional(),
    servesVegetarianFood: z.boolean().optional(),
    outdoorSeating: z.boolean().optional(),
    paymentMethods: z.array(z.string()).optional(),
    wheelchairAccessible: z.boolean().optional(),
    parkingAvailable: z.boolean().optional(),
    socialMedia: z.record(z.string()).optional(),
    ratingCategory: z.string().optional(),
    rating: z.number().optional(),
    count: z.number().int().optional(),
    lastUpdated: z.string().datetime({ offset: true }).transform(v =>
      new Date(v)
    ).optional(),
    dataSourceVersion: z.string().optional(),
    scrapingSessionId: z.string().optional(),
    alternatePhones: z.array(z.string()).optional(),
    contactPersonName: z.string().optional(),
    contactPersonTitle: z.string().optional(),
    contactEmail: z.string().optional(),
    foundedYear: z.number().int().optional(),
    businessType: z.string().optional(),
    certifications: z.array(z.string()).optional(),
    licenseNumber: z.string().optional(),
    revenueRange:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRevenueRange$inboundSchema
        .default("REVENUE_RANGE_UNSPECIFIED"),
    fundingStage: z.string().optional(),
    isPublicCompany: z.boolean().optional(),
    websiteLoadSpeed: z.number().optional(),
    hasSslCertificate: z.boolean().optional(),
    cmsUsed: z.string().optional(),
    ecommercePlatforms: z.array(z.string()).optional(),
    timezone: z.string().optional(),
    neighborhood: z.string().optional(),
    nearbyLandmarks: z.array(z.string()).optional(),
    transportationAccess: z.string().optional(),
    employeeBenefits: z.array(
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesEmployeeBenefits$inboundSchema,
    ).optional(),
    parentCompany: z.string().optional(),
    subsidiaries: z.array(z.string()).optional(),
    isFranchise: z.boolean().optional(),
    seoKeywords: z.array(z.string()).optional(),
    usesGoogleAds: z.boolean().optional(),
    googleMyBusinessCategory: z.string().optional(),
    naicsCode: z.string().optional(),
    sicCode: z.string().optional(),
    unspscCode: z.string().optional(),
    isGreenCertified: z.boolean().optional(),
    energySources: z.array(z.string()).optional(),
    sustainabilityRating: z.string().optional(),
    recentAnnouncements: z.array(z.string()).optional(),
    lastProductLaunch: z.string().datetime({ offset: true }).transform(v =>
      new Date(v)
    ).optional(),
    hasLitigationHistory: z.boolean().optional(),
    exportControlStatus: z.string().optional(),
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesLeads$Outbound =
  {
    id?: string | undefined;
    name?: string | undefined;
    website?: string | undefined;
    phone?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    googleRating?: number | undefined;
    reviewCount?: number | undefined;
    industry?: string | undefined;
    employeeCount?: number | undefined;
    estimatedRevenue?: string | undefined;
    createdAt?: string | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
    placeId?: string | undefined;
    googleMapsUrl?: string | undefined;
    businessStatus?: string | undefined;
    regularHours?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRegularHours$Outbound
      >
      | undefined;
    specialHours?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesSpecialHours$Outbound
      >
      | undefined;
    photoReferences?: Array<string> | undefined;
    mainPhotoUrl?: string | undefined;
    reviews?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesReviews$Outbound
      >
      | undefined;
    types?: Array<string> | undefined;
    amenities?: Array<string> | undefined;
    servesVegetarianFood?: boolean | undefined;
    outdoorSeating?: boolean | undefined;
    paymentMethods?: Array<string> | undefined;
    wheelchairAccessible?: boolean | undefined;
    parkingAvailable?: boolean | undefined;
    socialMedia?: { [k: string]: string } | undefined;
    ratingCategory?: string | undefined;
    rating?: number | undefined;
    count?: number | undefined;
    lastUpdated?: string | undefined;
    dataSourceVersion?: string | undefined;
    scrapingSessionId?: string | undefined;
    alternatePhones?: Array<string> | undefined;
    contactPersonName?: string | undefined;
    contactPersonTitle?: string | undefined;
    contactEmail?: string | undefined;
    foundedYear?: number | undefined;
    businessType?: string | undefined;
    certifications?: Array<string> | undefined;
    licenseNumber?: string | undefined;
    revenueRange: string;
    fundingStage?: string | undefined;
    isPublicCompany?: boolean | undefined;
    websiteLoadSpeed?: number | undefined;
    hasSslCertificate?: boolean | undefined;
    cmsUsed?: string | undefined;
    ecommercePlatforms?: Array<string> | undefined;
    timezone?: string | undefined;
    neighborhood?: string | undefined;
    nearbyLandmarks?: Array<string> | undefined;
    transportationAccess?: string | undefined;
    employeeBenefits?: Array<string> | undefined;
    parentCompany?: string | undefined;
    subsidiaries?: Array<string> | undefined;
    isFranchise?: boolean | undefined;
    seoKeywords?: Array<string> | undefined;
    usesGoogleAds?: boolean | undefined;
    googleMyBusinessCategory?: string | undefined;
    naicsCode?: string | undefined;
    sicCode?: string | undefined;
    unspscCode?: string | undefined;
    isGreenCertified?: boolean | undefined;
    energySources?: Array<string> | undefined;
    sustainabilityRating?: string | undefined;
    recentAnnouncements?: Array<string> | undefined;
    lastProductLaunch?: string | undefined;
    hasLitigationHistory?: boolean | undefined;
    exportControlStatus?: string | undefined;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesLeads$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesLeads$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesLeads
  > = z.object({
    id: z.string().optional(),
    name: z.string().optional(),
    website: z.string().optional(),
    phone: z.string().optional(),
    address: z.string().optional(),
    city: z.string().optional(),
    state: z.string().optional(),
    country: z.string().optional(),
    latitude: z.number().optional(),
    longitude: z.number().optional(),
    googleRating: z.number().optional(),
    reviewCount: z.number().int().optional(),
    industry: z.string().optional(),
    employeeCount: z.number().int().optional(),
    estimatedRevenue: z.string().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
    placeId: z.string().optional(),
    googleMapsUrl: z.string().optional(),
    businessStatus: z.string().optional(),
    regularHours: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRegularHours$outboundSchema
      ),
    ).optional(),
    specialHours: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesSpecialHours$outboundSchema
      ),
    ).optional(),
    photoReferences: z.array(z.string()).optional(),
    mainPhotoUrl: z.string().optional(),
    reviews: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesReviews$outboundSchema
      ),
    ).optional(),
    types: z.array(z.string()).optional(),
    amenities: z.array(z.string()).optional(),
    servesVegetarianFood: z.boolean().optional(),
    outdoorSeating: z.boolean().optional(),
    paymentMethods: z.array(z.string()).optional(),
    wheelchairAccessible: z.boolean().optional(),
    parkingAvailable: z.boolean().optional(),
    socialMedia: z.record(z.string()).optional(),
    ratingCategory: z.string().optional(),
    rating: z.number().optional(),
    count: z.number().int().optional(),
    lastUpdated: z.date().transform(v => v.toISOString()).optional(),
    dataSourceVersion: z.string().optional(),
    scrapingSessionId: z.string().optional(),
    alternatePhones: z.array(z.string()).optional(),
    contactPersonName: z.string().optional(),
    contactPersonTitle: z.string().optional(),
    contactEmail: z.string().optional(),
    foundedYear: z.number().int().optional(),
    businessType: z.string().optional(),
    certifications: z.array(z.string()).optional(),
    licenseNumber: z.string().optional(),
    revenueRange:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRevenueRange$outboundSchema
        .default("REVENUE_RANGE_UNSPECIFIED"),
    fundingStage: z.string().optional(),
    isPublicCompany: z.boolean().optional(),
    websiteLoadSpeed: z.number().optional(),
    hasSslCertificate: z.boolean().optional(),
    cmsUsed: z.string().optional(),
    ecommercePlatforms: z.array(z.string()).optional(),
    timezone: z.string().optional(),
    neighborhood: z.string().optional(),
    nearbyLandmarks: z.array(z.string()).optional(),
    transportationAccess: z.string().optional(),
    employeeBenefits: z.array(
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesEmployeeBenefits$outboundSchema,
    ).optional(),
    parentCompany: z.string().optional(),
    subsidiaries: z.array(z.string()).optional(),
    isFranchise: z.boolean().optional(),
    seoKeywords: z.array(z.string()).optional(),
    usesGoogleAds: z.boolean().optional(),
    googleMyBusinessCategory: z.string().optional(),
    naicsCode: z.string().optional(),
    sicCode: z.string().optional(),
    unspscCode: z.string().optional(),
    isGreenCertified: z.boolean().optional(),
    energySources: z.array(z.string()).optional(),
    sustainabilityRating: z.string().optional(),
    recentAnnouncements: z.array(z.string()).optional(),
    lastProductLaunch: z.date().transform(v => v.toISOString()).optional(),
    hasLitigationHistory: z.boolean().optional(),
    exportControlStatus: z.string().optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesLeads$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesLeads$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesLeads$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesLeads$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesLeads$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesLeads$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesLeads$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesLeadsToJSON(
  postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesLeads:
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesLeads,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesLeads$outboundSchema
      .parse(postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesLeads),
  );
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesLeadsFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesLeads,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesLeads$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesLeads' from JSON`,
  );
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesScrapingJobs$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesScrapingJobs,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    priority: z.number().int().optional(),
    payloadType: z.string().optional(),
    payload: z.string().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    status:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRequestStatus$inboundSchema
        .default("BACKGROUND_JOB_STATUS_UNSPECIFIED"),
    name: z.string().optional(),
    keywords: z.array(z.string()).optional(),
    lang:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesLang$inboundSchema
        .default("LANGUAGE_UNSPECIFIED"),
    zoom: z.number().int().optional(),
    lat: z.string().optional(),
    lon: z.string().optional(),
    fastMode: z.boolean().optional(),
    radius: z.number().int().optional(),
    depth: z.number().int().optional(),
    email: z.boolean().optional(),
    maxTime: z.number().int().optional(),
    proxies: z.array(z.string()).optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    leads: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesLeads$inboundSchema
      ),
    ).optional(),
    url: z.string().optional(),
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1WorkspacesScrapingJobs$Outbound =
  {
    id?: string | undefined;
    priority?: number | undefined;
    payloadType?: string | undefined;
    payload?: string | undefined;
    createdAt?: string | undefined;
    status: string;
    name?: string | undefined;
    keywords?: Array<string> | undefined;
    lang: string;
    zoom?: number | undefined;
    lat?: string | undefined;
    lon?: string | undefined;
    fastMode?: boolean | undefined;
    radius?: number | undefined;
    depth?: number | undefined;
    email?: boolean | undefined;
    maxTime?: number | undefined;
    proxies?: Array<string> | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
    leads?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesLeads$Outbound
      >
      | undefined;
    url?: string | undefined;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesScrapingJobs$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesScrapingJobs$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1WorkspacesScrapingJobs
  > = z.object({
    id: z.string().optional(),
    priority: z.number().int().optional(),
    payloadType: z.string().optional(),
    payload: z.string().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    status:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRequestStatus$outboundSchema
        .default("BACKGROUND_JOB_STATUS_UNSPECIFIED"),
    name: z.string().optional(),
    keywords: z.array(z.string()).optional(),
    lang:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesLang$outboundSchema
        .default("LANGUAGE_UNSPECIFIED"),
    zoom: z.number().int().optional(),
    lat: z.string().optional(),
    lon: z.string().optional(),
    fastMode: z.boolean().optional(),
    radius: z.number().int().optional(),
    depth: z.number().int().optional(),
    email: z.boolean().optional(),
    maxTime: z.number().int().optional(),
    proxies: z.array(z.string()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
    leads: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesLeads$outboundSchema
      ),
    ).optional(),
    url: z.string().optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesScrapingJobs$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesScrapingJobs$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesScrapingJobs$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesScrapingJobs$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesScrapingJobs$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesScrapingJobs$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1WorkspacesScrapingJobs$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesScrapingJobsToJSON(
  postApiLeadScraperMicroserviceApiV1WorkspacesScrapingJobs:
    PostApiLeadScraperMicroserviceApiV1WorkspacesScrapingJobs,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1WorkspacesScrapingJobs$outboundSchema
      .parse(postApiLeadScraperMicroserviceApiV1WorkspacesScrapingJobs),
  );
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesScrapingJobsFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1WorkspacesScrapingJobs,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1WorkspacesScrapingJobs$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1WorkspacesScrapingJobs' from JSON`,
  );
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRequestRequestBodyStatus$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRequestRequestBodyStatus
  > = z.nativeEnum(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRequestRequestBodyStatus,
  );

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRequestRequestBodyStatus$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRequestRequestBodyStatus
  > =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRequestRequestBodyStatus$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRequestRequestBodyStatus$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRequestRequestBodyStatus$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRequestRequestBodyStatus$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRequestRequestBodyStatus$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRequestRequestBodyStatus$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesApiKeys$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesApiKeys,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    name: z.string().optional(),
    keyHash: z.string().optional(),
    keyPrefix: z.string().optional(),
    scopes: z.array(z.string()).optional(),
    allowedIps: z.array(z.string()).optional(),
    allowedDomains: z.array(z.string()).optional(),
    allowedEnvironments: z.array(z.string()).optional(),
    isTestKey: z.boolean().optional(),
    requestsPerSecond: z.number().int().optional(),
    requestsPerDay: z.number().int().optional(),
    concurrentRequests: z.number().int().optional(),
    monthlyRequestQuota: z.string().optional(),
    costPerRequest: z.number().optional(),
    billingTier: z.string().optional(),
    totalRequests: z.string().optional(),
    totalErrors: z.string().optional(),
    lastUsedAt: z.string().datetime({ offset: true }).transform(v =>
      new Date(v)
    ).optional(),
    averageResponseTime: z.number().optional(),
    endpointUsageJson: z.string().optional(),
    errorRatesJson: z.string().optional(),
    recentErrors: z.string().optional(),
    successfulRequestsCount: z.number().int().optional(),
    successRate: z.number().optional(),
    status:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRequestRequestBodyStatus$inboundSchema
        .default("STATUS_UNSPECIFIED"),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    expiresAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    lastRotatedAt: z.string().datetime({ offset: true }).transform(v =>
      new Date(v)
    ).optional(),
    lastSecurityReviewAt: z.string().datetime({ offset: true }).transform(v =>
      new Date(v)
    ).optional(),
    requiresClientSecret: z.boolean().optional(),
    clientSecretHash: z.string().optional(),
    enforceHttps: z.boolean().optional(),
    enforceSigning: z.boolean().optional(),
    allowedSignatureAlgorithms: z.array(z.string()).optional(),
    enforceMutualTls: z.boolean().optional(),
    clientCertificateHash: z.string().optional(),
    requireRequestSigning: z.boolean().optional(),
    description: z.string().optional(),
    metadataJson: z.string().optional(),
    tags: z.array(z.string()).optional(),
    apiVersion: z.string().optional(),
    supportedFeatures: z.array(z.string()).optional(),
    documentationUrl: z.string().optional(),
    supportContact: z.string().optional(),
    logAllRequests: z.boolean().optional(),
    lastRotationReason: z.string().optional(),
    lastRotationDate: z.string().datetime({ offset: true }).transform(v =>
      new Date(v)
    ).optional(),
    rotationFrequencyDays: z.number().int().optional(),
    complianceStandards: z.array(z.string()).optional(),
    requiresAuditLogging: z.boolean().optional(),
    dataResidency: z.string().optional(),
    approvedIntegrations: z.array(z.string()).optional(),
    alertEmails: z.array(z.string()).optional(),
    webhookUrl: z.string().optional(),
    alertOnQuotaThreshold: z.boolean().optional(),
    quotaAlertThreshold: z.number().optional(),
    alertOnErrorSpike: z.boolean().optional(),
    errorAlertThreshold: z.number().optional(),
    monitoringIntegrations: z.array(z.string()).optional(),
    encrypted: z.boolean().optional(),
    dataClassification: z.string().optional(),
    maxUses: z.number().int().optional(),
    rateLimit: z.number().int().optional(),
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1WorkspacesApiKeys$Outbound = {
  id?: string | undefined;
  name?: string | undefined;
  keyHash?: string | undefined;
  keyPrefix?: string | undefined;
  scopes?: Array<string> | undefined;
  allowedIps?: Array<string> | undefined;
  allowedDomains?: Array<string> | undefined;
  allowedEnvironments?: Array<string> | undefined;
  isTestKey?: boolean | undefined;
  requestsPerSecond?: number | undefined;
  requestsPerDay?: number | undefined;
  concurrentRequests?: number | undefined;
  monthlyRequestQuota?: string | undefined;
  costPerRequest?: number | undefined;
  billingTier?: string | undefined;
  totalRequests?: string | undefined;
  totalErrors?: string | undefined;
  lastUsedAt?: string | undefined;
  averageResponseTime?: number | undefined;
  endpointUsageJson?: string | undefined;
  errorRatesJson?: string | undefined;
  recentErrors?: string | undefined;
  successfulRequestsCount?: number | undefined;
  successRate?: number | undefined;
  status: string;
  createdAt?: string | undefined;
  updatedAt?: string | undefined;
  expiresAt?: string | undefined;
  deletedAt?: string | undefined;
  lastRotatedAt?: string | undefined;
  lastSecurityReviewAt?: string | undefined;
  requiresClientSecret?: boolean | undefined;
  clientSecretHash?: string | undefined;
  enforceHttps?: boolean | undefined;
  enforceSigning?: boolean | undefined;
  allowedSignatureAlgorithms?: Array<string> | undefined;
  enforceMutualTls?: boolean | undefined;
  clientCertificateHash?: string | undefined;
  requireRequestSigning?: boolean | undefined;
  description?: string | undefined;
  metadataJson?: string | undefined;
  tags?: Array<string> | undefined;
  apiVersion?: string | undefined;
  supportedFeatures?: Array<string> | undefined;
  documentationUrl?: string | undefined;
  supportContact?: string | undefined;
  logAllRequests?: boolean | undefined;
  lastRotationReason?: string | undefined;
  lastRotationDate?: string | undefined;
  rotationFrequencyDays?: number | undefined;
  complianceStandards?: Array<string> | undefined;
  requiresAuditLogging?: boolean | undefined;
  dataResidency?: string | undefined;
  approvedIntegrations?: Array<string> | undefined;
  alertEmails?: Array<string> | undefined;
  webhookUrl?: string | undefined;
  alertOnQuotaThreshold?: boolean | undefined;
  quotaAlertThreshold?: number | undefined;
  alertOnErrorSpike?: boolean | undefined;
  errorAlertThreshold?: number | undefined;
  monitoringIntegrations?: Array<string> | undefined;
  encrypted?: boolean | undefined;
  dataClassification?: string | undefined;
  maxUses?: number | undefined;
  rateLimit?: number | undefined;
};

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesApiKeys$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesApiKeys$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1WorkspacesApiKeys
  > = z.object({
    id: z.string().optional(),
    name: z.string().optional(),
    keyHash: z.string().optional(),
    keyPrefix: z.string().optional(),
    scopes: z.array(z.string()).optional(),
    allowedIps: z.array(z.string()).optional(),
    allowedDomains: z.array(z.string()).optional(),
    allowedEnvironments: z.array(z.string()).optional(),
    isTestKey: z.boolean().optional(),
    requestsPerSecond: z.number().int().optional(),
    requestsPerDay: z.number().int().optional(),
    concurrentRequests: z.number().int().optional(),
    monthlyRequestQuota: z.string().optional(),
    costPerRequest: z.number().optional(),
    billingTier: z.string().optional(),
    totalRequests: z.string().optional(),
    totalErrors: z.string().optional(),
    lastUsedAt: z.date().transform(v => v.toISOString()).optional(),
    averageResponseTime: z.number().optional(),
    endpointUsageJson: z.string().optional(),
    errorRatesJson: z.string().optional(),
    recentErrors: z.string().optional(),
    successfulRequestsCount: z.number().int().optional(),
    successRate: z.number().optional(),
    status:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesRequestRequestBodyStatus$outboundSchema
        .default("STATUS_UNSPECIFIED"),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    expiresAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
    lastRotatedAt: z.date().transform(v => v.toISOString()).optional(),
    lastSecurityReviewAt: z.date().transform(v => v.toISOString()).optional(),
    requiresClientSecret: z.boolean().optional(),
    clientSecretHash: z.string().optional(),
    enforceHttps: z.boolean().optional(),
    enforceSigning: z.boolean().optional(),
    allowedSignatureAlgorithms: z.array(z.string()).optional(),
    enforceMutualTls: z.boolean().optional(),
    clientCertificateHash: z.string().optional(),
    requireRequestSigning: z.boolean().optional(),
    description: z.string().optional(),
    metadataJson: z.string().optional(),
    tags: z.array(z.string()).optional(),
    apiVersion: z.string().optional(),
    supportedFeatures: z.array(z.string()).optional(),
    documentationUrl: z.string().optional(),
    supportContact: z.string().optional(),
    logAllRequests: z.boolean().optional(),
    lastRotationReason: z.string().optional(),
    lastRotationDate: z.date().transform(v => v.toISOString()).optional(),
    rotationFrequencyDays: z.number().int().optional(),
    complianceStandards: z.array(z.string()).optional(),
    requiresAuditLogging: z.boolean().optional(),
    dataResidency: z.string().optional(),
    approvedIntegrations: z.array(z.string()).optional(),
    alertEmails: z.array(z.string()).optional(),
    webhookUrl: z.string().optional(),
    alertOnQuotaThreshold: z.boolean().optional(),
    quotaAlertThreshold: z.number().optional(),
    alertOnErrorSpike: z.boolean().optional(),
    errorAlertThreshold: z.number().optional(),
    monitoringIntegrations: z.array(z.string()).optional(),
    encrypted: z.boolean().optional(),
    dataClassification: z.string().optional(),
    maxUses: z.number().int().optional(),
    rateLimit: z.number().int().optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesApiKeys$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesApiKeys$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesApiKeys$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesApiKeys$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesApiKeys$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesApiKeys$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1WorkspacesApiKeys$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesApiKeysToJSON(
  postApiLeadScraperMicroserviceApiV1WorkspacesApiKeys:
    PostApiLeadScraperMicroserviceApiV1WorkspacesApiKeys,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1WorkspacesApiKeys$outboundSchema.parse(
      postApiLeadScraperMicroserviceApiV1WorkspacesApiKeys,
    ),
  );
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesApiKeysFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1WorkspacesApiKeys,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1WorkspacesApiKeys$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1WorkspacesApiKeys' from JSON`,
  );
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesTriggerEvents$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesTriggerEvents
  > = z.nativeEnum(PostApiLeadScraperMicroserviceApiV1WorkspacesTriggerEvents);

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesTriggerEvents$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesTriggerEvents
  > = PostApiLeadScraperMicroserviceApiV1WorkspacesTriggerEvents$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesTriggerEvents$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesTriggerEvents$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesTriggerEvents$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesTriggerEvents$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesTriggerEvents$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesIncludedFields$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesIncludedFields
  > = z.nativeEnum(PostApiLeadScraperMicroserviceApiV1WorkspacesIncludedFields);

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesIncludedFields$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesIncludedFields
  > = PostApiLeadScraperMicroserviceApiV1WorkspacesIncludedFields$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesIncludedFields$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesIncludedFields$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesIncludedFields$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesIncludedFields$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesIncludedFields$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesPayloadFormat$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesPayloadFormat
  > = z.nativeEnum(PostApiLeadScraperMicroserviceApiV1WorkspacesPayloadFormat);

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesPayloadFormat$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesPayloadFormat
  > = PostApiLeadScraperMicroserviceApiV1WorkspacesPayloadFormat$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesPayloadFormat$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesPayloadFormat$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesPayloadFormat$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesPayloadFormat$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesPayloadFormat$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesMetadata$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesMetadata,
    z.ZodTypeDef,
    unknown
  > = z.object({});

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1WorkspacesMetadata$Outbound = {};

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesMetadata$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesMetadata$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1WorkspacesMetadata
  > = z.object({});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesMetadata$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesMetadata$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesMetadata$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesMetadata$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesMetadata$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesMetadata$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1WorkspacesMetadata$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesMetadataToJSON(
  postApiLeadScraperMicroserviceApiV1WorkspacesMetadata:
    PostApiLeadScraperMicroserviceApiV1WorkspacesMetadata,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1WorkspacesMetadata$outboundSchema.parse(
      postApiLeadScraperMicroserviceApiV1WorkspacesMetadata,
    ),
  );
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesMetadataFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1WorkspacesMetadata,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1WorkspacesMetadata$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1WorkspacesMetadata' from JSON`,
  );
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWebhooks$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWebhooks,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    url: z.string().optional(),
    authType: z.string().optional(),
    authToken: z.string().optional(),
    customHeaders: z.record(z.string()).optional(),
    maxRetries: z.number().int().optional(),
    retryInterval: z.string().optional(),
    triggerEvents: z.array(
      PostApiLeadScraperMicroserviceApiV1WorkspacesTriggerEvents$inboundSchema,
    ).optional(),
    includedFields: z.array(
      PostApiLeadScraperMicroserviceApiV1WorkspacesIncludedFields$inboundSchema,
    ).optional(),
    includeFullResults: z.boolean().optional(),
    payloadFormat:
      PostApiLeadScraperMicroserviceApiV1WorkspacesPayloadFormat$inboundSchema
        .default("PAYLOAD_FORMAT_UNSPECIFIED"),
    verifySsl: z.boolean().optional(),
    signingSecret: z.string().optional(),
    rateLimit: z.number().int().optional(),
    rateLimitInterval: z.string().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    lastTriggeredAt: z.string().datetime({ offset: true }).transform(v =>
      new Date(v)
    ).optional(),
    successfulCalls: z.number().int().optional(),
    failedCalls: z.number().int().optional(),
    metadata: z.lazy(() =>
      PostApiLeadScraperMicroserviceApiV1WorkspacesMetadata$inboundSchema
    ).optional(),
    webhookName: z.string().optional(),
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWebhooks$Outbound = {
  id?: string | undefined;
  url?: string | undefined;
  authType?: string | undefined;
  authToken?: string | undefined;
  customHeaders?: { [k: string]: string } | undefined;
  maxRetries?: number | undefined;
  retryInterval?: string | undefined;
  triggerEvents?: Array<string> | undefined;
  includedFields?: Array<string> | undefined;
  includeFullResults?: boolean | undefined;
  payloadFormat: string;
  verifySsl?: boolean | undefined;
  signingSecret?: string | undefined;
  rateLimit?: number | undefined;
  rateLimitInterval?: string | undefined;
  createdAt?: string | undefined;
  updatedAt?: string | undefined;
  lastTriggeredAt?: string | undefined;
  successfulCalls?: number | undefined;
  failedCalls?: number | undefined;
  metadata?:
    | PostApiLeadScraperMicroserviceApiV1WorkspacesMetadata$Outbound
    | undefined;
  webhookName?: string | undefined;
};

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWebhooks$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWebhooks$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1WorkspacesWebhooks
  > = z.object({
    id: z.string().optional(),
    url: z.string().optional(),
    authType: z.string().optional(),
    authToken: z.string().optional(),
    customHeaders: z.record(z.string()).optional(),
    maxRetries: z.number().int().optional(),
    retryInterval: z.string().optional(),
    triggerEvents: z.array(
      PostApiLeadScraperMicroserviceApiV1WorkspacesTriggerEvents$outboundSchema,
    ).optional(),
    includedFields: z.array(
      PostApiLeadScraperMicroserviceApiV1WorkspacesIncludedFields$outboundSchema,
    ).optional(),
    includeFullResults: z.boolean().optional(),
    payloadFormat:
      PostApiLeadScraperMicroserviceApiV1WorkspacesPayloadFormat$outboundSchema
        .default("PAYLOAD_FORMAT_UNSPECIFIED"),
    verifySsl: z.boolean().optional(),
    signingSecret: z.string().optional(),
    rateLimit: z.number().int().optional(),
    rateLimitInterval: z.string().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    lastTriggeredAt: z.date().transform(v => v.toISOString()).optional(),
    successfulCalls: z.number().int().optional(),
    failedCalls: z.number().int().optional(),
    metadata: z.lazy(() =>
      PostApiLeadScraperMicroserviceApiV1WorkspacesMetadata$outboundSchema
    ).optional(),
    webhookName: z.string().optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWebhooks$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWebhooks$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWebhooks$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWebhooks$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWebhooks$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWebhooks$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWebhooks$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWebhooksToJSON(
  postApiLeadScraperMicroserviceApiV1WorkspacesWebhooks:
    PostApiLeadScraperMicroserviceApiV1WorkspacesWebhooks,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWebhooks$outboundSchema.parse(
      postApiLeadScraperMicroserviceApiV1WorkspacesWebhooks,
    ),
  );
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWebhooksFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1WorkspacesWebhooks,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1WorkspacesWebhooks$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1WorkspacesWebhooks' from JSON`,
  );
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceType$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceType
  > = z.nativeEnum(PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceType);

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceType$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceType
  > = PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceType$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceType$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceType$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceType$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceType$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceType$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspace$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspace,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    name: z.string().optional(),
    industry: z.string().optional(),
    domain: z.string().optional(),
    gdprCompliant: z.boolean().optional(),
    hipaaCompliant: z.boolean().optional(),
    soc2Compliant: z.boolean().optional(),
    storageQuota: z.string().optional(),
    usedStorage: z.string().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    workflows: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkflows$inboundSchema
      ),
    ).optional(),
    jobsRunThisMonth: z.number().int().optional(),
    workspaceJobLimit: z.number().int().optional(),
    dailyJobQuota: z.number().int().optional(),
    activeScrapers: z.number().int().optional(),
    totalLeadsCollected: z.number().int().optional(),
    lastJobRun: z.string().datetime({ offset: true }).transform(v =>
      new Date(v)
    ).optional(),
    scrapingJobs: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1WorkspacesScrapingJobs$inboundSchema
      ),
    ).optional(),
    apiKeys: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1WorkspacesApiKeys$inboundSchema
      ),
    ).optional(),
    webhooks: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1WorkspacesWebhooks$inboundSchema
      ),
    ).optional(),
    workspaceType:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceType$inboundSchema
        .default("WORKSPACE_TYPE_UNSPECIFIED"),
    description: z.string().optional(),
    metadata: z.record(z.string()).optional(),
    tags: z.array(z.string()).optional(),
    maxTeamMembers: z.number().int().optional(),
    currentTeamMembers: z.number().int().optional(),
    allowGuestAccess: z.boolean().optional(),
    allowedEmailDomains: z.array(z.string()).optional(),
    exportFormats: z.array(z.string()).optional(),
    exportSchedule: z.string().optional(),
    exportDestinations: z.array(z.string()).optional(),
    exportDestinationConfig: z.record(z.string()).optional(),
    compressExports: z.boolean().optional(),
    compressionFormat: z.string().optional(),
    salesforceEnabled: z.boolean().optional(),
    salesforceConfig: z.string().optional(),
    hubspotEnabled: z.boolean().optional(),
    hubspotConfig: z.string().optional(),
    zapierEnabled: z.boolean().optional(),
    zapierWebhook: z.string().optional(),
    activeIntegrations: z.array(z.string()).optional(),
    integrationSettings: z.record(z.string()).optional(),
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspace$Outbound = {
  id?: string | undefined;
  name?: string | undefined;
  industry?: string | undefined;
  domain?: string | undefined;
  gdprCompliant?: boolean | undefined;
  hipaaCompliant?: boolean | undefined;
  soc2Compliant?: boolean | undefined;
  storageQuota?: string | undefined;
  usedStorage?: string | undefined;
  createdAt?: string | undefined;
  updatedAt?: string | undefined;
  deletedAt?: string | undefined;
  workflows?:
    | Array<PostApiLeadScraperMicroserviceApiV1WorkspacesWorkflows$Outbound>
    | undefined;
  jobsRunThisMonth?: number | undefined;
  workspaceJobLimit?: number | undefined;
  dailyJobQuota?: number | undefined;
  activeScrapers?: number | undefined;
  totalLeadsCollected?: number | undefined;
  lastJobRun?: string | undefined;
  scrapingJobs?:
    | Array<PostApiLeadScraperMicroserviceApiV1WorkspacesScrapingJobs$Outbound>
    | undefined;
  apiKeys?:
    | Array<PostApiLeadScraperMicroserviceApiV1WorkspacesApiKeys$Outbound>
    | undefined;
  webhooks?:
    | Array<PostApiLeadScraperMicroserviceApiV1WorkspacesWebhooks$Outbound>
    | undefined;
  workspaceType: string;
  description?: string | undefined;
  metadata?: { [k: string]: string } | undefined;
  tags?: Array<string> | undefined;
  maxTeamMembers?: number | undefined;
  currentTeamMembers?: number | undefined;
  allowGuestAccess?: boolean | undefined;
  allowedEmailDomains?: Array<string> | undefined;
  exportFormats?: Array<string> | undefined;
  exportSchedule?: string | undefined;
  exportDestinations?: Array<string> | undefined;
  exportDestinationConfig?: { [k: string]: string } | undefined;
  compressExports?: boolean | undefined;
  compressionFormat?: string | undefined;
  salesforceEnabled?: boolean | undefined;
  salesforceConfig?: string | undefined;
  hubspotEnabled?: boolean | undefined;
  hubspotConfig?: string | undefined;
  zapierEnabled?: boolean | undefined;
  zapierWebhook?: string | undefined;
  activeIntegrations?: Array<string> | undefined;
  integrationSettings?: { [k: string]: string } | undefined;
};

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspace$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspace$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspace
  > = z.object({
    id: z.string().optional(),
    name: z.string().optional(),
    industry: z.string().optional(),
    domain: z.string().optional(),
    gdprCompliant: z.boolean().optional(),
    hipaaCompliant: z.boolean().optional(),
    soc2Compliant: z.boolean().optional(),
    storageQuota: z.string().optional(),
    usedStorage: z.string().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
    workflows: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkflows$outboundSchema
      ),
    ).optional(),
    jobsRunThisMonth: z.number().int().optional(),
    workspaceJobLimit: z.number().int().optional(),
    dailyJobQuota: z.number().int().optional(),
    activeScrapers: z.number().int().optional(),
    totalLeadsCollected: z.number().int().optional(),
    lastJobRun: z.date().transform(v => v.toISOString()).optional(),
    scrapingJobs: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1WorkspacesScrapingJobs$outboundSchema
      ),
    ).optional(),
    apiKeys: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1WorkspacesApiKeys$outboundSchema
      ),
    ).optional(),
    webhooks: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1WorkspacesWebhooks$outboundSchema
      ),
    ).optional(),
    workspaceType:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceType$outboundSchema
        .default("WORKSPACE_TYPE_UNSPECIFIED"),
    description: z.string().optional(),
    metadata: z.record(z.string()).optional(),
    tags: z.array(z.string()).optional(),
    maxTeamMembers: z.number().int().optional(),
    currentTeamMembers: z.number().int().optional(),
    allowGuestAccess: z.boolean().optional(),
    allowedEmailDomains: z.array(z.string()).optional(),
    exportFormats: z.array(z.string()).optional(),
    exportSchedule: z.string().optional(),
    exportDestinations: z.array(z.string()).optional(),
    exportDestinationConfig: z.record(z.string()).optional(),
    compressExports: z.boolean().optional(),
    compressionFormat: z.string().optional(),
    salesforceEnabled: z.boolean().optional(),
    salesforceConfig: z.string().optional(),
    hubspotEnabled: z.boolean().optional(),
    hubspotConfig: z.string().optional(),
    zapierEnabled: z.boolean().optional(),
    zapierWebhook: z.string().optional(),
    activeIntegrations: z.array(z.string()).optional(),
    integrationSettings: z.record(z.string()).optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspace$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspace$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspace$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspace$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspace$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspace$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspace$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceToJSON(
  postApiLeadScraperMicroserviceApiV1WorkspacesWorkspace:
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspace,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspace$outboundSchema.parse(
      postApiLeadScraperMicroserviceApiV1WorkspacesWorkspace,
    ),
  );
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspace,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspace$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspace' from JSON`,
  );
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesRequestBody$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesRequestBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    workspace: z.lazy(() =>
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspace$inboundSchema
    ).optional(),
    accountId: z.string().optional(),
    organizationId: z.string().optional(),
    tenantId: z.string().optional(),
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1WorkspacesRequestBody$Outbound =
  {
    workspace?:
      | PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspace$Outbound
      | undefined;
    accountId?: string | undefined;
    organizationId?: string | undefined;
    tenantId?: string | undefined;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesRequestBody$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesRequestBody$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1WorkspacesRequestBody
  > = z.object({
    workspace: z.lazy(() =>
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspace$outboundSchema
    ).optional(),
    accountId: z.string().optional(),
    organizationId: z.string().optional(),
    tenantId: z.string().optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesRequestBody$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesRequestBody$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesRequestBody$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesRequestBody$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesRequestBody$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesRequestBody$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1WorkspacesRequestBody$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesRequestBodyToJSON(
  postApiLeadScraperMicroserviceApiV1WorkspacesRequestBody:
    PostApiLeadScraperMicroserviceApiV1WorkspacesRequestBody,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1WorkspacesRequestBody$outboundSchema
      .parse(postApiLeadScraperMicroserviceApiV1WorkspacesRequestBody),
  );
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesRequestBodyFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1WorkspacesRequestBody,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1WorkspacesRequestBody$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1WorkspacesRequestBody' from JSON`,
  );
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseStatus$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseStatus
  > = z.nativeEnum(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseStatus,
  );

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseStatus$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseStatus
  > =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseStatus$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseStatus$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseStatus$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseStatus$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseStatus$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseStatus$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200ApplicationJSONResponseBodyStatus$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200ApplicationJSONResponseBodyStatus
  > = z.nativeEnum(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200ApplicationJSONResponseBodyStatus,
  );

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200ApplicationJSONResponseBodyStatus$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200ApplicationJSONResponseBodyStatus
  > =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200ApplicationJSONResponseBodyStatus$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200ApplicationJSONResponseBodyStatus$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200ApplicationJSONResponseBodyStatus$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200ApplicationJSONResponseBodyStatus$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200ApplicationJSONResponseBodyStatus$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200ApplicationJSONResponseBodyStatus$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Lang$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Lang
  > = z.nativeEnum(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Lang,
  );

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Lang$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Lang
  > =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Lang$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Lang$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Lang$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Lang$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Lang$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Lang$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200ApplicationJSONDay$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200ApplicationJSONDay
  > = z.nativeEnum(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200ApplicationJSONDay,
  );

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200ApplicationJSONDay$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200ApplicationJSONDay
  > =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200ApplicationJSONDay$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200ApplicationJSONDay$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200ApplicationJSONDay$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200ApplicationJSONDay$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200ApplicationJSONDay$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200ApplicationJSONDay$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200RegularHours$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200RegularHours,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    day:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200ApplicationJSONDay$inboundSchema
        .default("DAY_OF_WEEK_UNSPECIFIED"),
    openTime: z.string().optional(),
    closeTime: z.string().optional(),
    closed: z.boolean().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200RegularHours$Outbound =
  {
    id?: string | undefined;
    day: string;
    openTime?: string | undefined;
    closeTime?: string | undefined;
    closed?: boolean | undefined;
    createdAt?: string | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200RegularHours$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200RegularHours$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200RegularHours
  > = z.object({
    id: z.string().optional(),
    day:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200ApplicationJSONDay$outboundSchema
        .default("DAY_OF_WEEK_UNSPECIFIED"),
    openTime: z.string().optional(),
    closeTime: z.string().optional(),
    closed: z.boolean().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200RegularHours$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200RegularHours$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200RegularHours$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200RegularHours$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200RegularHours$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200RegularHours$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200RegularHours$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200RegularHoursToJSON(
  postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200RegularHours:
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200RegularHours,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200RegularHours$outboundSchema
      .parse(
        postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200RegularHours,
      ),
  );
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200RegularHoursFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200RegularHours,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200RegularHours$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200RegularHours' from JSON`,
  );
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200ApplicationJSONResponseBodyDay$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200ApplicationJSONResponseBodyDay
  > = z.nativeEnum(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200ApplicationJSONResponseBodyDay,
  );

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200ApplicationJSONResponseBodyDay$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200ApplicationJSONResponseBodyDay
  > =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200ApplicationJSONResponseBodyDay$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200ApplicationJSONResponseBodyDay$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200ApplicationJSONResponseBodyDay$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200ApplicationJSONResponseBodyDay$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200ApplicationJSONResponseBodyDay$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200ApplicationJSONResponseBodyDay$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200SpecialHours$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200SpecialHours,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    day:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200ApplicationJSONResponseBodyDay$inboundSchema
        .default("DAY_OF_WEEK_UNSPECIFIED"),
    openTime: z.string().optional(),
    closeTime: z.string().optional(),
    closed: z.boolean().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200SpecialHours$Outbound =
  {
    id?: string | undefined;
    day: string;
    openTime?: string | undefined;
    closeTime?: string | undefined;
    closed?: boolean | undefined;
    createdAt?: string | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200SpecialHours$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200SpecialHours$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200SpecialHours
  > = z.object({
    id: z.string().optional(),
    day:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200ApplicationJSONResponseBodyDay$outboundSchema
        .default("DAY_OF_WEEK_UNSPECIFIED"),
    openTime: z.string().optional(),
    closeTime: z.string().optional(),
    closed: z.boolean().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200SpecialHours$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200SpecialHours$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200SpecialHours$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200SpecialHours$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200SpecialHours$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200SpecialHours$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200SpecialHours$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200SpecialHoursToJSON(
  postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200SpecialHours:
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200SpecialHours,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200SpecialHours$outboundSchema
      .parse(
        postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200SpecialHours,
      ),
  );
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200SpecialHoursFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200SpecialHours,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200SpecialHours$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200SpecialHours' from JSON`,
  );
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Reviews$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Reviews,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    author: z.string().optional(),
    rating: z.number().optional(),
    text: z.string().optional(),
    time: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    language: z.string().optional(),
    profilePhotoUrl: z.string().optional(),
    reviewCount: z.number().int().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Reviews$Outbound =
  {
    id?: string | undefined;
    author?: string | undefined;
    rating?: number | undefined;
    text?: string | undefined;
    time?: string | undefined;
    language?: string | undefined;
    profilePhotoUrl?: string | undefined;
    reviewCount?: number | undefined;
    createdAt?: string | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Reviews$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Reviews$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Reviews
  > = z.object({
    id: z.string().optional(),
    author: z.string().optional(),
    rating: z.number().optional(),
    text: z.string().optional(),
    time: z.date().transform(v => v.toISOString()).optional(),
    language: z.string().optional(),
    profilePhotoUrl: z.string().optional(),
    reviewCount: z.number().int().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Reviews$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Reviews$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Reviews$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Reviews$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Reviews$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Reviews$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Reviews$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200ReviewsToJSON(
  postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Reviews:
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Reviews,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Reviews$outboundSchema
      .parse(
        postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Reviews,
      ),
  );
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200ReviewsFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Reviews,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Reviews$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Reviews' from JSON`,
  );
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200RevenueRange$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200RevenueRange
  > = z.nativeEnum(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200RevenueRange,
  );

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200RevenueRange$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200RevenueRange
  > =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200RevenueRange$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200RevenueRange$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200RevenueRange$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200RevenueRange$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200RevenueRange$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200RevenueRange$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200EmployeeBenefits$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200EmployeeBenefits
  > = z.nativeEnum(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200EmployeeBenefits,
  );

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200EmployeeBenefits$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200EmployeeBenefits
  > =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200EmployeeBenefits$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200EmployeeBenefits$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200EmployeeBenefits$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200EmployeeBenefits$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200EmployeeBenefits$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200EmployeeBenefits$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Leads$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Leads,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    name: z.string().optional(),
    website: z.string().optional(),
    phone: z.string().optional(),
    address: z.string().optional(),
    city: z.string().optional(),
    state: z.string().optional(),
    country: z.string().optional(),
    latitude: z.number().optional(),
    longitude: z.number().optional(),
    googleRating: z.number().optional(),
    reviewCount: z.number().int().optional(),
    industry: z.string().optional(),
    employeeCount: z.number().int().optional(),
    estimatedRevenue: z.string().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    placeId: z.string().optional(),
    googleMapsUrl: z.string().optional(),
    businessStatus: z.string().optional(),
    regularHours: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200RegularHours$inboundSchema
      ),
    ).optional(),
    specialHours: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200SpecialHours$inboundSchema
      ),
    ).optional(),
    photoReferences: z.array(z.string()).optional(),
    mainPhotoUrl: z.string().optional(),
    reviews: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Reviews$inboundSchema
      ),
    ).optional(),
    types: z.array(z.string()).optional(),
    amenities: z.array(z.string()).optional(),
    servesVegetarianFood: z.boolean().optional(),
    outdoorSeating: z.boolean().optional(),
    paymentMethods: z.array(z.string()).optional(),
    wheelchairAccessible: z.boolean().optional(),
    parkingAvailable: z.boolean().optional(),
    socialMedia: z.record(z.string()).optional(),
    ratingCategory: z.string().optional(),
    rating: z.number().optional(),
    count: z.number().int().optional(),
    lastUpdated: z.string().datetime({ offset: true }).transform(v =>
      new Date(v)
    ).optional(),
    dataSourceVersion: z.string().optional(),
    scrapingSessionId: z.string().optional(),
    alternatePhones: z.array(z.string()).optional(),
    contactPersonName: z.string().optional(),
    contactPersonTitle: z.string().optional(),
    contactEmail: z.string().optional(),
    foundedYear: z.number().int().optional(),
    businessType: z.string().optional(),
    certifications: z.array(z.string()).optional(),
    licenseNumber: z.string().optional(),
    revenueRange:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200RevenueRange$inboundSchema
        .default("REVENUE_RANGE_UNSPECIFIED"),
    fundingStage: z.string().optional(),
    isPublicCompany: z.boolean().optional(),
    websiteLoadSpeed: z.number().optional(),
    hasSslCertificate: z.boolean().optional(),
    cmsUsed: z.string().optional(),
    ecommercePlatforms: z.array(z.string()).optional(),
    timezone: z.string().optional(),
    neighborhood: z.string().optional(),
    nearbyLandmarks: z.array(z.string()).optional(),
    transportationAccess: z.string().optional(),
    employeeBenefits: z.array(
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200EmployeeBenefits$inboundSchema,
    ).optional(),
    parentCompany: z.string().optional(),
    subsidiaries: z.array(z.string()).optional(),
    isFranchise: z.boolean().optional(),
    seoKeywords: z.array(z.string()).optional(),
    usesGoogleAds: z.boolean().optional(),
    googleMyBusinessCategory: z.string().optional(),
    naicsCode: z.string().optional(),
    sicCode: z.string().optional(),
    unspscCode: z.string().optional(),
    isGreenCertified: z.boolean().optional(),
    energySources: z.array(z.string()).optional(),
    sustainabilityRating: z.string().optional(),
    recentAnnouncements: z.array(z.string()).optional(),
    lastProductLaunch: z.string().datetime({ offset: true }).transform(v =>
      new Date(v)
    ).optional(),
    hasLitigationHistory: z.boolean().optional(),
    exportControlStatus: z.string().optional(),
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Leads$Outbound =
  {
    id?: string | undefined;
    name?: string | undefined;
    website?: string | undefined;
    phone?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    googleRating?: number | undefined;
    reviewCount?: number | undefined;
    industry?: string | undefined;
    employeeCount?: number | undefined;
    estimatedRevenue?: string | undefined;
    createdAt?: string | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
    placeId?: string | undefined;
    googleMapsUrl?: string | undefined;
    businessStatus?: string | undefined;
    regularHours?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200RegularHours$Outbound
      >
      | undefined;
    specialHours?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200SpecialHours$Outbound
      >
      | undefined;
    photoReferences?: Array<string> | undefined;
    mainPhotoUrl?: string | undefined;
    reviews?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Reviews$Outbound
      >
      | undefined;
    types?: Array<string> | undefined;
    amenities?: Array<string> | undefined;
    servesVegetarianFood?: boolean | undefined;
    outdoorSeating?: boolean | undefined;
    paymentMethods?: Array<string> | undefined;
    wheelchairAccessible?: boolean | undefined;
    parkingAvailable?: boolean | undefined;
    socialMedia?: { [k: string]: string } | undefined;
    ratingCategory?: string | undefined;
    rating?: number | undefined;
    count?: number | undefined;
    lastUpdated?: string | undefined;
    dataSourceVersion?: string | undefined;
    scrapingSessionId?: string | undefined;
    alternatePhones?: Array<string> | undefined;
    contactPersonName?: string | undefined;
    contactPersonTitle?: string | undefined;
    contactEmail?: string | undefined;
    foundedYear?: number | undefined;
    businessType?: string | undefined;
    certifications?: Array<string> | undefined;
    licenseNumber?: string | undefined;
    revenueRange: string;
    fundingStage?: string | undefined;
    isPublicCompany?: boolean | undefined;
    websiteLoadSpeed?: number | undefined;
    hasSslCertificate?: boolean | undefined;
    cmsUsed?: string | undefined;
    ecommercePlatforms?: Array<string> | undefined;
    timezone?: string | undefined;
    neighborhood?: string | undefined;
    nearbyLandmarks?: Array<string> | undefined;
    transportationAccess?: string | undefined;
    employeeBenefits?: Array<string> | undefined;
    parentCompany?: string | undefined;
    subsidiaries?: Array<string> | undefined;
    isFranchise?: boolean | undefined;
    seoKeywords?: Array<string> | undefined;
    usesGoogleAds?: boolean | undefined;
    googleMyBusinessCategory?: string | undefined;
    naicsCode?: string | undefined;
    sicCode?: string | undefined;
    unspscCode?: string | undefined;
    isGreenCertified?: boolean | undefined;
    energySources?: Array<string> | undefined;
    sustainabilityRating?: string | undefined;
    recentAnnouncements?: Array<string> | undefined;
    lastProductLaunch?: string | undefined;
    hasLitigationHistory?: boolean | undefined;
    exportControlStatus?: string | undefined;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Leads$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Leads$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Leads
  > = z.object({
    id: z.string().optional(),
    name: z.string().optional(),
    website: z.string().optional(),
    phone: z.string().optional(),
    address: z.string().optional(),
    city: z.string().optional(),
    state: z.string().optional(),
    country: z.string().optional(),
    latitude: z.number().optional(),
    longitude: z.number().optional(),
    googleRating: z.number().optional(),
    reviewCount: z.number().int().optional(),
    industry: z.string().optional(),
    employeeCount: z.number().int().optional(),
    estimatedRevenue: z.string().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
    placeId: z.string().optional(),
    googleMapsUrl: z.string().optional(),
    businessStatus: z.string().optional(),
    regularHours: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200RegularHours$outboundSchema
      ),
    ).optional(),
    specialHours: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200SpecialHours$outboundSchema
      ),
    ).optional(),
    photoReferences: z.array(z.string()).optional(),
    mainPhotoUrl: z.string().optional(),
    reviews: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Reviews$outboundSchema
      ),
    ).optional(),
    types: z.array(z.string()).optional(),
    amenities: z.array(z.string()).optional(),
    servesVegetarianFood: z.boolean().optional(),
    outdoorSeating: z.boolean().optional(),
    paymentMethods: z.array(z.string()).optional(),
    wheelchairAccessible: z.boolean().optional(),
    parkingAvailable: z.boolean().optional(),
    socialMedia: z.record(z.string()).optional(),
    ratingCategory: z.string().optional(),
    rating: z.number().optional(),
    count: z.number().int().optional(),
    lastUpdated: z.date().transform(v => v.toISOString()).optional(),
    dataSourceVersion: z.string().optional(),
    scrapingSessionId: z.string().optional(),
    alternatePhones: z.array(z.string()).optional(),
    contactPersonName: z.string().optional(),
    contactPersonTitle: z.string().optional(),
    contactEmail: z.string().optional(),
    foundedYear: z.number().int().optional(),
    businessType: z.string().optional(),
    certifications: z.array(z.string()).optional(),
    licenseNumber: z.string().optional(),
    revenueRange:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200RevenueRange$outboundSchema
        .default("REVENUE_RANGE_UNSPECIFIED"),
    fundingStage: z.string().optional(),
    isPublicCompany: z.boolean().optional(),
    websiteLoadSpeed: z.number().optional(),
    hasSslCertificate: z.boolean().optional(),
    cmsUsed: z.string().optional(),
    ecommercePlatforms: z.array(z.string()).optional(),
    timezone: z.string().optional(),
    neighborhood: z.string().optional(),
    nearbyLandmarks: z.array(z.string()).optional(),
    transportationAccess: z.string().optional(),
    employeeBenefits: z.array(
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200EmployeeBenefits$outboundSchema,
    ).optional(),
    parentCompany: z.string().optional(),
    subsidiaries: z.array(z.string()).optional(),
    isFranchise: z.boolean().optional(),
    seoKeywords: z.array(z.string()).optional(),
    usesGoogleAds: z.boolean().optional(),
    googleMyBusinessCategory: z.string().optional(),
    naicsCode: z.string().optional(),
    sicCode: z.string().optional(),
    unspscCode: z.string().optional(),
    isGreenCertified: z.boolean().optional(),
    energySources: z.array(z.string()).optional(),
    sustainabilityRating: z.string().optional(),
    recentAnnouncements: z.array(z.string()).optional(),
    lastProductLaunch: z.date().transform(v => v.toISOString()).optional(),
    hasLitigationHistory: z.boolean().optional(),
    exportControlStatus: z.string().optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Leads$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Leads$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Leads$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Leads$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Leads$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Leads$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Leads$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200LeadsToJSON(
  postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Leads:
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Leads,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Leads$outboundSchema
      .parse(
        postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Leads,
      ),
  );
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200LeadsFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Leads,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Leads$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Leads' from JSON`,
  );
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesJobs$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesJobs,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    priority: z.number().int().optional(),
    payloadType: z.string().optional(),
    payload: z.string().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    status:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200ApplicationJSONResponseBodyStatus$inboundSchema
        .default("BACKGROUND_JOB_STATUS_UNSPECIFIED"),
    name: z.string().optional(),
    keywords: z.array(z.string()).optional(),
    lang:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Lang$inboundSchema
        .default("LANGUAGE_UNSPECIFIED"),
    zoom: z.number().int().optional(),
    lat: z.string().optional(),
    lon: z.string().optional(),
    fastMode: z.boolean().optional(),
    radius: z.number().int().optional(),
    depth: z.number().int().optional(),
    email: z.boolean().optional(),
    maxTime: z.number().int().optional(),
    proxies: z.array(z.string()).optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    leads: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Leads$inboundSchema
      ),
    ).optional(),
    url: z.string().optional(),
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesJobs$Outbound =
  {
    id?: string | undefined;
    priority?: number | undefined;
    payloadType?: string | undefined;
    payload?: string | undefined;
    createdAt?: string | undefined;
    status: string;
    name?: string | undefined;
    keywords?: Array<string> | undefined;
    lang: string;
    zoom?: number | undefined;
    lat?: string | undefined;
    lon?: string | undefined;
    fastMode?: boolean | undefined;
    radius?: number | undefined;
    depth?: number | undefined;
    email?: boolean | undefined;
    maxTime?: number | undefined;
    proxies?: Array<string> | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
    leads?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Leads$Outbound
      >
      | undefined;
    url?: string | undefined;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesJobs$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesJobs$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesJobs
  > = z.object({
    id: z.string().optional(),
    priority: z.number().int().optional(),
    payloadType: z.string().optional(),
    payload: z.string().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    status:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200ApplicationJSONResponseBodyStatus$outboundSchema
        .default("BACKGROUND_JOB_STATUS_UNSPECIFIED"),
    name: z.string().optional(),
    keywords: z.array(z.string()).optional(),
    lang:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Lang$outboundSchema
        .default("LANGUAGE_UNSPECIFIED"),
    zoom: z.number().int().optional(),
    lat: z.string().optional(),
    lon: z.string().optional(),
    fastMode: z.boolean().optional(),
    radius: z.number().int().optional(),
    depth: z.number().int().optional(),
    email: z.boolean().optional(),
    maxTime: z.number().int().optional(),
    proxies: z.array(z.string()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
    leads: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Leads$outboundSchema
      ),
    ).optional(),
    url: z.string().optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesJobs$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesJobs$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesJobs$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesJobs$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesJobs$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesJobs$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesJobs$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesJobsToJSON(
  postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesJobs:
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesJobs,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesJobs$outboundSchema
      .parse(postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesJobs),
  );
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesJobsFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesJobs,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesJobs$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesJobs' from JSON`,
  );
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesOutputFormat$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesOutputFormat
  > = z.nativeEnum(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesOutputFormat,
  );

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesOutputFormat$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesOutputFormat
  > =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesOutputFormat$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesOutputFormat$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesOutputFormat$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesOutputFormat$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesOutputFormat$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesOutputFormat$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWorkflows$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWorkflows,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    name: z.string().optional(),
    cronExpression: z.string().optional(),
    nextRunTime: z.string().datetime({ offset: true }).transform(v =>
      new Date(v)
    ).optional(),
    lastRunTime: z.string().datetime({ offset: true }).transform(v =>
      new Date(v)
    ).optional(),
    status:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseStatus$inboundSchema
        .default("WORKFLOW_STATUS_UNSPECIFIED"),
    retryCount: z.number().int().optional(),
    maxRetries: z.number().int().optional(),
    alertEmails: z.string().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    jobs: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesJobs$inboundSchema
      ),
    ).optional(),
    geoFencingRadius: z.number().optional(),
    geoFencingLat: z.number().optional(),
    geoFencingLon: z.number().optional(),
    geoFencingZoomMin: z.number().int().optional(),
    geoFencingZoomMax: z.number().int().optional(),
    includeReviews: z.boolean().optional(),
    includePhotos: z.boolean().optional(),
    includeBusinessHours: z.boolean().optional(),
    maxReviewsPerBusiness: z.number().int().optional(),
    outputFormat:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesOutputFormat$inboundSchema
        .default("OUTPUT_FORMAT_UNSPECIFIED"),
    outputDestination: z.string().optional(),
    dataRetention: z.string().optional(),
    anonymizePii: z.boolean().optional(),
    notificationSlackChannel: z.string().optional(),
    notificationEmailGroup: z.string().optional(),
    notificationNotifyOnStart: z.boolean().optional(),
    notificationNotifyOnComplete: z.boolean().optional(),
    notificationNotifyOnFailure: z.boolean().optional(),
    contentFilterAllowedCountries: z.array(z.string()).optional(),
    contentFilterExcludedTypes: z.array(z.string()).optional(),
    contentFilterMinimumRating: z.number().optional(),
    contentFilterMinimumReviews: z.number().int().optional(),
    qosMaxConcurrentRequests: z.number().int().optional(),
    qosMaxRetries: z.number().int().optional(),
    qosRequestTimeout: z.string().optional(),
    qosEnableJavascript: z.boolean().optional(),
    respectRobotsTxt: z.boolean().optional(),
    acceptTermsOfService: z.boolean().optional(),
    userAgent: z.string().optional(),
    searchTerms: z.array(z.string()).optional(),
    scheduledEntryId: z.string().optional(),
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWorkflows$Outbound =
  {
    id?: string | undefined;
    name?: string | undefined;
    cronExpression?: string | undefined;
    nextRunTime?: string | undefined;
    lastRunTime?: string | undefined;
    status: string;
    retryCount?: number | undefined;
    maxRetries?: number | undefined;
    alertEmails?: string | undefined;
    createdAt?: string | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
    jobs?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesJobs$Outbound
      >
      | undefined;
    geoFencingRadius?: number | undefined;
    geoFencingLat?: number | undefined;
    geoFencingLon?: number | undefined;
    geoFencingZoomMin?: number | undefined;
    geoFencingZoomMax?: number | undefined;
    includeReviews?: boolean | undefined;
    includePhotos?: boolean | undefined;
    includeBusinessHours?: boolean | undefined;
    maxReviewsPerBusiness?: number | undefined;
    outputFormat: string;
    outputDestination?: string | undefined;
    dataRetention?: string | undefined;
    anonymizePii?: boolean | undefined;
    notificationSlackChannel?: string | undefined;
    notificationEmailGroup?: string | undefined;
    notificationNotifyOnStart?: boolean | undefined;
    notificationNotifyOnComplete?: boolean | undefined;
    notificationNotifyOnFailure?: boolean | undefined;
    contentFilterAllowedCountries?: Array<string> | undefined;
    contentFilterExcludedTypes?: Array<string> | undefined;
    contentFilterMinimumRating?: number | undefined;
    contentFilterMinimumReviews?: number | undefined;
    qosMaxConcurrentRequests?: number | undefined;
    qosMaxRetries?: number | undefined;
    qosRequestTimeout?: string | undefined;
    qosEnableJavascript?: boolean | undefined;
    respectRobotsTxt?: boolean | undefined;
    acceptTermsOfService?: boolean | undefined;
    userAgent?: string | undefined;
    searchTerms?: Array<string> | undefined;
    scheduledEntryId?: string | undefined;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWorkflows$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWorkflows$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWorkflows
  > = z.object({
    id: z.string().optional(),
    name: z.string().optional(),
    cronExpression: z.string().optional(),
    nextRunTime: z.date().transform(v => v.toISOString()).optional(),
    lastRunTime: z.date().transform(v => v.toISOString()).optional(),
    status:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseStatus$outboundSchema
        .default("WORKFLOW_STATUS_UNSPECIFIED"),
    retryCount: z.number().int().optional(),
    maxRetries: z.number().int().optional(),
    alertEmails: z.string().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
    jobs: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesJobs$outboundSchema
      ),
    ).optional(),
    geoFencingRadius: z.number().optional(),
    geoFencingLat: z.number().optional(),
    geoFencingLon: z.number().optional(),
    geoFencingZoomMin: z.number().int().optional(),
    geoFencingZoomMax: z.number().int().optional(),
    includeReviews: z.boolean().optional(),
    includePhotos: z.boolean().optional(),
    includeBusinessHours: z.boolean().optional(),
    maxReviewsPerBusiness: z.number().int().optional(),
    outputFormat:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesOutputFormat$outboundSchema
        .default("OUTPUT_FORMAT_UNSPECIFIED"),
    outputDestination: z.string().optional(),
    dataRetention: z.string().optional(),
    anonymizePii: z.boolean().optional(),
    notificationSlackChannel: z.string().optional(),
    notificationEmailGroup: z.string().optional(),
    notificationNotifyOnStart: z.boolean().optional(),
    notificationNotifyOnComplete: z.boolean().optional(),
    notificationNotifyOnFailure: z.boolean().optional(),
    contentFilterAllowedCountries: z.array(z.string()).optional(),
    contentFilterExcludedTypes: z.array(z.string()).optional(),
    contentFilterMinimumRating: z.number().optional(),
    contentFilterMinimumReviews: z.number().int().optional(),
    qosMaxConcurrentRequests: z.number().int().optional(),
    qosMaxRetries: z.number().int().optional(),
    qosRequestTimeout: z.string().optional(),
    qosEnableJavascript: z.boolean().optional(),
    respectRobotsTxt: z.boolean().optional(),
    acceptTermsOfService: z.boolean().optional(),
    userAgent: z.string().optional(),
    searchTerms: z.array(z.string()).optional(),
    scheduledEntryId: z.string().optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWorkflows$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWorkflows$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWorkflows$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWorkflows$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWorkflows$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWorkflows$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWorkflows$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWorkflowsToJSON(
  postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWorkflows:
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWorkflows,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWorkflows$outboundSchema
      .parse(postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWorkflows),
  );
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWorkflowsFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWorkflows,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWorkflows$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWorkflows' from JSON`,
  );
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Status$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Status
  > = z.nativeEnum(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Status,
  );

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Status$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Status
  > =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Status$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Status$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Status$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Status$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Status$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Status$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseLang$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseLang
  > = z.nativeEnum(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseLang,
  );

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseLang$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseLang
  > =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseLang$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseLang$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseLang$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseLang$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseLang$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseLang$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseDay$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseDay
  > = z.nativeEnum(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseDay,
  );

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseDay$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseDay
  > =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseDay$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseDay$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseDay$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseDay$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseDay$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseDay$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseRegularHours$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseRegularHours,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    day:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseDay$inboundSchema
        .default("DAY_OF_WEEK_UNSPECIFIED"),
    openTime: z.string().optional(),
    closeTime: z.string().optional(),
    closed: z.boolean().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseRegularHours$Outbound =
  {
    id?: string | undefined;
    day: string;
    openTime?: string | undefined;
    closeTime?: string | undefined;
    closed?: boolean | undefined;
    createdAt?: string | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseRegularHours$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseRegularHours$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseRegularHours
  > = z.object({
    id: z.string().optional(),
    day:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseDay$outboundSchema
        .default("DAY_OF_WEEK_UNSPECIFIED"),
    openTime: z.string().optional(),
    closeTime: z.string().optional(),
    closed: z.boolean().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseRegularHours$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseRegularHours$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseRegularHours$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseRegularHours$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseRegularHours$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseRegularHours$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseRegularHours$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseRegularHoursToJSON(
  postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseRegularHours:
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseRegularHours,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseRegularHours$outboundSchema
      .parse(
        postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseRegularHours,
      ),
  );
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseRegularHoursFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseRegularHours,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseRegularHours$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseRegularHours' from JSON`,
  );
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Day$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Day
  > = z.nativeEnum(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Day,
  );

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Day$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Day
  > =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Day$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Day$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Day$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Day$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Day$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Day$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseSpecialHours$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseSpecialHours,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    day:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Day$inboundSchema
        .default("DAY_OF_WEEK_UNSPECIFIED"),
    openTime: z.string().optional(),
    closeTime: z.string().optional(),
    closed: z.boolean().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseSpecialHours$Outbound =
  {
    id?: string | undefined;
    day: string;
    openTime?: string | undefined;
    closeTime?: string | undefined;
    closed?: boolean | undefined;
    createdAt?: string | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseSpecialHours$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseSpecialHours$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseSpecialHours
  > = z.object({
    id: z.string().optional(),
    day:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Day$outboundSchema
        .default("DAY_OF_WEEK_UNSPECIFIED"),
    openTime: z.string().optional(),
    closeTime: z.string().optional(),
    closed: z.boolean().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseSpecialHours$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseSpecialHours$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseSpecialHours$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseSpecialHours$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseSpecialHours$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseSpecialHours$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseSpecialHours$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseSpecialHoursToJSON(
  postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseSpecialHours:
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseSpecialHours,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseSpecialHours$outboundSchema
      .parse(
        postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseSpecialHours,
      ),
  );
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseSpecialHoursFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseSpecialHours,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseSpecialHours$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseSpecialHours' from JSON`,
  );
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseReviews$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseReviews,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    author: z.string().optional(),
    rating: z.number().optional(),
    text: z.string().optional(),
    time: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    language: z.string().optional(),
    profilePhotoUrl: z.string().optional(),
    reviewCount: z.number().int().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseReviews$Outbound =
  {
    id?: string | undefined;
    author?: string | undefined;
    rating?: number | undefined;
    text?: string | undefined;
    time?: string | undefined;
    language?: string | undefined;
    profilePhotoUrl?: string | undefined;
    reviewCount?: number | undefined;
    createdAt?: string | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseReviews$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseReviews$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseReviews
  > = z.object({
    id: z.string().optional(),
    author: z.string().optional(),
    rating: z.number().optional(),
    text: z.string().optional(),
    time: z.date().transform(v => v.toISOString()).optional(),
    language: z.string().optional(),
    profilePhotoUrl: z.string().optional(),
    reviewCount: z.number().int().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseReviews$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseReviews$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseReviews$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseReviews$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseReviews$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseReviews$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseReviews$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseReviewsToJSON(
  postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseReviews:
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseReviews,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseReviews$outboundSchema
      .parse(
        postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseReviews,
      ),
  );
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseReviewsFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseReviews,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseReviews$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseReviews' from JSON`,
  );
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseRevenueRange$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseRevenueRange
  > = z.nativeEnum(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseRevenueRange,
  );

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseRevenueRange$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseRevenueRange
  > =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseRevenueRange$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseRevenueRange$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseRevenueRange$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseRevenueRange$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseRevenueRange$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseRevenueRange$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseEmployeeBenefits$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseEmployeeBenefits
  > = z.nativeEnum(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseEmployeeBenefits,
  );

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseEmployeeBenefits$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseEmployeeBenefits
  > =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseEmployeeBenefits$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseEmployeeBenefits$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseEmployeeBenefits$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseEmployeeBenefits$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseEmployeeBenefits$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseEmployeeBenefits$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseLeads$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseLeads,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    name: z.string().optional(),
    website: z.string().optional(),
    phone: z.string().optional(),
    address: z.string().optional(),
    city: z.string().optional(),
    state: z.string().optional(),
    country: z.string().optional(),
    latitude: z.number().optional(),
    longitude: z.number().optional(),
    googleRating: z.number().optional(),
    reviewCount: z.number().int().optional(),
    industry: z.string().optional(),
    employeeCount: z.number().int().optional(),
    estimatedRevenue: z.string().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    placeId: z.string().optional(),
    googleMapsUrl: z.string().optional(),
    businessStatus: z.string().optional(),
    regularHours: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseRegularHours$inboundSchema
      ),
    ).optional(),
    specialHours: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseSpecialHours$inboundSchema
      ),
    ).optional(),
    photoReferences: z.array(z.string()).optional(),
    mainPhotoUrl: z.string().optional(),
    reviews: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseReviews$inboundSchema
      ),
    ).optional(),
    types: z.array(z.string()).optional(),
    amenities: z.array(z.string()).optional(),
    servesVegetarianFood: z.boolean().optional(),
    outdoorSeating: z.boolean().optional(),
    paymentMethods: z.array(z.string()).optional(),
    wheelchairAccessible: z.boolean().optional(),
    parkingAvailable: z.boolean().optional(),
    socialMedia: z.record(z.string()).optional(),
    ratingCategory: z.string().optional(),
    rating: z.number().optional(),
    count: z.number().int().optional(),
    lastUpdated: z.string().datetime({ offset: true }).transform(v =>
      new Date(v)
    ).optional(),
    dataSourceVersion: z.string().optional(),
    scrapingSessionId: z.string().optional(),
    alternatePhones: z.array(z.string()).optional(),
    contactPersonName: z.string().optional(),
    contactPersonTitle: z.string().optional(),
    contactEmail: z.string().optional(),
    foundedYear: z.number().int().optional(),
    businessType: z.string().optional(),
    certifications: z.array(z.string()).optional(),
    licenseNumber: z.string().optional(),
    revenueRange:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseRevenueRange$inboundSchema
        .default("REVENUE_RANGE_UNSPECIFIED"),
    fundingStage: z.string().optional(),
    isPublicCompany: z.boolean().optional(),
    websiteLoadSpeed: z.number().optional(),
    hasSslCertificate: z.boolean().optional(),
    cmsUsed: z.string().optional(),
    ecommercePlatforms: z.array(z.string()).optional(),
    timezone: z.string().optional(),
    neighborhood: z.string().optional(),
    nearbyLandmarks: z.array(z.string()).optional(),
    transportationAccess: z.string().optional(),
    employeeBenefits: z.array(
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseEmployeeBenefits$inboundSchema,
    ).optional(),
    parentCompany: z.string().optional(),
    subsidiaries: z.array(z.string()).optional(),
    isFranchise: z.boolean().optional(),
    seoKeywords: z.array(z.string()).optional(),
    usesGoogleAds: z.boolean().optional(),
    googleMyBusinessCategory: z.string().optional(),
    naicsCode: z.string().optional(),
    sicCode: z.string().optional(),
    unspscCode: z.string().optional(),
    isGreenCertified: z.boolean().optional(),
    energySources: z.array(z.string()).optional(),
    sustainabilityRating: z.string().optional(),
    recentAnnouncements: z.array(z.string()).optional(),
    lastProductLaunch: z.string().datetime({ offset: true }).transform(v =>
      new Date(v)
    ).optional(),
    hasLitigationHistory: z.boolean().optional(),
    exportControlStatus: z.string().optional(),
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseLeads$Outbound =
  {
    id?: string | undefined;
    name?: string | undefined;
    website?: string | undefined;
    phone?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    googleRating?: number | undefined;
    reviewCount?: number | undefined;
    industry?: string | undefined;
    employeeCount?: number | undefined;
    estimatedRevenue?: string | undefined;
    createdAt?: string | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
    placeId?: string | undefined;
    googleMapsUrl?: string | undefined;
    businessStatus?: string | undefined;
    regularHours?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseRegularHours$Outbound
      >
      | undefined;
    specialHours?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseSpecialHours$Outbound
      >
      | undefined;
    photoReferences?: Array<string> | undefined;
    mainPhotoUrl?: string | undefined;
    reviews?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseReviews$Outbound
      >
      | undefined;
    types?: Array<string> | undefined;
    amenities?: Array<string> | undefined;
    servesVegetarianFood?: boolean | undefined;
    outdoorSeating?: boolean | undefined;
    paymentMethods?: Array<string> | undefined;
    wheelchairAccessible?: boolean | undefined;
    parkingAvailable?: boolean | undefined;
    socialMedia?: { [k: string]: string } | undefined;
    ratingCategory?: string | undefined;
    rating?: number | undefined;
    count?: number | undefined;
    lastUpdated?: string | undefined;
    dataSourceVersion?: string | undefined;
    scrapingSessionId?: string | undefined;
    alternatePhones?: Array<string> | undefined;
    contactPersonName?: string | undefined;
    contactPersonTitle?: string | undefined;
    contactEmail?: string | undefined;
    foundedYear?: number | undefined;
    businessType?: string | undefined;
    certifications?: Array<string> | undefined;
    licenseNumber?: string | undefined;
    revenueRange: string;
    fundingStage?: string | undefined;
    isPublicCompany?: boolean | undefined;
    websiteLoadSpeed?: number | undefined;
    hasSslCertificate?: boolean | undefined;
    cmsUsed?: string | undefined;
    ecommercePlatforms?: Array<string> | undefined;
    timezone?: string | undefined;
    neighborhood?: string | undefined;
    nearbyLandmarks?: Array<string> | undefined;
    transportationAccess?: string | undefined;
    employeeBenefits?: Array<string> | undefined;
    parentCompany?: string | undefined;
    subsidiaries?: Array<string> | undefined;
    isFranchise?: boolean | undefined;
    seoKeywords?: Array<string> | undefined;
    usesGoogleAds?: boolean | undefined;
    googleMyBusinessCategory?: string | undefined;
    naicsCode?: string | undefined;
    sicCode?: string | undefined;
    unspscCode?: string | undefined;
    isGreenCertified?: boolean | undefined;
    energySources?: Array<string> | undefined;
    sustainabilityRating?: string | undefined;
    recentAnnouncements?: Array<string> | undefined;
    lastProductLaunch?: string | undefined;
    hasLitigationHistory?: boolean | undefined;
    exportControlStatus?: string | undefined;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseLeads$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseLeads$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseLeads
  > = z.object({
    id: z.string().optional(),
    name: z.string().optional(),
    website: z.string().optional(),
    phone: z.string().optional(),
    address: z.string().optional(),
    city: z.string().optional(),
    state: z.string().optional(),
    country: z.string().optional(),
    latitude: z.number().optional(),
    longitude: z.number().optional(),
    googleRating: z.number().optional(),
    reviewCount: z.number().int().optional(),
    industry: z.string().optional(),
    employeeCount: z.number().int().optional(),
    estimatedRevenue: z.string().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
    placeId: z.string().optional(),
    googleMapsUrl: z.string().optional(),
    businessStatus: z.string().optional(),
    regularHours: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseRegularHours$outboundSchema
      ),
    ).optional(),
    specialHours: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseSpecialHours$outboundSchema
      ),
    ).optional(),
    photoReferences: z.array(z.string()).optional(),
    mainPhotoUrl: z.string().optional(),
    reviews: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseReviews$outboundSchema
      ),
    ).optional(),
    types: z.array(z.string()).optional(),
    amenities: z.array(z.string()).optional(),
    servesVegetarianFood: z.boolean().optional(),
    outdoorSeating: z.boolean().optional(),
    paymentMethods: z.array(z.string()).optional(),
    wheelchairAccessible: z.boolean().optional(),
    parkingAvailable: z.boolean().optional(),
    socialMedia: z.record(z.string()).optional(),
    ratingCategory: z.string().optional(),
    rating: z.number().optional(),
    count: z.number().int().optional(),
    lastUpdated: z.date().transform(v => v.toISOString()).optional(),
    dataSourceVersion: z.string().optional(),
    scrapingSessionId: z.string().optional(),
    alternatePhones: z.array(z.string()).optional(),
    contactPersonName: z.string().optional(),
    contactPersonTitle: z.string().optional(),
    contactEmail: z.string().optional(),
    foundedYear: z.number().int().optional(),
    businessType: z.string().optional(),
    certifications: z.array(z.string()).optional(),
    licenseNumber: z.string().optional(),
    revenueRange:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseRevenueRange$outboundSchema
        .default("REVENUE_RANGE_UNSPECIFIED"),
    fundingStage: z.string().optional(),
    isPublicCompany: z.boolean().optional(),
    websiteLoadSpeed: z.number().optional(),
    hasSslCertificate: z.boolean().optional(),
    cmsUsed: z.string().optional(),
    ecommercePlatforms: z.array(z.string()).optional(),
    timezone: z.string().optional(),
    neighborhood: z.string().optional(),
    nearbyLandmarks: z.array(z.string()).optional(),
    transportationAccess: z.string().optional(),
    employeeBenefits: z.array(
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseEmployeeBenefits$outboundSchema,
    ).optional(),
    parentCompany: z.string().optional(),
    subsidiaries: z.array(z.string()).optional(),
    isFranchise: z.boolean().optional(),
    seoKeywords: z.array(z.string()).optional(),
    usesGoogleAds: z.boolean().optional(),
    googleMyBusinessCategory: z.string().optional(),
    naicsCode: z.string().optional(),
    sicCode: z.string().optional(),
    unspscCode: z.string().optional(),
    isGreenCertified: z.boolean().optional(),
    energySources: z.array(z.string()).optional(),
    sustainabilityRating: z.string().optional(),
    recentAnnouncements: z.array(z.string()).optional(),
    lastProductLaunch: z.date().transform(v => v.toISOString()).optional(),
    hasLitigationHistory: z.boolean().optional(),
    exportControlStatus: z.string().optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseLeads$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseLeads$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseLeads$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseLeads$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseLeads$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseLeads$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseLeads$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseLeadsToJSON(
  postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseLeads:
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseLeads,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseLeads$outboundSchema
      .parse(
        postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseLeads,
      ),
  );
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseLeadsFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseLeads,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseLeads$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseLeads' from JSON`,
  );
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesScrapingJobs$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesScrapingJobs,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    priority: z.number().int().optional(),
    payloadType: z.string().optional(),
    payload: z.string().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    status:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Status$inboundSchema
        .default("BACKGROUND_JOB_STATUS_UNSPECIFIED"),
    name: z.string().optional(),
    keywords: z.array(z.string()).optional(),
    lang:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseLang$inboundSchema
        .default("LANGUAGE_UNSPECIFIED"),
    zoom: z.number().int().optional(),
    lat: z.string().optional(),
    lon: z.string().optional(),
    fastMode: z.boolean().optional(),
    radius: z.number().int().optional(),
    depth: z.number().int().optional(),
    email: z.boolean().optional(),
    maxTime: z.number().int().optional(),
    proxies: z.array(z.string()).optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    leads: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseLeads$inboundSchema
      ),
    ).optional(),
    url: z.string().optional(),
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesScrapingJobs$Outbound =
  {
    id?: string | undefined;
    priority?: number | undefined;
    payloadType?: string | undefined;
    payload?: string | undefined;
    createdAt?: string | undefined;
    status: string;
    name?: string | undefined;
    keywords?: Array<string> | undefined;
    lang: string;
    zoom?: number | undefined;
    lat?: string | undefined;
    lon?: string | undefined;
    fastMode?: boolean | undefined;
    radius?: number | undefined;
    depth?: number | undefined;
    email?: boolean | undefined;
    maxTime?: number | undefined;
    proxies?: Array<string> | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
    leads?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseLeads$Outbound
      >
      | undefined;
    url?: string | undefined;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesScrapingJobs$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesScrapingJobs$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesScrapingJobs
  > = z.object({
    id: z.string().optional(),
    priority: z.number().int().optional(),
    payloadType: z.string().optional(),
    payload: z.string().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    status:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200Status$outboundSchema
        .default("BACKGROUND_JOB_STATUS_UNSPECIFIED"),
    name: z.string().optional(),
    keywords: z.array(z.string()).optional(),
    lang:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseLang$outboundSchema
        .default("LANGUAGE_UNSPECIFIED"),
    zoom: z.number().int().optional(),
    lat: z.string().optional(),
    lon: z.string().optional(),
    fastMode: z.boolean().optional(),
    radius: z.number().int().optional(),
    depth: z.number().int().optional(),
    email: z.boolean().optional(),
    maxTime: z.number().int().optional(),
    proxies: z.array(z.string()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
    leads: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponseLeads$outboundSchema
      ),
    ).optional(),
    url: z.string().optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesScrapingJobs$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesScrapingJobs$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesScrapingJobs$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesScrapingJobs$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesScrapingJobs$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesScrapingJobs$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesScrapingJobs$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesScrapingJobsToJSON(
  postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesScrapingJobs:
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesScrapingJobs,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesScrapingJobs$outboundSchema
      .parse(
        postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesScrapingJobs,
      ),
  );
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesScrapingJobsFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesScrapingJobs,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesScrapingJobs$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesScrapingJobs' from JSON`,
  );
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200ApplicationJSONStatus$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200ApplicationJSONStatus
  > = z.nativeEnum(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200ApplicationJSONStatus,
  );

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200ApplicationJSONStatus$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200ApplicationJSONStatus
  > =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200ApplicationJSONStatus$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200ApplicationJSONStatus$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200ApplicationJSONStatus$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200ApplicationJSONStatus$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200ApplicationJSONStatus$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200ApplicationJSONStatus$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesApiKeys$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesApiKeys,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    name: z.string().optional(),
    keyHash: z.string().optional(),
    keyPrefix: z.string().optional(),
    scopes: z.array(z.string()).optional(),
    allowedIps: z.array(z.string()).optional(),
    allowedDomains: z.array(z.string()).optional(),
    allowedEnvironments: z.array(z.string()).optional(),
    isTestKey: z.boolean().optional(),
    requestsPerSecond: z.number().int().optional(),
    requestsPerDay: z.number().int().optional(),
    concurrentRequests: z.number().int().optional(),
    monthlyRequestQuota: z.string().optional(),
    costPerRequest: z.number().optional(),
    billingTier: z.string().optional(),
    totalRequests: z.string().optional(),
    totalErrors: z.string().optional(),
    lastUsedAt: z.string().datetime({ offset: true }).transform(v =>
      new Date(v)
    ).optional(),
    averageResponseTime: z.number().optional(),
    endpointUsageJson: z.string().optional(),
    errorRatesJson: z.string().optional(),
    recentErrors: z.string().optional(),
    successfulRequestsCount: z.number().int().optional(),
    successRate: z.number().optional(),
    status:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200ApplicationJSONStatus$inboundSchema
        .default("STATUS_UNSPECIFIED"),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    expiresAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    lastRotatedAt: z.string().datetime({ offset: true }).transform(v =>
      new Date(v)
    ).optional(),
    lastSecurityReviewAt: z.string().datetime({ offset: true }).transform(v =>
      new Date(v)
    ).optional(),
    requiresClientSecret: z.boolean().optional(),
    clientSecretHash: z.string().optional(),
    enforceHttps: z.boolean().optional(),
    enforceSigning: z.boolean().optional(),
    allowedSignatureAlgorithms: z.array(z.string()).optional(),
    enforceMutualTls: z.boolean().optional(),
    clientCertificateHash: z.string().optional(),
    requireRequestSigning: z.boolean().optional(),
    description: z.string().optional(),
    metadataJson: z.string().optional(),
    tags: z.array(z.string()).optional(),
    apiVersion: z.string().optional(),
    supportedFeatures: z.array(z.string()).optional(),
    documentationUrl: z.string().optional(),
    supportContact: z.string().optional(),
    logAllRequests: z.boolean().optional(),
    lastRotationReason: z.string().optional(),
    lastRotationDate: z.string().datetime({ offset: true }).transform(v =>
      new Date(v)
    ).optional(),
    rotationFrequencyDays: z.number().int().optional(),
    complianceStandards: z.array(z.string()).optional(),
    requiresAuditLogging: z.boolean().optional(),
    dataResidency: z.string().optional(),
    approvedIntegrations: z.array(z.string()).optional(),
    alertEmails: z.array(z.string()).optional(),
    webhookUrl: z.string().optional(),
    alertOnQuotaThreshold: z.boolean().optional(),
    quotaAlertThreshold: z.number().optional(),
    alertOnErrorSpike: z.boolean().optional(),
    errorAlertThreshold: z.number().optional(),
    monitoringIntegrations: z.array(z.string()).optional(),
    encrypted: z.boolean().optional(),
    dataClassification: z.string().optional(),
    maxUses: z.number().int().optional(),
    rateLimit: z.number().int().optional(),
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesApiKeys$Outbound =
  {
    id?: string | undefined;
    name?: string | undefined;
    keyHash?: string | undefined;
    keyPrefix?: string | undefined;
    scopes?: Array<string> | undefined;
    allowedIps?: Array<string> | undefined;
    allowedDomains?: Array<string> | undefined;
    allowedEnvironments?: Array<string> | undefined;
    isTestKey?: boolean | undefined;
    requestsPerSecond?: number | undefined;
    requestsPerDay?: number | undefined;
    concurrentRequests?: number | undefined;
    monthlyRequestQuota?: string | undefined;
    costPerRequest?: number | undefined;
    billingTier?: string | undefined;
    totalRequests?: string | undefined;
    totalErrors?: string | undefined;
    lastUsedAt?: string | undefined;
    averageResponseTime?: number | undefined;
    endpointUsageJson?: string | undefined;
    errorRatesJson?: string | undefined;
    recentErrors?: string | undefined;
    successfulRequestsCount?: number | undefined;
    successRate?: number | undefined;
    status: string;
    createdAt?: string | undefined;
    updatedAt?: string | undefined;
    expiresAt?: string | undefined;
    deletedAt?: string | undefined;
    lastRotatedAt?: string | undefined;
    lastSecurityReviewAt?: string | undefined;
    requiresClientSecret?: boolean | undefined;
    clientSecretHash?: string | undefined;
    enforceHttps?: boolean | undefined;
    enforceSigning?: boolean | undefined;
    allowedSignatureAlgorithms?: Array<string> | undefined;
    enforceMutualTls?: boolean | undefined;
    clientCertificateHash?: string | undefined;
    requireRequestSigning?: boolean | undefined;
    description?: string | undefined;
    metadataJson?: string | undefined;
    tags?: Array<string> | undefined;
    apiVersion?: string | undefined;
    supportedFeatures?: Array<string> | undefined;
    documentationUrl?: string | undefined;
    supportContact?: string | undefined;
    logAllRequests?: boolean | undefined;
    lastRotationReason?: string | undefined;
    lastRotationDate?: string | undefined;
    rotationFrequencyDays?: number | undefined;
    complianceStandards?: Array<string> | undefined;
    requiresAuditLogging?: boolean | undefined;
    dataResidency?: string | undefined;
    approvedIntegrations?: Array<string> | undefined;
    alertEmails?: Array<string> | undefined;
    webhookUrl?: string | undefined;
    alertOnQuotaThreshold?: boolean | undefined;
    quotaAlertThreshold?: number | undefined;
    alertOnErrorSpike?: boolean | undefined;
    errorAlertThreshold?: number | undefined;
    monitoringIntegrations?: Array<string> | undefined;
    encrypted?: boolean | undefined;
    dataClassification?: string | undefined;
    maxUses?: number | undefined;
    rateLimit?: number | undefined;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesApiKeys$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesApiKeys$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesApiKeys
  > = z.object({
    id: z.string().optional(),
    name: z.string().optional(),
    keyHash: z.string().optional(),
    keyPrefix: z.string().optional(),
    scopes: z.array(z.string()).optional(),
    allowedIps: z.array(z.string()).optional(),
    allowedDomains: z.array(z.string()).optional(),
    allowedEnvironments: z.array(z.string()).optional(),
    isTestKey: z.boolean().optional(),
    requestsPerSecond: z.number().int().optional(),
    requestsPerDay: z.number().int().optional(),
    concurrentRequests: z.number().int().optional(),
    monthlyRequestQuota: z.string().optional(),
    costPerRequest: z.number().optional(),
    billingTier: z.string().optional(),
    totalRequests: z.string().optional(),
    totalErrors: z.string().optional(),
    lastUsedAt: z.date().transform(v => v.toISOString()).optional(),
    averageResponseTime: z.number().optional(),
    endpointUsageJson: z.string().optional(),
    errorRatesJson: z.string().optional(),
    recentErrors: z.string().optional(),
    successfulRequestsCount: z.number().int().optional(),
    successRate: z.number().optional(),
    status:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesResponse200ApplicationJSONStatus$outboundSchema
        .default("STATUS_UNSPECIFIED"),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    expiresAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
    lastRotatedAt: z.date().transform(v => v.toISOString()).optional(),
    lastSecurityReviewAt: z.date().transform(v => v.toISOString()).optional(),
    requiresClientSecret: z.boolean().optional(),
    clientSecretHash: z.string().optional(),
    enforceHttps: z.boolean().optional(),
    enforceSigning: z.boolean().optional(),
    allowedSignatureAlgorithms: z.array(z.string()).optional(),
    enforceMutualTls: z.boolean().optional(),
    clientCertificateHash: z.string().optional(),
    requireRequestSigning: z.boolean().optional(),
    description: z.string().optional(),
    metadataJson: z.string().optional(),
    tags: z.array(z.string()).optional(),
    apiVersion: z.string().optional(),
    supportedFeatures: z.array(z.string()).optional(),
    documentationUrl: z.string().optional(),
    supportContact: z.string().optional(),
    logAllRequests: z.boolean().optional(),
    lastRotationReason: z.string().optional(),
    lastRotationDate: z.date().transform(v => v.toISOString()).optional(),
    rotationFrequencyDays: z.number().int().optional(),
    complianceStandards: z.array(z.string()).optional(),
    requiresAuditLogging: z.boolean().optional(),
    dataResidency: z.string().optional(),
    approvedIntegrations: z.array(z.string()).optional(),
    alertEmails: z.array(z.string()).optional(),
    webhookUrl: z.string().optional(),
    alertOnQuotaThreshold: z.boolean().optional(),
    quotaAlertThreshold: z.number().optional(),
    alertOnErrorSpike: z.boolean().optional(),
    errorAlertThreshold: z.number().optional(),
    monitoringIntegrations: z.array(z.string()).optional(),
    encrypted: z.boolean().optional(),
    dataClassification: z.string().optional(),
    maxUses: z.number().int().optional(),
    rateLimit: z.number().int().optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesApiKeys$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesApiKeys$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesApiKeys$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesApiKeys$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesApiKeys$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesApiKeys$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesApiKeys$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesApiKeysToJSON(
  postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesApiKeys:
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesApiKeys,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesApiKeys$outboundSchema
      .parse(postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesApiKeys),
  );
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesApiKeysFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesApiKeys,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesApiKeys$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesApiKeys' from JSON`,
  );
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesTriggerEvents$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesTriggerEvents
  > = z.nativeEnum(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesTriggerEvents,
  );

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesTriggerEvents$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesTriggerEvents
  > =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesTriggerEvents$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesTriggerEvents$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesTriggerEvents$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesTriggerEvents$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesTriggerEvents$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesTriggerEvents$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesIncludedFields$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesIncludedFields
  > = z.nativeEnum(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesIncludedFields,
  );

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesIncludedFields$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesIncludedFields
  > =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesIncludedFields$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesIncludedFields$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesIncludedFields$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesIncludedFields$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesIncludedFields$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesIncludedFields$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesPayloadFormat$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesPayloadFormat
  > = z.nativeEnum(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesPayloadFormat,
  );

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesPayloadFormat$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesPayloadFormat
  > =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesPayloadFormat$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesPayloadFormat$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesPayloadFormat$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesPayloadFormat$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesPayloadFormat$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesPayloadFormat$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesMetadata$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesMetadata,
    z.ZodTypeDef,
    unknown
  > = z.object({});

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesMetadata$Outbound =
  {};

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesMetadata$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesMetadata$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesMetadata
  > = z.object({});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesMetadata$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesMetadata$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesMetadata$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesMetadata$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesMetadata$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesMetadata$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesMetadata$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesMetadataToJSON(
  postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesMetadata:
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesMetadata,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesMetadata$outboundSchema
      .parse(postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesMetadata),
  );
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesMetadataFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesMetadata,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesMetadata$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesMetadata' from JSON`,
  );
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWebhooks$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWebhooks,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    url: z.string().optional(),
    authType: z.string().optional(),
    authToken: z.string().optional(),
    customHeaders: z.record(z.string()).optional(),
    maxRetries: z.number().int().optional(),
    retryInterval: z.string().optional(),
    triggerEvents: z.array(
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesTriggerEvents$inboundSchema,
    ).optional(),
    includedFields: z.array(
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesIncludedFields$inboundSchema,
    ).optional(),
    includeFullResults: z.boolean().optional(),
    payloadFormat:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesPayloadFormat$inboundSchema
        .default("PAYLOAD_FORMAT_UNSPECIFIED"),
    verifySsl: z.boolean().optional(),
    signingSecret: z.string().optional(),
    rateLimit: z.number().int().optional(),
    rateLimitInterval: z.string().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    lastTriggeredAt: z.string().datetime({ offset: true }).transform(v =>
      new Date(v)
    ).optional(),
    successfulCalls: z.number().int().optional(),
    failedCalls: z.number().int().optional(),
    metadata: z.lazy(() =>
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesMetadata$inboundSchema
    ).optional(),
    webhookName: z.string().optional(),
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWebhooks$Outbound =
  {
    id?: string | undefined;
    url?: string | undefined;
    authType?: string | undefined;
    authToken?: string | undefined;
    customHeaders?: { [k: string]: string } | undefined;
    maxRetries?: number | undefined;
    retryInterval?: string | undefined;
    triggerEvents?: Array<string> | undefined;
    includedFields?: Array<string> | undefined;
    includeFullResults?: boolean | undefined;
    payloadFormat: string;
    verifySsl?: boolean | undefined;
    signingSecret?: string | undefined;
    rateLimit?: number | undefined;
    rateLimitInterval?: string | undefined;
    createdAt?: string | undefined;
    updatedAt?: string | undefined;
    lastTriggeredAt?: string | undefined;
    successfulCalls?: number | undefined;
    failedCalls?: number | undefined;
    metadata?:
      | PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesMetadata$Outbound
      | undefined;
    webhookName?: string | undefined;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWebhooks$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWebhooks$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWebhooks
  > = z.object({
    id: z.string().optional(),
    url: z.string().optional(),
    authType: z.string().optional(),
    authToken: z.string().optional(),
    customHeaders: z.record(z.string()).optional(),
    maxRetries: z.number().int().optional(),
    retryInterval: z.string().optional(),
    triggerEvents: z.array(
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesTriggerEvents$outboundSchema,
    ).optional(),
    includedFields: z.array(
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesIncludedFields$outboundSchema,
    ).optional(),
    includeFullResults: z.boolean().optional(),
    payloadFormat:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesPayloadFormat$outboundSchema
        .default("PAYLOAD_FORMAT_UNSPECIFIED"),
    verifySsl: z.boolean().optional(),
    signingSecret: z.string().optional(),
    rateLimit: z.number().int().optional(),
    rateLimitInterval: z.string().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    lastTriggeredAt: z.date().transform(v => v.toISOString()).optional(),
    successfulCalls: z.number().int().optional(),
    failedCalls: z.number().int().optional(),
    metadata: z.lazy(() =>
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesMetadata$outboundSchema
    ).optional(),
    webhookName: z.string().optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWebhooks$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWebhooks$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWebhooks$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWebhooks$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWebhooks$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWebhooks$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWebhooks$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWebhooksToJSON(
  postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWebhooks:
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWebhooks,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWebhooks$outboundSchema
      .parse(postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWebhooks),
  );
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWebhooksFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWebhooks,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWebhooks$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWebhooks' from JSON`,
  );
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWorkspaceType$inboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWorkspaceType
  > = z.nativeEnum(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWorkspaceType,
  );

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWorkspaceType$outboundSchema:
  z.ZodNativeEnum<
    typeof PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWorkspaceType
  > =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWorkspaceType$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWorkspaceType$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWorkspaceType$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWorkspaceType$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWorkspaceType$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWorkspaceType$outboundSchema;
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWorkspace$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWorkspace,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string().optional(),
    name: z.string().optional(),
    industry: z.string().optional(),
    domain: z.string().optional(),
    gdprCompliant: z.boolean().optional(),
    hipaaCompliant: z.boolean().optional(),
    soc2Compliant: z.boolean().optional(),
    storageQuota: z.string().optional(),
    usedStorage: z.string().optional(),
    createdAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    updatedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    deletedAt: z.string().datetime({ offset: true }).transform(v => new Date(v))
      .optional(),
    workflows: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWorkflows$inboundSchema
      ),
    ).optional(),
    jobsRunThisMonth: z.number().int().optional(),
    workspaceJobLimit: z.number().int().optional(),
    dailyJobQuota: z.number().int().optional(),
    activeScrapers: z.number().int().optional(),
    totalLeadsCollected: z.number().int().optional(),
    lastJobRun: z.string().datetime({ offset: true }).transform(v =>
      new Date(v)
    ).optional(),
    scrapingJobs: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesScrapingJobs$inboundSchema
      ),
    ).optional(),
    apiKeys: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesApiKeys$inboundSchema
      ),
    ).optional(),
    webhooks: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWebhooks$inboundSchema
      ),
    ).optional(),
    workspaceType:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWorkspaceType$inboundSchema
        .default("WORKSPACE_TYPE_UNSPECIFIED"),
    description: z.string().optional(),
    metadata: z.record(z.string()).optional(),
    tags: z.array(z.string()).optional(),
    maxTeamMembers: z.number().int().optional(),
    currentTeamMembers: z.number().int().optional(),
    allowGuestAccess: z.boolean().optional(),
    allowedEmailDomains: z.array(z.string()).optional(),
    exportFormats: z.array(z.string()).optional(),
    exportSchedule: z.string().optional(),
    exportDestinations: z.array(z.string()).optional(),
    exportDestinationConfig: z.record(z.string()).optional(),
    compressExports: z.boolean().optional(),
    compressionFormat: z.string().optional(),
    salesforceEnabled: z.boolean().optional(),
    salesforceConfig: z.string().optional(),
    hubspotEnabled: z.boolean().optional(),
    hubspotConfig: z.string().optional(),
    zapierEnabled: z.boolean().optional(),
    zapierWebhook: z.string().optional(),
    activeIntegrations: z.array(z.string()).optional(),
    integrationSettings: z.record(z.string()).optional(),
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWorkspace$Outbound =
  {
    id?: string | undefined;
    name?: string | undefined;
    industry?: string | undefined;
    domain?: string | undefined;
    gdprCompliant?: boolean | undefined;
    hipaaCompliant?: boolean | undefined;
    soc2Compliant?: boolean | undefined;
    storageQuota?: string | undefined;
    usedStorage?: string | undefined;
    createdAt?: string | undefined;
    updatedAt?: string | undefined;
    deletedAt?: string | undefined;
    workflows?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWorkflows$Outbound
      >
      | undefined;
    jobsRunThisMonth?: number | undefined;
    workspaceJobLimit?: number | undefined;
    dailyJobQuota?: number | undefined;
    activeScrapers?: number | undefined;
    totalLeadsCollected?: number | undefined;
    lastJobRun?: string | undefined;
    scrapingJobs?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesScrapingJobs$Outbound
      >
      | undefined;
    apiKeys?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesApiKeys$Outbound
      >
      | undefined;
    webhooks?:
      | Array<
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWebhooks$Outbound
      >
      | undefined;
    workspaceType: string;
    description?: string | undefined;
    metadata?: { [k: string]: string } | undefined;
    tags?: Array<string> | undefined;
    maxTeamMembers?: number | undefined;
    currentTeamMembers?: number | undefined;
    allowGuestAccess?: boolean | undefined;
    allowedEmailDomains?: Array<string> | undefined;
    exportFormats?: Array<string> | undefined;
    exportSchedule?: string | undefined;
    exportDestinations?: Array<string> | undefined;
    exportDestinationConfig?: { [k: string]: string } | undefined;
    compressExports?: boolean | undefined;
    compressionFormat?: string | undefined;
    salesforceEnabled?: boolean | undefined;
    salesforceConfig?: string | undefined;
    hubspotEnabled?: boolean | undefined;
    hubspotConfig?: string | undefined;
    zapierEnabled?: boolean | undefined;
    zapierWebhook?: string | undefined;
    activeIntegrations?: Array<string> | undefined;
    integrationSettings?: { [k: string]: string } | undefined;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWorkspace$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWorkspace$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWorkspace
  > = z.object({
    id: z.string().optional(),
    name: z.string().optional(),
    industry: z.string().optional(),
    domain: z.string().optional(),
    gdprCompliant: z.boolean().optional(),
    hipaaCompliant: z.boolean().optional(),
    soc2Compliant: z.boolean().optional(),
    storageQuota: z.string().optional(),
    usedStorage: z.string().optional(),
    createdAt: z.date().transform(v => v.toISOString()).optional(),
    updatedAt: z.date().transform(v => v.toISOString()).optional(),
    deletedAt: z.date().transform(v => v.toISOString()).optional(),
    workflows: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWorkflows$outboundSchema
      ),
    ).optional(),
    jobsRunThisMonth: z.number().int().optional(),
    workspaceJobLimit: z.number().int().optional(),
    dailyJobQuota: z.number().int().optional(),
    activeScrapers: z.number().int().optional(),
    totalLeadsCollected: z.number().int().optional(),
    lastJobRun: z.date().transform(v => v.toISOString()).optional(),
    scrapingJobs: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesScrapingJobs$outboundSchema
      ),
    ).optional(),
    apiKeys: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesApiKeys$outboundSchema
      ),
    ).optional(),
    webhooks: z.array(
      z.lazy(() =>
        PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWebhooks$outboundSchema
      ),
    ).optional(),
    workspaceType:
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWorkspaceType$outboundSchema
        .default("WORKSPACE_TYPE_UNSPECIFIED"),
    description: z.string().optional(),
    metadata: z.record(z.string()).optional(),
    tags: z.array(z.string()).optional(),
    maxTeamMembers: z.number().int().optional(),
    currentTeamMembers: z.number().int().optional(),
    allowGuestAccess: z.boolean().optional(),
    allowedEmailDomains: z.array(z.string()).optional(),
    exportFormats: z.array(z.string()).optional(),
    exportSchedule: z.string().optional(),
    exportDestinations: z.array(z.string()).optional(),
    exportDestinationConfig: z.record(z.string()).optional(),
    compressExports: z.boolean().optional(),
    compressionFormat: z.string().optional(),
    salesforceEnabled: z.boolean().optional(),
    salesforceConfig: z.string().optional(),
    hubspotEnabled: z.boolean().optional(),
    hubspotConfig: z.string().optional(),
    zapierEnabled: z.boolean().optional(),
    zapierWebhook: z.string().optional(),
    activeIntegrations: z.array(z.string()).optional(),
    integrationSettings: z.record(z.string()).optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWorkspace$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWorkspace$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWorkspace$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWorkspace$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWorkspace$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWorkspace$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWorkspace$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWorkspaceToJSON(
  postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWorkspace:
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWorkspace,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWorkspace$outboundSchema
      .parse(postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWorkspace),
  );
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWorkspaceFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWorkspace,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWorkspace$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWorkspace' from JSON`,
  );
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesResponseBody$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    workspace: z.lazy(() =>
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWorkspace$inboundSchema
    ).optional(),
  });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1WorkspacesResponseBody$Outbound =
  {
    workspace?:
      | PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWorkspace$Outbound
      | undefined;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1WorkspacesResponseBody$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1WorkspacesResponseBody$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1WorkspacesResponseBody
  > = z.object({
    workspace: z.lazy(() =>
      PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspacesWorkspace$outboundSchema
    ).optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1WorkspacesResponseBody$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesResponseBody$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesResponseBody$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesResponseBody$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1WorkspacesResponseBody$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1WorkspacesResponseBody$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1WorkspacesResponseBody$Outbound;
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesResponseBodyToJSON(
  postApiLeadScraperMicroserviceApiV1WorkspacesResponseBody:
    PostApiLeadScraperMicroserviceApiV1WorkspacesResponseBody,
): string {
  return JSON.stringify(
    PostApiLeadScraperMicroserviceApiV1WorkspacesResponseBody$outboundSchema
      .parse(postApiLeadScraperMicroserviceApiV1WorkspacesResponseBody),
  );
}

export function postApiLeadScraperMicroserviceApiV1WorkspacesResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<
  PostApiLeadScraperMicroserviceApiV1WorkspacesResponseBody,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      PostApiLeadScraperMicroserviceApiV1WorkspacesResponseBody$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'PostApiLeadScraperMicroserviceApiV1WorkspacesResponseBody' from JSON`,
  );
}
